// This file is auto-generated by @hey-api/openapi-ts

export type AIAvatar = {
    readonly id: number;
    name: string;
    variant: string;
    raw_preview_url: (string) | null;
    preview_url: (string) | null;
    movement_preview_url: string;
    thumbnail_url: string;
    image_url: string;
    driver_performance: string;
};

export type AIAvatarVoicePreset = {
    readonly id: number;
    name: string;
    avatar_id: number;
    thumbnail_url: string;
    movement_preview_url: string;
    voice_slug: string;
    audio_url: string;
    background_preview_url: (string) | null;
    background_render_url: (string) | null;
};

/**
 * Serializer for AI media aspect ratio configuration where internal_value is a string.
 */
export type AIMediaAspectRatio = {
    internal_value: string;
    api_value: string;
};

/**
 * Serializer for AI video duration objects where internal_value is an integer.
 */
export type AIVideoDuration = {
    internal_value: number;
    api_value: string;
};

export type AIVoice = {
    slug: string;
    display_name: string;
    preview_url: (string) | null;
    accent: ((AccentEnum) | null);
    tone: ((AIVoiceToneEnum) | null);
    style: ((AIVoiceStyleEnum) | null);
    is_paid: boolean;
    is_private: boolean;
    is_deprecated: boolean;
    readonly attributes: (GroupedAIVoiceFilters);
};

export type AIVoiceFilter = {
    readonly id: number;
    type: AIVoiceFilterTypeEnum;
    value: string;
    display: string;
};

/**
 * * `accent` - Accent
 * * `tone` - Tone
 * * `style` - Style
 * * `language` - Language
 * * `age` - Age
 * * `gender` - Gender
 * * `quality` - Quality
 */
export enum AIVoiceFilterTypeEnum {
    ACCENT = 'accent',
    TONE = 'tone',
    STYLE = 'style',
    LANGUAGE = 'language',
    AGE = 'age',
    GENDER = 'gender',
    QUALITY = 'quality'
}

/**
 * * `Conversational` - Conversational
 * * `Dramatic` - Dramatic
 * * `Narrative` - Narrative
 * * `Presentational` - Presentational
 */
export enum AIVoiceStyleEnum {
    CONVERSATIONAL = 'Conversational',
    DRAMATIC = 'Dramatic',
    NARRATIVE = 'Narrative',
    PRESENTATIONAL = 'Presentational'
}

/**
 * * `Assertive` - Assertive
 * * `Balanced` - Balanced
 * * `Calm` - Calm
 * * `Casual` - Casual
 * * `Confident` - Confident
 * * `Deep` - Deep
 * * `Enthusiastic` - Enthusiastic
 * * `Warm` - Warm
 * * `Whisper` - Whisper
 */
export enum AIVoiceToneEnum {
    ASSERTIVE = 'Assertive',
    BALANCED = 'Balanced',
    CALM = 'Calm',
    CASUAL = 'Casual',
    CONFIDENT = 'Confident',
    DEEP = 'Deep',
    ENTHUSIASTIC = 'Enthusiastic',
    WARM = 'Warm',
    WHISPER = 'Whisper'
}

/**
 * * `American` - American
 * * `Australian` - Australian
 * * `British` - British
 * * `Irish` - Irish
 * * `Italian` - Italian
 * * `Arabic` - Arabic
 * * `Bulgarian` - Bulgarian
 * * `Chinese` - Chinese
 * * `Croatian` - Croatian
 * * `Czech` - Czech
 * * `Danish` - Danish
 * * `Dutch` - Dutch
 * * `Filipino` - Filipino
 * * `Finnish` - Finnish
 * * `French` - French
 * * `German` - German
 * * `Greek` - Greek
 * * `Hindi` - Hindi
 * * `Hungarian` - Hungarian
 * * `Indian` - Indian
 * * `Indonesian` - Indonesian
 * * `Japanese` - Japanese
 * * `Korean` - Korean
 * * `Malay` - Malay
 * * `Norwegian` - Norwegian
 * * `Polish` - Polish
 * * `Portuguese (Portugal)` - Portuguese Portugal
 * * `Portuguese (Brazil)` - Portuguese Brazil
 * * `Romanian` - Romanian
 * * `Russian` - Russian
 * * `Slovak` - Slovak
 * * `Spanish (Spain)` - Spanish Spain
 * * `Spanish (South America)` - Spanish Southamerica
 * * `Swedish` - Swedish
 * * `Tamil` - Tamil
 * * `Turkish` - Turkish
 * * `Ukrainian` - Ukrainian
 * * `Vietnamese` - Vietnamese
 */
export enum AccentEnum {
    AMERICAN = 'American',
    AUSTRALIAN = 'Australian',
    BRITISH = 'British',
    IRISH = 'Irish',
    ITALIAN = 'Italian',
    ARABIC = 'Arabic',
    BULGARIAN = 'Bulgarian',
    CHINESE = 'Chinese',
    CROATIAN = 'Croatian',
    CZECH = 'Czech',
    DANISH = 'Danish',
    DUTCH = 'Dutch',
    FILIPINO = 'Filipino',
    FINNISH = 'Finnish',
    FRENCH = 'French',
    GERMAN = 'German',
    GREEK = 'Greek',
    HINDI = 'Hindi',
    HUNGARIAN = 'Hungarian',
    INDIAN = 'Indian',
    INDONESIAN = 'Indonesian',
    JAPANESE = 'Japanese',
    KOREAN = 'Korean',
    MALAY = 'Malay',
    NORWEGIAN = 'Norwegian',
    POLISH = 'Polish',
    PORTUGUESE__PORTUGAL_ = 'Portuguese (Portugal)',
    PORTUGUESE__BRAZIL_ = 'Portuguese (Brazil)',
    ROMANIAN = 'Romanian',
    RUSSIAN = 'Russian',
    SLOVAK = 'Slovak',
    SPANISH__SPAIN_ = 'Spanish (Spain)',
    SPANISH__SOUTH_AMERICA_ = 'Spanish (South America)',
    SWEDISH = 'Swedish',
    TAMIL = 'Tamil',
    TURKISH = 'Turkish',
    UKRAINIAN = 'Ukrainian',
    VIETNAMESE = 'Vietnamese'
}

/**
 * * `soft_archive` - Soft Archive
 * * `hard_archive` - Hard Archive
 * * `unarchive` - Unarchive
 */
export enum ActionEnum {
    SOFT_ARCHIVE = 'soft_archive',
    HARD_ARCHIVE = 'hard_archive',
    UNARCHIVE = 'unarchive'
}

export type AddExtraDataToUserRequest = {
    category: string;
    value: string;
};

export type AdminMediaFolder = {
    readonly id: number;
    readonly name: string;
};

export type AdminWorkspace = {
    readonly id: number;
    readonly name: string;
};

export type Announcement = {
    readonly id: number;
    title: string;
    /**
     * Supports HTML: &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;br&gt;, &lt;a href&gt;, &lt;ul&gt;, &lt;ol&gt;, &lt;li&gt;
     */
    body: string;
    /**
     * Optional image or GIF URL
     */
    image_url: string;
    /**
     * YouTube URL (watch or embed format)
     */
    video_url: string;
    /**
     * Call-to-action button text
     */
    cta_text: string;
    /**
     * Call-to-action URL
     */
    cta_url: string;
    readonly category: ((AnnouncementCategory) | null);
    /**
     * If checked, shows as a popup in addition to appearing in the sidebar
     */
    show_as_popup: boolean;
    /**
     * Determines if this announcement should show as a popup in the current context.
     * Considers: show_as_popup flag, URL targeting, and user targeting.
     */
    readonly show_popup_now: boolean;
    publish_date: string;
    readonly is_viewed: boolean;
    readonly is_preview: boolean;
    readonly is_expired: boolean;
};

export type AnnouncementCategory = {
    readonly id: number;
    name: string;
    /**
     * Hex color code for the category badge
     */
    color: string;
};

export type AnnouncementClickRequest = {
    announcement_id: number;
};

export type AnnouncementViewRequest = {
    announcement_id: number;
};

export type ArchiveMultipleVideosRequest = {
    video_ids: Array<(number)>;
    action: ActionEnum;
};

export type ArchiveMultipleVideosResponse = {
    videoIds: Array<(number)>;
    status: string;
};

export type Article = {
    readonly id: number;
    readonly url: string;
    readonly language: (string) | null;
    readonly original_content: unknown;
    readonly sentences: Array<(string)>;
};

export type ArticleUpdateUrlRequest = {
    url: string;
};

/**
 * * `landscape` - Landscape
 * * `square` - Square
 * * `vertical` - Vertical
 * * `fourfive` - Fourfive
 */
export enum AspectRatio {
    LANDSCAPE = 'landscape',
    SQUARE = 'square',
    VERTICAL = 'vertical',
    FOURFIVE = 'fourfive'
}

export type AssetAudioEnhancementResponse = AssetContainerModel | AsyncOperationResponse | AysncOperationEmptyResponse;

/**
 * This is a base class that shouldn't really be instantiated ever.
 * It allows any serializer that inherits from it to call:
 *
 * .. code-block:: python
 *
 * >>> serializer.create_obj(serializer.validated_data)
 *
 * And return an object of the type indicated by python_class inside the Meta
 * class of the serializer.
 */
export type AssetContainerModel = {
    type: AssetContainerTypes;
    audio: ((AudioAssetModel) | null);
    background: ((SlideBackgroundModel) | null);
    font: ((FontAsset) | null);
    icon: ((IconAssetModel) | null);
    document: ((DocumentAssetModel) | null);
    folder_id: (number) | null;
    article_id: (number) | null;
    document_id: (number) | null;
};

/**
 * This is a base class that shouldn't really be instantiated ever.
 * It allows any serializer that inherits from it to call:
 *
 * .. code-block:: python
 *
 * >>> serializer.create_obj(serializer.validated_data)
 *
 * And return an object of the type indicated by python_class inside the Meta
 * class of the serializer.
 */
export type AssetContainerModelRequest = {
    type: AssetContainerTypes;
    audio?: ((AudioAssetModelRequest) | null);
    background?: ((SlideBackgroundModelRequest) | null);
    font?: ((FontAssetRequest) | null);
    icon?: ((IconAssetModelRequest) | null);
    document?: ((DocumentAssetModelRequest) | null);
    folder_id?: (number) | null;
    article_id?: (number) | null;
    document_id?: (number) | null;
};

/**
 * * `audio` - Audio
 * * `background` - Background
 * * `font` - Font
 * * `icon` - Icon
 * * `document` - Document
 */
export enum AssetContainerTypes {
    AUDIO = 'audio',
    BACKGROUND = 'background',
    FONT = 'font',
    ICON = 'icon',
    DOCUMENT = 'document'
}

export type AssetGenerationData = {
    uuid: string;
    prompt: string;
    properties: ((ImageGenerationProperties) | null);
    model_name: ModelNameEnum;
    asset: ((SlideBackgroundModel) | null);
};

export type AssetGenerationError = {
    message: string;
};

export type AssetGenerationListResponse = {
    results: Array<AssetGenerationResponse>;
    show_upsell: boolean;
};

export type AssetGenerationResponse = {
    result: AssetGenerationData;
    error: ((AssetGenerationError) | null);
};

export type AssetMetadataRequest = {
    source: SourceEnum;
    license: LicenseEnum;
    uuid?: string;
    source_id?: string;
    language?: (string) | null;
    attribution?: string;
    tags?: Array<(string)> | null;
    start_millis?: (number) | null;
    end_millis?: (number) | null;
    script?: string;
    ai_voice?: string;
    article_id?: number;
    document_id?: number;
    description?: string;
    generation_uuid?: string;
    script_with_word_timings?: Array<{
        [key: string]: unknown;
    }> | null;
    can_background_transcode?: boolean;
    from_clip_creator?: boolean;
};

/**
 * This is a base class that shouldn't really be instantiated ever.
 * It allows any serializer that inherits from it to call:
 *
 * .. code-block:: python
 *
 * >>> serializer.create_obj(serializer.validated_data)
 *
 * And return an object of the type indicated by python_class inside the Meta
 * class of the serializer.
 */
export type AssetSave = {
    async_operation_uuid: string;
    uploaded_asset: AssetContainerModel;
};

/**
 * This is a base class that shouldn't really be instantiated ever.
 * It allows any serializer that inherits from it to call:
 *
 * .. code-block:: python
 *
 * >>> serializer.create_obj(serializer.validated_data)
 *
 * And return an object of the type indicated by python_class inside the Meta
 * class of the serializer.
 */
export type AssetSaveRequest = {
    async_operation_uuid?: string;
    uploaded_asset: AssetContainerModelRequest;
};

export type AssetSourceItemRequest = {
    asset_type: AssetTypes;
    asset_uuid: string;
};

export type AssetTranscript = {
    hasVoiceover: (boolean) | null;
    transcriptWords: Array<TranscriptWord>;
    language: LanguageEnum;
};

/**
 * * `image` - Image
 * * `video` - Video
 * * `audio` - Audio
 * * `font` - Font
 * * `icon` - Icon
 * * `document` - Document
 */
export enum AssetTypes {
    IMAGE = 'image',
    VIDEO = 'video',
    AUDIO = 'audio',
    FONT = 'font',
    ICON = 'icon',
    DOCUMENT = 'document'
}

export type AssetValidationRequest = {
    metadata: AssetMetadataRequest;
    bucket: string;
    file_name: string;
    user_file_name: string;
    add_to_user_library?: boolean;
    only_images?: boolean;
    async_operation_uuid: string;
};

export type AsyncOperation = {
    readonly async_operation_uuid: string;
    readonly async_operation_name: (AsyncOperationNameEnum);
    readonly status: (AsyncOperationStatus);
    readonly is_mandatory: boolean;
    readonly is_sub_step: boolean;
    readonly input: unknown;
    readonly output: unknown;
    readonly error_messages: unknown;
    user: number;
    readonly asset_type: ((AsyncOperationAssetTypeEnum) | null);
    readonly asset_uuid: (string) | null;
    readonly created_at: string;
    readonly transient_urls: Array<TransientUrl>;
    readonly video_id: (number) | null;
    readonly processed_time: string;
};

/**
 * * `ImageAsset` - Image
 * * `VideoAsset` - Video
 * * `AudioAsset` - Audio
 * * `FontAsset` - Font
 * * `IconAsset` - Icon
 */
export enum AsyncOperationAssetTypeEnum {
    IMAGE_ASSET = 'ImageAsset',
    VIDEO_ASSET = 'VideoAsset',
    AUDIO_ASSET = 'AudioAsset',
    FONT_ASSET = 'FontAsset',
    ICON_ASSET = 'IconAsset'
}

export type AsyncOperationMessage = {
    uid: string;
    error: (string) | null;
    type: AsyncOperationMessageTypeEnum;
    result: {
        [key: string]: unknown;
    } | null;
};

/**
 * * `ASYNC_OPERATION_RESULT` - ASYNC_OPERATION_RESULT
 */
export enum AsyncOperationMessageTypeEnum {
    ASYNC_OPERATION_RESULT = 'ASYNC_OPERATION_RESULT'
}

/**
 * * `uplod_urls` - Upload Urls
 * * `validate_upload` - Validate Upload
 * * `initialize_upload` - Initialize Upload
 * * `prepare_file` - Prepare File
 * * `async_enhance_audio` - Async Enhance Audio
 * * `extract_audio` - Extract Audio
 * * `generate_transcript` - Generate Transcript
 * * `process_upload` - Process Upload
 * * `get_serialized_asset_data` - Get Serialized Asset Data
 * * `generate_edited_voiceover` - Generate Edited Voiceover
 * * `convert_text_to_voiceover` - Convert Text To Voiceover
 * * `convert_text_to_voiceover_asset` - Convert Text To Voiceover Asset
 * * `poll_transcode` - Poll Transcode
 */
export enum AsyncOperationNameEnum {
    UPLOD_URLS = 'uplod_urls',
    VALIDATE_UPLOAD = 'validate_upload',
    INITIALIZE_UPLOAD = 'initialize_upload',
    PREPARE_FILE = 'prepare_file',
    ASYNC_ENHANCE_AUDIO = 'async_enhance_audio',
    EXTRACT_AUDIO = 'extract_audio',
    GENERATE_TRANSCRIPT = 'generate_transcript',
    PROCESS_UPLOAD = 'process_upload',
    GET_SERIALIZED_ASSET_DATA = 'get_serialized_asset_data',
    GENERATE_EDITED_VOICEOVER = 'generate_edited_voiceover',
    CONVERT_TEXT_TO_VOICEOVER = 'convert_text_to_voiceover',
    CONVERT_TEXT_TO_VOICEOVER_ASSET = 'convert_text_to_voiceover_asset',
    POLL_TRANSCODE = 'poll_transcode'
}

export type AsyncOperationResponse = {
    async_operation_uuid: string;
};

export type AsyncOperationResult = {
    status: AsyncOperationStatus;
    message: (string) | null;
    expected_error: (boolean) | null;
    /**
     * This field can be any type.
     */
    result: (string | number | boolean | {
    [key: string]: unknown;
} | unknown[] | null);
};

/**
 * * `success` - Success
 * * `failed` - Failed
 * * `processing` - Processing
 */
export enum AsyncOperationStatus {
    SUCCESS = 'success',
    FAILED = 'failed',
    PROCESSING = 'processing'
}

export type AudioAssetModel = {
    readonly id: number;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: (string) | null;
    license: LicenseEnum;
    attribution: (string) | null;
    mp3_url: string;
    orig_mp3_url: string;
    duration: number;
    description: (string) | null;
    tags: Array<(string)>;
    title: (string) | null;
    name: string;
    quality: number;
    waveform: [
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number
    ];
    /**
     * This method is used for getting all the ids of users who starred the music asset or have
     * recently used the music asset in their rendered video. The 'history_index_user_ids' is only passed
     * to context after a search under favorite and most recently used music from web.api_views.AudioAssets.get().
     */
    readonly history_index_user_ids: Array<(number)> | null;
    has_voiceover: (boolean) | null;
    captions: ((Transcription) | null);
    ai_voice: (string) | null;
    readonly ai_voice_speed: (number) | null;
};

export type AudioAssetModelRequest = {
    uuid?: (string) | null;
    source: SourceEnum;
    source_id?: (string) | null;
    license: LicenseEnum;
    attribution?: (string) | null;
    mp3_url: string;
    orig_mp3_url?: string;
    duration: number;
    description?: (string) | null;
    tags: Array<(string)>;
    title?: (string) | null;
    name: string;
    quality?: number;
    waveform: [
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number
    ];
    has_voiceover?: (boolean) | null;
    captions?: ((TranscriptionRequest) | null);
    ai_voice?: (string) | null;
};

export type AudioAssetResponse = {
    count: number;
    search_source: AudioSearchSourceEnum;
    next: (string) | null;
    previous: (string) | null;
    results: Array<AssetContainerModel>;
    corrected_query: string;
    corrected_query_indices: [
        number,
        number
    ];
    did_you_mean_query: string;
    did_you_mean_highlighted_query: string;
    error: string;
};

export type AudioAssetSourceData = {
    mp3_url: string;
    duration: number;
    source: (SourceEnum);
    readonly source_id: string;
    license: LicenseEnum;
    attribution: string;
    description: (string) | null;
    tags: Array<(string)>;
    title: (string) | null;
    name: string;
    quality: number;
    readonly uuid: string;
    readonly id: number;
    ai_voice: (string) | null;
    ai_voice_speed: (number) | null;
};

export type AudioAssetSourceDataRequest = {
    mp3_url: string;
    duration?: number;
    source: (SourceEnum);
    license: LicenseEnum;
    attribution?: string;
    description?: (string) | null;
    tags: Array<(string)>;
    title?: (string) | null;
    name: string;
    quality?: number;
    ai_voice?: (string) | null;
    ai_voice_speed?: (number) | null;
};

/**
 * * `cc` - cc
 * * `uploads` - uploads
 * * `recent` - recent
 * * `favorites` - favorites
 * * `voiceover_uploads` - voiceover_uploads
 */
export enum AudioSearchSourceEnum {
    CC = 'cc',
    UPLOADS = 'uploads',
    RECENT = 'recent',
    FAVORITES = 'favorites',
    VOICEOVER_UPLOADS = 'voiceover_uploads'
}

export type AuditLog = {
    event_name: string;
    actor: AuditLogActor;
    event_description: (string) | null;
    readonly timestamp: string;
};

export type AuditLogActor = {
    readonly id: number;
    email: string;
    readonly full_name: string;
    readonly photo_url: string;
};

export type AuthToken = {
    readonly token: string;
};

export type AuthTokenRequest = {
    username: string;
    password: string;
};

export type AysncOperationEmptyResponse = {
    is_async_operation_uuid_empty: boolean;
};

/**
 * * `none` - None
 * * `auto_pan_to_fit_max_content` - Auto Pan To Fit Max Content
 * * `pan_up` - Pan Up
 * * `pan_down` - Pan Down
 * * `pan_left` - Pan Left
 * * `pan_right` - Pan Right
 * * `zoom_in` - Zoom In
 * * `zoom_out` - Zoom Out
 */
export enum BackgroundAnimationRecommendationOptions {
    NONE = 'none',
    AUTO_PAN_TO_FIT_MAX_CONTENT = 'auto_pan_to_fit_max_content',
    PAN_UP = 'pan_up',
    PAN_DOWN = 'pan_down',
    PAN_LEFT = 'pan_left',
    PAN_RIGHT = 'pan_right',
    ZOOM_IN = 'zoom_in',
    ZOOM_OUT = 'zoom_out'
}

export type BackgroundRemovalResponse = {
    asset: ((SlideBackgroundModel) | null);
    created: boolean;
};

export type BackupCodes = {
    backup_keys: Array<(string)>;
};

export type BatchTextToVoiceoverRequest = {
    blocks: Array<TextToVoiceoverRequest>;
};

export type BatchTextToVoiceoverResponse = {
    blocks: Array<TextToVoiceoverResponse>;
};

export type BetaFeedbackRequest = {
    rating: number;
    feedback?: string;
    feature_type: string;
    user_messages?: Array<(string)>;
    conversation_id?: string;
    creation_tool_name?: string;
};

/**
 * * `monthly` - Monthly
 * * `annual` - Annual
 */
export enum BillingCycleEnum {
    MONTHLY = 'monthly',
    ANNUAL = 'annual'
}

export type BillingPreferences = {
    billing_name: (string) | null;
    billing_address: (string) | null;
};

export type BillingPreferencesRequest = {
    billing_name?: (string) | null;
    billing_address?: (string) | null;
};

export type Blueprint = {
    readonly id: number;
    name: string;
    readonly supported_templates: Array<(string)>;
    readonly supported_templates_data: {
        [key: string]: {
            video_id: number;
            poster_url: string;
        };
    };
    default_template_id: string;
    default_aspect_ratio: AspectRatio;
    readonly default_target_duration_seconds: number;
    readonly min_scene_count: (number) | null;
    narrative_thread: NarrativeThreadEnum;
    video_ids: Array<(number)>;
    readonly poster_url: string;
    description: (string) | null;
    draft_video_ids: Array<(number)>;
    readonly ai_voice: (string) | null;
    ai_avatar: (number) | null;
    /**
     * Global caption scene design ID (e.g., global_template:fancy_caption) for this blueprint
     */
    caption_scene_design_id: (string) | null;
    is_temporary: boolean;
    /**
     * Returns whether the blueprint is public or not.
     * A blueprint is considered public if it has no user or workspace associated with it.
     */
    readonly is_public: boolean;
    /**
     * For public blueprints, allows for filtering to specific product use cases
     *
     * * `sketch` - Sketch
     * * `spinoff` - Spinoff
     * * `clip_creator` - Clip Creator
     */
    use_case: ((UseCaseEnum) | null);
    readonly display_group: (BlueprintDisplayGroup);
    readonly display_order: number;
    /**
     * Custom instructions for the blueprint that guide AI video generation
     */
    custom_instructions: (string) | null;
};

export type BlueprintAutoPickRequest = {
    input_content: string;
    template: string;
    narrative_thread: NarrativeThreadEnum;
};

export type BlueprintAutoPickResponse = {
    public_blueprint_id: (number) | null;
    custom_blueprint_id: (number) | null;
    recent_video_id: (number) | null;
};

export type BlueprintDisplayGroup = {
    readonly id: number;
    display_name: string;
    order: number;
    description: string;
    is_active: boolean;
};

export type BlueprintDisplayGroupRequest = {
    display_name: string;
    order: number;
    description?: string;
    is_active?: boolean;
};

export type BlueprintOption = {
    id: number;
    name: string;
    description: string;
    narrative_thread: NarrativeThreadEnum;
};

export type BlueprintRequest = {
    name: string;
    user?: number;
    workspace?: number;
    default_template_id: string;
    default_aspect_ratio?: AspectRatio;
    narrative_thread: NarrativeThreadEnum;
    video_ids?: Array<(number)>;
    description?: (string) | null;
    draft_video_ids?: Array<(number)>;
    ai_avatar?: (number) | null;
    /**
     * Global caption scene design ID (e.g., global_template:fancy_caption) for this blueprint
     */
    caption_scene_design_id?: (string) | null;
    is_temporary?: boolean;
    /**
     * For public blueprints, allows for filtering to specific product use cases
     *
     * * `sketch` - Sketch
     * * `spinoff` - Spinoff
     * * `clip_creator` - Clip Creator
     */
    use_case?: ((UseCaseEnum) | null);
    /**
     * Custom instructions for the blueprint that guide AI video generation
     */
    custom_instructions?: (string) | null;
};

export type BoundingBox = {
    x: number;
    y: number;
    width: number;
    height: number;
};

export type BrandKit = {
    readonly id: number;
    readonly workspace: number;
    name: string;
    readonly team: number;
    colors: Array<BrandKitColor>;
    fonts: Array<(number)>;
    watermark: (string) | null;
    readonly watermarkDetails: Array<ImageAssetModel>;
};

export type BrandKitColor = {
    r: number;
    g: number;
    b: number;
    a: number;
    category: CategoryEnum;
};

export type BrandKitColorRequest = {
    r: number;
    g: number;
    b: number;
    a: number;
    category: CategoryEnum;
};

export type BrandKitRequest = {
    name: string;
    colors: Array<BrandKitColorRequest>;
    fonts: Array<(number)>;
    watermark: (string) | null;
};

/**
 * * `normal` - Normal
 * * `dim_to_read_text` - Dim To Read Text
 */
export enum BrightnessRecommendationOptions {
    NORMAL = 'normal',
    DIM_TO_READ_TEXT = 'dim_to_read_text'
}

export type BulkAssetSourceRequest = {
    asset_items: Array<AssetSourceItemRequest>;
};

export type BulkPublishRequest = {
    video_ids: Array<(number)>;
};

export type BulkPublishResponse = {
    results: Array<BulkPublishResponseItem>;
};

export type BulkPublishResponseItem = {
    video_id: number;
    status: StatusEnum;
    error_code: ((ErrorEnum) | null);
    details: ((PublishErrorDetails) | null);
};

export type BulkTextSegmentationRequest = {
    batches: Array<TextSegmentationRequest>;
};

export type BulkTextSegmentationResponse = {
    batches: Array<TextSegmentationResponse>;
};

export type BulkUpdateProjectMemberItemRequest = {
    project_id: number;
    workspace_id: number;
    added_members?: Array<(number)>;
    removed_members?: Array<(number)>;
};

export type BulkUpdateProjectMembersRequest = {
    projects: Array<BulkUpdateProjectMemberItemRequest>;
};

export type BulkUploadResult = {
    upload_url: string;
    download_url: string;
    file_name: string;
    async_operation_uuid: string;
    status: BulkUploadResultStatusEnum;
    message: string;
};

/**
 * * `success` - success
 * * `error` - error
 */
export enum BulkUploadResultStatusEnum {
    SUCCESS = 'success',
    ERROR = 'error'
}

export type BulkUploadUrlsRequest = {
    type: UploadUrlsRequestTypeEnum;
    file_names: Array<(string)>;
};

export type BulkUploadUrlsResponse = {
    uploads: Array<BulkUploadResult>;
};

export type CancellationFeedback = {
    reason: (string) | null;
    other_reason: (string) | null;
    feedback: (string) | null;
};

export type CancellationFeedbackRequest = {
    reason?: (string) | null;
    other_reason?: (string) | null;
    feedback?: (string) | null;
};

export type Capabilities = {
    render_720p: boolean;
    render_1080p: boolean;
    no_branding: boolean;
    getty_media: boolean;
    getty_unlimited_media: boolean;
    shutterstock_media: boolean;
    shutterstock_unlimited_media: boolean;
    custom_watermark: boolean;
    custom_font: boolean;
    upload_stickers: boolean;
    theming_settings: boolean;
    max_brand_kits: number;
    max_team_size: number;
    purchased_seats: number;
    purchased_seat_ceiling: number;
    max_workspaces: number;
    can_invite_team_members: boolean;
    can_see_all_templates: boolean;
    team_brand_kits_amount: number;
    script_generation_duration_control: boolean;
    has_audit_log: boolean;
    screen_recording: boolean;
};

/**
 * * `brand` - Brand
 * * `neutral` - Neutral
 */
export enum CategoryEnum {
    BRAND = 'brand',
    NEUTRAL = 'neutral'
}

export type ChangePasswordRequest = {
    new_password: string;
    new_password_repeat: string;
    old_password: string;
};

export type ChangePasswordResponse = {
    error: boolean;
    new_password_error: string;
    new_password_repeat_error: string;
    reset_password_error: string;
    old_password_error: string;
};

export type Charge = {
    readonly id: string;
    readonly date: number;
    readonly receipt_url: string;
    readonly invoice_url: string;
};

export type ClickLogsClick = {
    readonly user: number;
    time: string;
    video_id: number;
    log_name: string;
    action: string;
    result: ClickLogsResult;
    language: string;
};

export type ClickLogsClickRequest = {
    time?: string;
    video_id: number;
    log_name?: string;
    action?: string;
    result: ClickLogsResultRequest;
    language?: string;
};

export type ClickLogsQuery = {
    readonly user: number;
    time: string;
    video_id: number;
    log_name: string;
    readonly action: string;
    query: string;
    processed_query: string;
    corrected_query: string;
    page: number;
    results: Array<ClickLogsResult>;
    results_shape: [
        number,
        number
    ];
    language: string;
    filter: {
        [key: string]: unknown;
    };
};

export type ClickLogsQueryRequest = {
    time?: string;
    video_id: number;
    log_name?: string;
    query: string;
    processed_query: string;
    corrected_query: string;
    page: number;
    results: Array<ClickLogsResultRequest>;
    results_shape?: [
        number,
        number
    ];
    language: string;
    filter?: {
        [key: string]: unknown;
    };
};

export type ClickLogsRecommendation = {
    readonly user: number;
    time: string;
    video_id: number;
    log_name: string;
    readonly action: string;
    query: Array<(string)>;
    page: number;
    strategy: string;
    results: Array<ClickLogsResult>;
    results_shape: [
        number,
        number
    ];
    language: string;
    filter: {
        [key: string]: unknown;
    };
};

export type ClickLogsRecommendationRequest = {
    time?: string;
    video_id: number;
    log_name?: string;
    query: Array<(string)>;
    page: number;
    strategy: string;
    results: Array<ClickLogsResultRequest>;
    results_shape?: [
        number,
        number
    ];
    language: string;
    filter?: {
        [key: string]: unknown;
    };
};

export type ClickLogsResult = {
    type: AssetTypes;
    uuid: string;
};

export type ClickLogsResultRequest = {
    type: AssetTypes;
    uuid: string;
};

export type ClipPlan = {
    title: string;
    content_prompt: string;
    estimated_duration: (number) | null;
};

export type ClipPlanRequest = {
    title: string;
    content_prompt: string;
    estimated_duration: (number) | null;
};

export type ClipPlannerRequest = {
    user_goal: string;
    transcript: string;
    min_duration?: (number) | null;
    max_duration?: (number) | null;
};

export type ClipPlansResponse = {
    plans: Array<ClipPlan>;
};

export type ClipSegment = {
    startTime: number;
    endTime: number;
};

export type ColorGradingFilter = {
    readonly id: number;
    name: string;
    preview_image_url: string;
    texture_url: string;
    status: ColorGradingFilterStatusEnum;
    description: (string) | null;
};

/**
 * * `draft` - Draft
 * * `active` - Active
 */
export enum ColorGradingFilterStatusEnum {
    DRAFT = 'draft',
    ACTIVE = 'active'
}

/**
 * Stripped down set of properties that we have for logged in comment users as well as external users.
 */
export type CommentablePersonProfile = {
    first_name: string;
    last_name: string;
    email: string;
    id: (number) | null;
};

export type ConversationDetail = {
    readonly id: string;
    readonly user_id: number;
    readonly workspace_id: (number) | null;
    readonly video_id: (number) | null;
    messages: Array<{
        [key: string]: unknown;
    }>;
    model: string;
    tools: unknown;
    task_type: (string) | null;
    actual_latency: (number) | null;
    media_registry: unknown;
    readonly created_at: string;
    readonly updated_at: string;
};

export type CopyMediaAssetsRequest = {
    source_team_id: number;
    source_workspace_id: number;
    source_folder_id: (number) | null;
    target_workspace_ids: Array<(number)>;
    show_stats: string;
};

export type CopyMediaAssetsResponse = {
    source_team_id: number;
    source_team_members: Array<(string)>;
    source_workspace_id: number;
    source_folder_id: (number) | null;
    target_workspaces: Array<(string)>;
    num_of_video_assets: number;
    num_of_image_assets: number;
    num_of_icon_assets: number;
};

export type CopyMediaAssetsResult = CopyMediaAssetsResponse | QueuedTaskResult;

export type CouponStatus = {
    valid: boolean;
    duration: string;
    discount: string;
    id: string;
};

export type CreateBlueprintFromSimilarRequest = {
    video_id: number;
    archived?: boolean;
    name?: (string) | null;
    custom_instructions?: (string) | null;
};

export type CreateBlueprintFromSuggestedBlueprintRequest = {
    suggested_blueprint_id: number;
};

export type CreateVideoFromBlueprintRequest = {
    blueprint_id: number;
    target_project_id?: number;
};

export type CreateVideoRequest = {
    video_data: {
        [key: string]: unknown;
    };
    project_id?: number;
    aspect_ratio?: string;
    template?: (string) | null;
    script_composer_data?: ((ScriptComposerDataRequest) | null);
};

export type CreateVideoResponse = {
    video_id: number;
    video_data_hash: string;
};

/**
 * * `new` - New
 * * `edit` - Edit
 * * `template` - Template
 * * `new-recommended` - New Recommended
 * * `instant-email` - Instant Email
 * * `media` - Media
 * * `clip-creator` - Clip Creator
 * * `screen-recordings` - Screen Recordings
 * * `copy-and-paste` - Copy And Paste
 * * `url` - Url
 * * `start-from-scratch` - Start From Scratch
 * * `extension-toolbar` - Extension Toolbar
 * * `extension-wordpress` - Extension Wordpress
 * * `extension-medium` - Extension Medium
 * * `translation` - Translation
 * * `suggested-blueprint` - Suggested Blueprint
 * * `genx` - Genx
 */
export enum CreationSourceEnum {
    NEW = 'new',
    EDIT = 'edit',
    TEMPLATE = 'template',
    NEW_RECOMMENDED = 'new-recommended',
    INSTANT_EMAIL = 'instant-email',
    MEDIA = 'media',
    CLIP_CREATOR = 'clip-creator',
    SCREEN_RECORDINGS = 'screen-recordings',
    COPY_AND_PASTE = 'copy-and-paste',
    URL = 'url',
    START_FROM_SCRATCH = 'start-from-scratch',
    EXTENSION_TOOLBAR = 'extension-toolbar',
    EXTENSION_WORDPRESS = 'extension-wordpress',
    EXTENSION_MEDIUM = 'extension-medium',
    TRANSLATION = 'translation',
    SUGGESTED_BLUEPRINT = 'suggested-blueprint',
    GENX = 'genx'
}

export type CreditCardDetails = {
    last_four: string;
    exp_month: number;
    exp_year: number;
    credit: number;
};

/**
 * * `none` - No Crop
 * * `subject_center` - Subject Center
 * * `subject_rule_of_thirds` - Subject Rule Of Thirds
 */
export enum CropRecommendationOptions {
    NONE = 'none',
    SUBJECT_CENTER = 'subject_center',
    SUBJECT_RULE_OF_THIRDS = 'subject_rule_of_thirds'
}

export type CurrentPlanName = {
    plan_name: string;
    payment_status: (string) | null;
    client_secret: (string) | null;
};

export type DAMSearchRequest = {
    dam_config_id: number;
    provider: ProviderEnum;
    filters: Array<FiltersEnum>;
    search_term?: (string) | null;
    next_page?: (string) | null;
};

/**
 * * `start_from_scratch` - Start From Scratch
 * * `talking_head_upload_record` - Talking Head Upload Record
 * * `voiceover_upload_record` - Voiceover Upload Record
 * * `screen_recording` - Screen Recording
 */
export enum DashboardFlowEnum {
    START_FROM_SCRATCH = 'start_from_scratch',
    TALKING_HEAD_UPLOAD_RECORD = 'talking_head_upload_record',
    VOICEOVER_UPLOAD_RECORD = 'voiceover_upload_record',
    SCREEN_RECORDING = 'screen_recording'
}

/**
 * This is a stripped down version of VideoSerializer to only contain the fields needed for the dashboard.
 * Since that's where we're listing a bunch of videos it's important to keep the payload small.
 */
export type DashboardVideo = {
    slug: string;
    name: string;
    readonly creation_date: (string) | null;
    readonly page_url: string;
    readonly id: number;
    readonly download_url: (string) | null;
    readonly placeholder_image_url: (string) | null;
    readonly status: (VideoStatus);
    readonly project: (number) | null;
    readonly is_in_script_composer: boolean;
    readonly owner_name: string;
    readonly video_approval_status: ((VideoApprovalStatusEnum) | null);
    readonly last_updated_by_name: string;
    last_updated_date: string;
    /**
     * Language this video was translated into (only set if video created by translation feature)
     */
    translated_language: (string) | null;
    creation_source: ((CreationSourceEnum) | null);
    edit_parent_language: (string) | null;
    aspect_ratio: AspectRatio;
    narrative_threads: Array<NarrativeThreadEnum> | null;
    readonly template_id: string;
    duration_seconds: (number) | null;
    /**
     * List of tags for categorizing and filtering videos
     */
    tags: Array<(string)>;
};

export type DatasetMetadata = {
    readonly id: number;
    dataset_metadata: unknown;
};

export type DatasetMetadataRequest = {
    dataset_metadata?: unknown;
};

export type DeleteUserAccountResponse = {
    sso_idp: (string) | null;
};

export type DisplayGroup = {
    readonly id: number;
    display_name: string;
    template: string;
    order: number;
};

/**
 * Override the DisplayGroupSerializer to reflect that the 'order' property can be null which will be auto-assigned
 */
export type DisplayGroupCreateRequest = {
    display_name: string;
    template: string;
    order?: (number) | null;
};

export type DisplayGroupOrderRequest = {
    id: number;
    order: number;
};

export type Document = {
    readonly id: number;
    path: string;
    name: string;
    language: LanguageEnum;
};

export type DocumentAssetModel = {
    readonly id: number;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: (string) | null;
    license: LicenseEnum;
    attribution: (string) | null;
    url: string;
    name: string;
};

export type DocumentAssetModelRequest = {
    uuid?: (string) | null;
    source: SourceEnum;
    source_id?: (string) | null;
    license: LicenseEnum;
    attribution?: (string) | null;
    url: string;
    name: string;
};

export type DocumentRequest = {
    path: string;
    name: string;
    language: LanguageEnum;
};

export type DocumentsRequest = {
    url: string;
    name: string;
};

export type DuplicateBlueprintRequest = {
    target_workspace_ids?: Array<(number)>;
};

export type DuplicateMultipleVideosRequest = {
    video_ids: Array<(number)>;
    with_prefix?: boolean;
    use_default_name?: boolean;
    target_project_id?: number;
    archived?: boolean;
};

export type EditVoiceoverRequest = {
    video_id?: (number) | null;
    full_transcript: Array<EditedTranscriptWordRequest>;
    language: LanguageEnum;
    original_audio_asset_source_data: AudioAssetSourceDataRequest;
    trim_start_millis?: (number) | null;
    trim_end_millis?: (number) | null;
    context_select_full_transcript?: (boolean) | null;
    new_voice?: string;
    new_voice_speed?: (number) | null;
};

export type EditedTranscriptWord = {
    word: string;
    startTime: number;
    endTime: number;
    filler: boolean;
    id: string;
};

export type EditedTranscriptWordRequest = {
    word: string;
    startTime: number;
    endTime: number;
    filler?: boolean;
    id: string;
    userSelected: boolean;
    contextSelected?: (boolean) | null;
};

export type EmailExistenceRequest = {
    email: string;
};

export type EmailExistenceResponse = {
    email: string;
    reason: string;
};

/**
 * * `hit-media-credit-limit` - Hit Media Credit Limit
 * * `premium-media-credits` - Premium Media Credits
 * * `video-duration-too-long` - Video Duration Too Long
 * * `voiceover-too-long` - Voiceover Too Long
 * * `transitioned-media-present` - Transitioned Media Present
 * * `overwriting-data` - Overwriting Data
 * * `already-published` - Already Published
 * * `not-published` - Not Published
 * * `upgrade-for-ai-avatar` - Upgrade For Ai Avatar
 * * `upgrade-for-unlimited-media` - Upgrade For Unlimited Media
 * * `video-has-too-many-scenes` - Video Has Too Many Scenes
 * * `unable-to-find-video` - Unable To Find Video
 * * `unable-to-read-video` - Unable To Read Video
 * * `no-url-available` - No Url Available
 * * `hit-ai-vo-minutes-limit` - Hit Ai Vo Minutes Limit
 * * `unknown-state` - Unknown State
 * * `custom-fonts-not-allowed` - Custom Fonts Not Allowed
 * * `custom-colors-not-allowed` - Custom Colors Not Allowed
 * * `custom-colors-and-fonts-not-allowed` - Custom Colors And Fonts Not Allowed
 * * `zero-slides` - Zero Slides
 * * `hit-feature-usage-limit` - Feature Limit Reached
 */
export enum ErrorEnum {
    HIT_MEDIA_CREDIT_LIMIT = 'hit-media-credit-limit',
    PREMIUM_MEDIA_CREDITS = 'premium-media-credits',
    VIDEO_DURATION_TOO_LONG = 'video-duration-too-long',
    VOICEOVER_TOO_LONG = 'voiceover-too-long',
    TRANSITIONED_MEDIA_PRESENT = 'transitioned-media-present',
    OVERWRITING_DATA = 'overwriting-data',
    ALREADY_PUBLISHED = 'already-published',
    NOT_PUBLISHED = 'not-published',
    UPGRADE_FOR_AI_AVATAR = 'upgrade-for-ai-avatar',
    UPGRADE_FOR_UNLIMITED_MEDIA = 'upgrade-for-unlimited-media',
    VIDEO_HAS_TOO_MANY_SCENES = 'video-has-too-many-scenes',
    UNABLE_TO_FIND_VIDEO = 'unable-to-find-video',
    UNABLE_TO_READ_VIDEO = 'unable-to-read-video',
    NO_URL_AVAILABLE = 'no-url-available',
    HIT_AI_VO_MINUTES_LIMIT = 'hit-ai-vo-minutes-limit',
    UNKNOWN_STATE = 'unknown-state',
    CUSTOM_FONTS_NOT_ALLOWED = 'custom-fonts-not-allowed',
    CUSTOM_COLORS_NOT_ALLOWED = 'custom-colors-not-allowed',
    CUSTOM_COLORS_AND_FONTS_NOT_ALLOWED = 'custom-colors-and-fonts-not-allowed',
    ZERO_SLIDES = 'zero-slides',
    HIT_FEATURE_USAGE_LIMIT = 'hit-feature-usage-limit'
}

export type EstimatedRenderDurationResponse = {
    video_estimates: {
        [key: string]: VideoEstimate;
    };
};

/**
 * * `unknown` - Unknown
 * * `retrying` - Retrying
 * * `error` - Error
 */
export enum EstimatedStatusEnum {
    UNKNOWN = 'unknown',
    RETRYING = 'retrying',
    ERROR = 'error'
}

export type EvalGrade = {
    readonly id: number;
    evalRunShotId: number;
    stage: StageEnum;
    readonly userId: number;
    score: number;
    notes: string;
    readonly createdAt: string;
};

export type EvalGradeCreateRequest = {
    evalRunShotId: number;
    stage: StageEnum;
    score: number;
    notes?: string;
};

export type EvalRunCreateRequest = {
    evalSetId: number;
    presetSlug: string;
    gradingPresetId?: (number) | null;
    imageModel?: string;
    videoModel?: string;
    notes?: string;
};

export type EvalRunDetail = {
    readonly id: number;
    readonly evalSetId: number;
    readonly evalSetName: string;
    readonly presetSlug: string;
    readonly presetName: string;
    readonly status: string;
    readonly imageModel: string;
    readonly videoModel: string;
    readonly configSnapshot: unknown;
    readonly gradingConfigSnapshot: unknown;
    readonly avgImageScore: (number) | null;
    readonly avgVideoScore: (number) | null;
    readonly imageCreditsUsed: number;
    readonly videoCreditsUsed: number;
    readonly imageCreditCostPerShot: number;
    readonly videoCreditCostPerShot: number;
    readonly notes: string;
    readonly createdBy: string;
    readonly createdAt: string;
    readonly runScripts: Array<EvalRunScript>;
};

export type EvalRunList = {
    readonly id: number;
    readonly evalSetId: number;
    readonly evalSetName: string;
    readonly presetSlug: string;
    readonly presetName: string;
    readonly status: string;
    readonly imageModel: string;
    readonly videoModel: string;
    readonly avgImageScore: (number) | null;
    readonly avgVideoScore: (number) | null;
    readonly imageCreditsUsed: number;
    readonly videoCreditsUsed: number;
    readonly gradingConfigSnapshot: unknown;
    readonly notes: string;
    readonly createdBy: string;
    readonly createdAt: string;
};

export type EvalRunScript = {
    readonly id: number;
    readonly evalScriptId: number;
    readonly evalScriptTitle: string;
    readonly storyboardData: unknown;
    readonly shots: Array<EvalRunShot>;
};

export type EvalRunScriptCreateRequest = {
    evalScriptId: number;
    storyboardData: unknown;
};

export type EvalRunShot = {
    readonly id: number;
    readonly shotIndex: number;
    readonly shotPrompt: string;
    readonly videoPrompt: string;
    readonly aiVoiceover: string;
    readonly imageAssetUuid: (string) | null;
    readonly imageAssetUrl: (string) | null;
    readonly videoAssetUuid: (string) | null;
    readonly videoAssetUrl: (string) | null;
    readonly imageStatus: string;
    readonly videoStatus: string;
    readonly grades: Array<EvalGrade>;
};

/**
 * * `storyboarding` - storyboarding
 * * `images_generating` - images_generating
 * * `images_review` - images_review
 * * `videos_generating` - videos_generating
 * * `videos_review` - videos_review
 * * `complete` - complete
 * * `failed` - failed
 */
export enum EvalRunUpdateStatusEnum {
    STORYBOARDING = 'storyboarding',
    IMAGES_GENERATING = 'images_generating',
    IMAGES_REVIEW = 'images_review',
    VIDEOS_GENERATING = 'videos_generating',
    VIDEOS_REVIEW = 'videos_review',
    COMPLETE = 'complete',
    FAILED = 'failed'
}

export type EvalScript = {
    readonly id: number;
    title: string;
    scriptText: string;
    order: number;
};

export type EvalScriptCreateRequest = {
    title: string;
    scriptText: string;
    order?: number;
};

export type EvalSetCreateRequest = {
    name: string;
    description?: string;
};

export type EvalSetDetail = {
    readonly id: number;
    name: string;
    description: string;
    readonly scripts: Array<EvalScript>;
    readonly createdAt: string;
};

export type EvalSetList = {
    readonly id: number;
    name: string;
    description: string;
    readonly scriptCount: number;
    readonly createdAt: string;
};

export type ExportAuditLogResponse = {
    url: string;
};

export type FaceDetectionRequest = {
    asset_uuid: string;
    asset_type: AssetTypes;
    timestamp_ms?: (number) | null;
};

export type FaceDetectionResponse = {
    bounding_boxes: Array<BoundingBox>;
};

/**
 * A serializer for incoming CREATE requests to the Favorites endpoint.
 */
export type FavoritedAsset = {
    asset_type: AssetTypes;
    uuid: string;
};

/**
 * Serializer for a single feature flag with enrollment status.
 */
export type FeatureFlag = {
    name: string;
    is_enrolled: boolean;
};

export type FeedbackRequest = {
    text: string;
    emoji: string;
    video_id: number;
    blueprint_id?: number;
    source?: string;
    page?: string;
    flow?: string;
};

/**
 * * `videos` - Videos
 * * `photos` - Photos
 */
export enum FiltersEnum {
    VIDEOS = 'videos',
    PHOTOS = 'photos'
}

export type FontAsset = {
    readonly id: number;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: (string) | null;
    license: LicenseEnum;
    attribution: (string) | null;
    url: string;
    description: (string) | null;
    tags: Array<(string)>;
    title: (string) | null;
    name: string;
};

export type FontAssetRequest = {
    uuid?: (string) | null;
    source: SourceEnum;
    source_id?: (string) | null;
    license: LicenseEnum;
    attribution?: (string) | null;
    url: string;
    description?: (string) | null;
    tags: Array<(string)>;
    title?: (string) | null;
    name: string;
};

export type ForgotPasswordSubmissionRequest = {
    email: string;
};

export type GenXPresetBuilderScenario = {
    readonly id: number;
    text: string;
    order: number;
};

export type GenXPresetBuilderScenarioRequest = {
    text: string;
    order?: number;
};

export type GenXStylePreset = {
    slug: string;
    name: string;
    description: string;
    imageStyleGuidelines: string;
    videoStyleGuidelines: string;
    videoNegativePrompt: string;
    thumbnail_url: string;
    status: string;
    styleReferenceAssets: Array<GenXStylePresetImage>;
};

export type GenXStylePresetCreate = {
    slug: string;
    name: string;
    description: string;
    style_guidelines: string;
    video_style_guidelines: string;
    video_negative_prompt: string;
    thumbnail_url: string;
    image_uuids: Array<(string)>;
};

export type GenXStylePresetCreateRequest = {
    slug: string;
    name: string;
    description?: string;
    style_guidelines?: string;
    video_style_guidelines?: string;
    video_negative_prompt?: string;
    thumbnail_url?: string;
    image_uuids?: Array<(string)>;
};

export type GenXStylePresetImage = {
    uuid: string;
    displayUrl: string;
};

export type GenerateChartConfigRequest = {
    scene_text: string;
    chart_type?: string;
    chart_data?: string;
    custom_prompt?: string;
};

export type GenerateChartConfigResponse = {
    config: unknown;
};

export type GenerateIconAssetMetadata = {
    type: string;
    name: string;
    sourceData: {
        [key: string]: unknown;
    };
};

export type GenerateMediaAssetMetadata = {
    type: string;
    name: string;
    sourceData: {
        [key: string]: unknown;
    };
};

export type GenerateRecommendedVideoRequest = {
    video_id?: (number) | null;
    template_id: string;
    reference_material?: (string) | null;
    language?: ((LanguageEnum) | null);
    narrative_thread: NarrativeThreadEnum;
    script_segments?: Array<(string)> | null;
    transcript_words?: Array<(string)> | null;
    aspect_ratio: AspectRatio;
    blueprint_id?: number;
    media_candidates?: ((MediaCandidatesRequest) | null);
    media_options?: ((MediaOptionsRequest) | null);
};

export type GenerateRecommendedVideoResponse = {
    scenes: Array<SceneRecommendation>;
    media_options: MediaOptions;
    media_candidates: MediaCandidates;
    script: string;
};

/**
 * This object contains the information necessary to generate a scene.
 */
export type GenerateSceneMetadata = {
    segment: string;
    display_group_name: string;
    scene_design: string;
    language: string;
    assets: Array<PolymorphicAsset>;
    modifications: {
        [key: string]: unknown;
    };
};

export type GenerateScriptFromPromptRequest = {
    video_id: number;
    narrative_thread: NarrativeThreadEnum;
    language?: ((LanguageEnum) | null);
    subject: string;
    audience?: string;
    author?: string;
    reference_material?: string;
    other_instructions?: string;
    duration: number;
    tone?: (string) | null;
    blueprint_id?: number;
    template_id?: string;
    perspective?: (PerspectiveEnum);
};

export type GenerateScriptOption = {
    uuid: string;
    type: (string) | null;
    title: string;
    description: string;
    duration_seconds: (number) | null;
    tone: string;
    perspective: string;
    include_hook: boolean;
    include_cta: boolean;
};

export type GenerateScriptOptionRequest = {
    uuid: string;
    type?: (string) | null;
    title: string;
    description: string;
    duration_seconds: (number) | null;
    tone?: string;
    perspective?: string;
    include_hook?: boolean;
    include_cta?: boolean;
};

export type GenerateScriptRequest = {
    video_id: number;
    doctext: string;
    narrative_thread?: (NarrativeThreadEnum);
    language?: ((LanguageEnum) | null);
    title: string;
    description?: string;
    duration: number;
    tone?: (string) | null;
    blueprint_id?: number;
    perspective?: (PerspectiveEnum);
    template_id?: string;
};

export type GenerateScriptResponse = {
    data: ScriptData;
    error_message: (string) | null;
    warning_message: (string) | null;
};

export type GenerateTextAssetMetadata = {
    type: string;
    name: string;
    text: string;
    highlights: Array<[
        number,
        number
    ]>;
};

export type GenerateTranscriptResponse = {
    has_voiceover: (boolean) | null;
};

export type GenerateVideosForVideoPlansRequest = {
    reference_material?: (string) | null;
    video_plans: Array<VideoPlanRequest>;
    /**
     * List of source media UUIDs to include in media candidates
     */
    source_media_uuids?: Array<(string)> | null;
    media_options?: ((MediaOptionsRequest) | null);
    /**
     * ID of the sketch conversation that triggered this video generation
     */
    conversation_id?: (string) | null;
};

export type GenerativeMediaModels = {
    model_type: ModelTypeEnum;
    model_name: ModelNameEnum;
    display_name: string;
    description: string;
    supported_aspect_ratios: Array<AIMediaAspectRatio>;
    supported_duration_seconds: Array<AIVideoDuration>;
    credit_cost_per_second: number;
    credit_cost: number;
    max_reference_images: number;
    requires_paid_plan: boolean;
    is_visible_to_public: boolean;
};

export type GradingPreset = {
    readonly id: number;
    name: string;
    description: string;
    scaleType: string;
    scaleMin: number;
    scaleMax: number;
    scaleLabels: unknown;
    scorerName: string;
    scorerParams: unknown;
};

/**
 * * `grounded` - grounded
 * * `ungrounded` - ungrounded
 * * `editorial` - editorial
 */
export enum GroundedEnum {
    GROUNDED = 'grounded',
    UNGROUNDED = 'ungrounded',
    EDITORIAL = 'editorial'
}

export type GroundhogAnalysisRequest = {
    reference_material: string;
    sentences: Array<(string)>;
};

export type GroundhogAnalysisResponse = {
    script_analysis: Array<GroundhogSentenceAnalysis>;
};

export type GroundhogEvidence = {
    reference_excerpt: string;
};

export type GroundhogSentenceAnalysis = {
    sentence_index: number;
    sentence_text: string;
    grounded: GroundedEnum;
    supporting_evidence: Array<GroundhogEvidence>;
    explanation: string;
};

export type GroupedAIVoiceFilters = {
    accent: Array<(string)>;
    tone: Array<(string)>;
    style: Array<(string)>;
    language: Array<(string)>;
    age: Array<(string)>;
    gender: Array<(string)>;
    quality: Array<(string)>;
};

export type HasValidProjectInWorkspaceResponse = {
    has_valid_project: boolean;
};

export type IconAssetModel = {
    readonly id: number;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: (string) | null;
    license: LicenseEnum;
    attribution: (string) | null;
    url: string;
    description: (string) | null;
    tags: Array<(string)>;
    title: (string) | null;
    animated: (boolean) | null;
    num_colors: number;
    readonly history_index_user_ids: Array<(number)> | null;
};

export type IconAssetModelRequest = {
    uuid?: (string) | null;
    source: SourceEnum;
    source_id?: (string) | null;
    license: LicenseEnum;
    attribution?: (string) | null;
    url: string;
    description?: (string) | null;
    tags: Array<(string)>;
    title?: (string) | null;
    animated?: (boolean) | null;
    num_colors: number;
};

export type IdeaOutlineData = {
    subject: string;
    use_case: string;
    references: Array<(string)>;
};

export type IdeaOutlineDataRequest = {
    subject: string;
    use_case?: string;
    references: Array<(string)>;
};

export type ImageAsset = {
    id: (number) | null;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: (string) | null;
    license: LicenseEnum;
    attribution: (string) | null;
    is_editorial: (boolean) | null;
    width: (number) | null;
    height: (number) | null;
    suitability_score: (number) | null;
    thumbnail_url: string;
    preview_url: string;
    render_url: (string) | null;
};

export type ImageAssetModel = {
    readonly id: number;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: string;
    license: LicenseEnum;
    attribution: (string) | null;
    is_editorial: (boolean) | null;
    width: number;
    height: number;
    suitability_score: (number) | null;
    thumbnail_url: string;
    preview_url: string;
    render_url: (string) | null;
    description: (string) | null;
    tags: Array<(string)>;
    title: (string) | null;
    display_credit_text: (string) | null;
    display_credit_url: (string) | null;
};

export type ImageAssetModelRequest = {
    uuid?: (string) | null;
    source: SourceEnum;
    source_id: string;
    license: LicenseEnum;
    attribution?: (string) | null;
    is_editorial?: (boolean) | null;
    width?: number;
    height?: number;
    suitability_score?: (number) | null;
    thumbnail_url: string;
    preview_url: string;
    render_url?: (string) | null;
    description?: (string) | null;
    tags: Array<(string)>;
    title?: (string) | null;
    display_credit_text?: (string) | null;
    display_credit_url?: (string) | null;
};

export type ImageGenerationProperties = {
    style: ImageGenerationPropertiesStyleEnum;
    tone: ImageGenerationPropertiesToneEnum;
    reference_images: Array<(string)>;
};

/**
 * * `None` - None
 * * `Cartoon` - Cartoon
 * * `Digital art` - Digital Art
 * * `Illustration` - Illustration
 * * `Painting` - Painting
 * * `Pencil sketch` - Pencil Sketch
 * * `Photorealistic` - Photorealistic
 */
export enum ImageGenerationPropertiesStyleEnum {
    NONE = 'None',
    CARTOON = 'Cartoon',
    DIGITAL_ART = 'Digital art',
    ILLUSTRATION = 'Illustration',
    PAINTING = 'Painting',
    PENCIL_SKETCH = 'Pencil sketch',
    PHOTOREALISTIC = 'Photorealistic'
}

/**
 * * `None` - None
 * * `Black and white` - Black And White
 * * `Cool tone` - Cool Tone
 * * `Golden tone` - Golden Tone
 * * `Monochromatic` - Monochromatic
 * * `Muted color` - Muted Color
 * * `Saturated` - Saturated
 * * `Vibrant colors` - Vibrant Colors
 */
export enum ImageGenerationPropertiesToneEnum {
    NONE = 'None',
    BLACK_AND_WHITE = 'Black and white',
    COOL_TONE = 'Cool tone',
    GOLDEN_TONE = 'Golden tone',
    MONOCHROMATIC = 'Monochromatic',
    MUTED_COLOR = 'Muted color',
    SATURATED = 'Saturated',
    VIBRANT_COLORS = 'Vibrant colors'
}

/**
 * * `fal-ai/flux/dev` - Flux Dev
 * * `fal-ai/flux/schnell` - Flux Schnell
 * * `fal-ai/imagen4/preview` - Imagen4
 * * `fal-ai/nano-banana` - Nano Banana
 * * `fal-ai/nano-banana-pro` - Nano Banana Pro
 * * `fal-ai/nano-banana-2` - Nano Banana 2
 * * `fal-ai/imagen3` - Imagen3
 * * `fal-ai/flux-pro/v1.1` - Flux Pro 1 1
 * * `fal-ai/recraft-v3` - Recraft V3
 * * `fal-ai/birefnet/v2` - Briefnet V2
 * * `fal-ai/nano-banana/edit` - Nano Banana Edit
 * * `fal-ai/nano-banana-pro/edit` - Nano Banana Pro Edit
 * * `fal-ai/nano-banana-2/edit` - Nano Banana 2 Edit
 * * `fal-ai/flux-kontext/dev` - Flux Kontext Dev
 * * `gpt-image-1` - Gpt Image 1
 * * `fal-ai/flux/dev/image-to-image` - Flux Dev Kontext
 * * `fal-ai/flux-pro/kontext` - Flux Pro Kontext
 */
export enum ImageGenerationRequestModelEnum {
    FAL_AI_FLUX_DEV = 'fal-ai/flux/dev',
    FAL_AI_FLUX_SCHNELL = 'fal-ai/flux/schnell',
    FAL_AI_IMAGEN4_PREVIEW = 'fal-ai/imagen4/preview',
    FAL_AI_NANO_BANANA = 'fal-ai/nano-banana',
    FAL_AI_NANO_BANANA_PRO = 'fal-ai/nano-banana-pro',
    FAL_AI_NANO_BANANA_2 = 'fal-ai/nano-banana-2',
    FAL_AI_IMAGEN3 = 'fal-ai/imagen3',
    FAL_AI_FLUX_PRO_V1_1 = 'fal-ai/flux-pro/v1.1',
    FAL_AI_RECRAFT_V3 = 'fal-ai/recraft-v3',
    FAL_AI_BIREFNET_V2 = 'fal-ai/birefnet/v2',
    FAL_AI_NANO_BANANA_EDIT = 'fal-ai/nano-banana/edit',
    FAL_AI_NANO_BANANA_PRO_EDIT = 'fal-ai/nano-banana-pro/edit',
    FAL_AI_NANO_BANANA_2_EDIT = 'fal-ai/nano-banana-2/edit',
    FAL_AI_FLUX_KONTEXT_DEV = 'fal-ai/flux-kontext/dev',
    GPT_IMAGE_1 = 'gpt-image-1',
    FAL_AI_FLUX_DEV_IMAGE_TO_IMAGE = 'fal-ai/flux/dev/image-to-image',
    FAL_AI_FLUX_PRO_KONTEXT = 'fal-ai/flux-pro/kontext'
}

/**
 * * `pending` - pending
 * * `completed` - completed
 * * `failed` - failed
 */
export enum ImageStatusEnum {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

/**
 * Response when checking a signup to see if it has been invited to a team
 */
export type InvitationResponse = {
    sender_first_name: string;
    recipient_email: string;
    sso_required: boolean;
    user_exists: boolean;
};

/**
 * * `xx` - xx
 * * `af` - af
 * * `ar` - ar
 * * `bg` - bg
 * * `ca` - ca
 * * `cs` - cs
 * * `da` - da
 * * `de` - de
 * * `el` - el
 * * `en` - en
 * * `es` - es
 * * `et` - et
 * * `fa` - fa
 * * `fi` - fi
 * * `fr` - fr
 * * `he` - he
 * * `hi` - hi
 * * `hr` - hr
 * * `hu` - hu
 * * `id` - id
 * * `it` - it
 * * `ja` - ja
 * * `ko` - ko
 * * `ku` - ku
 * * `lt` - lt
 * * `lv` - lv
 * * `mk` - mk
 * * `ms` - ms
 * * `nl` - nl
 * * `nn` - nn
 * * `no` - no
 * * `pl` - pl
 * * `pt` - pt
 * * `ro` - ro
 * * `ru` - ru
 * * `sk` - sk
 * * `sr` - sr
 * * `sv` - sv
 * * `th` - th
 * * `tl` - tl
 * * `tr` - tr
 * * `uk` - uk
 * * `ur` - ur
 * * `vi` - vi
 * * `zh` - zh
 * * `zh-tw` - zh-tw
 * * `ta` - ta
 * * `te` - te
 * * `ml` - ml
 * * `kn` - kn
 * * `mr` - mr
 * * `pa` - pa
 * * `as` - as
 * * `or` - or
 */
export enum LanguageEnum {
    XX = 'xx',
    AF = 'af',
    AR = 'ar',
    BG = 'bg',
    CA = 'ca',
    CS = 'cs',
    DA = 'da',
    DE = 'de',
    EL = 'el',
    EN = 'en',
    ES = 'es',
    ET = 'et',
    FA = 'fa',
    FI = 'fi',
    FR = 'fr',
    HE = 'he',
    HI = 'hi',
    HR = 'hr',
    HU = 'hu',
    ID = 'id',
    IT = 'it',
    JA = 'ja',
    KO = 'ko',
    KU = 'ku',
    LT = 'lt',
    LV = 'lv',
    MK = 'mk',
    MS = 'ms',
    NL = 'nl',
    NN = 'nn',
    NO = 'no',
    PL = 'pl',
    PT = 'pt',
    RO = 'ro',
    RU = 'ru',
    SK = 'sk',
    SR = 'sr',
    SV = 'sv',
    TH = 'th',
    TL = 'tl',
    TR = 'tr',
    UK = 'uk',
    UR = 'ur',
    VI = 'vi',
    ZH = 'zh',
    ZH_TW = 'zh-tw',
    TA = 'ta',
    TE = 'te',
    ML = 'ml',
    KN = 'kn',
    MR = 'mr',
    PA = 'pa',
    AS = 'as',
    OR = 'or'
}

export type LanguageInfoForTextRequest = {
    text: string;
};

export type LanguageInfoForTextResponse = {
    language: LanguageEnum;
    text_direction: TextDirectionEnum;
};

/**
 * * `xx` - xx
 * * `af` - af
 * * `ar` - ar
 * * `bg` - bg
 * * `ca` - ca
 * * `cs` - cs
 * * `da` - da
 * * `de` - de
 * * `el` - el
 * * `en-GB` - en-GB
 * * `en-US` - en-US
 * * `es-mx` - es-mx
 * * `es-co` - es-co
 * * `es-es` - es-es
 * * `et` - et
 * * `fa` - fa
 * * `fi` - fi
 * * `fr-fr` - fr-fr
 * * `fr-ca` - fr-ca
 * * `he` - he
 * * `hi` - hi
 * * `hr` - hr
 * * `hu` - hu
 * * `id` - id
 * * `it` - it
 * * `ja` - ja
 * * `ko` - ko
 * * `ku` - ku
 * * `lt` - lt
 * * `lv` - lv
 * * `mk` - mk
 * * `ms` - ms
 * * `nl` - nl
 * * `nn` - nn
 * * `no` - no
 * * `pl` - pl
 * * `pt-br` - pt-br
 * * `pt-pt` - pt-pt
 * * `ro` - ro
 * * `ru` - ru
 * * `sk` - sk
 * * `sr` - sr
 * * `sv` - sv
 * * `th` - th
 * * `tl` - tl
 * * `tr` - tr
 * * `uk` - uk
 * * `ur` - ur
 * * `vi` - vi
 * * `zh` - zh
 * * `zh-tw` - zh-tw
 * * `ta` - ta
 * * `te` - te
 * * `ml` - ml
 * * `kn` - kn
 * * `mr` - mr
 * * `pa` - pa
 * * `as` - as
 * * `or` - or
 */
export enum LanguageLocalesEnum {
    XX = 'xx',
    AF = 'af',
    AR = 'ar',
    BG = 'bg',
    CA = 'ca',
    CS = 'cs',
    DA = 'da',
    DE = 'de',
    EL = 'el',
    EN_GB = 'en-GB',
    EN_US = 'en-US',
    ES_MX = 'es-mx',
    ES_CO = 'es-co',
    ES_ES = 'es-es',
    ET = 'et',
    FA = 'fa',
    FI = 'fi',
    FR_FR = 'fr-fr',
    FR_CA = 'fr-ca',
    HE = 'he',
    HI = 'hi',
    HR = 'hr',
    HU = 'hu',
    ID = 'id',
    IT = 'it',
    JA = 'ja',
    KO = 'ko',
    KU = 'ku',
    LT = 'lt',
    LV = 'lv',
    MK = 'mk',
    MS = 'ms',
    NL = 'nl',
    NN = 'nn',
    NO = 'no',
    PL = 'pl',
    PT_BR = 'pt-br',
    PT_PT = 'pt-pt',
    RO = 'ro',
    RU = 'ru',
    SK = 'sk',
    SR = 'sr',
    SV = 'sv',
    TH = 'th',
    TL = 'tl',
    TR = 'tr',
    UK = 'uk',
    UR = 'ur',
    VI = 'vi',
    ZH = 'zh',
    ZH_TW = 'zh-tw',
    TA = 'ta',
    TE = 'te',
    ML = 'ml',
    KN = 'kn',
    MR = 'mr',
    PA = 'pa',
    AS = 'as',
    OR = 'or'
}

/**
 * * `CC0` - CC0
 * * `BY` - BY
 * * `user_private` - user_private
 */
export enum LicenseEnum {
    CC0 = 'CC0',
    BY = 'BY',
    USER_PRIVATE = 'user_private'
}

export type LogMediaAgentResultsRequest = {
    video_id: number;
    conversation_id: string;
    flags: Array<(string)>;
    media_selections: Array<MediaSelectionEntryRequest>;
};

export type LongestSupportedDurationTargetsRequest = {
    doctext: string;
};

export type LongestSupportedDurationTargetsResponse = {
    longest_supported_duration_seconds: (number) | null;
};

export type MediaAssetTextRepresentationResponse = {
    text_representation: string;
    visual_first_frame_description: (string) | null;
    decade: (string) | null;
};

export type MediaAttributesResponse = {
    asset_name: string;
    x_offset: (number) | null;
    y_offset: (number) | null;
    background_animation: MediaAttributesResponseBackgroundAnimationEnum;
    brightness: number;
};

/**
 * * `none` - none
 * * `pan_left` - pan_left
 * * `pan_right` - pan_right
 * * `pan_up` - pan_up
 * * `pan_down` - pan_down
 * * `zoom_out` - zoom_out
 * * `zoom_in` - zoom_in
 */
export enum MediaAttributesResponseBackgroundAnimationEnum {
    NONE = 'none',
    PAN_LEFT = 'pan_left',
    PAN_RIGHT = 'pan_right',
    PAN_UP = 'pan_up',
    PAN_DOWN = 'pan_down',
    ZOOM_OUT = 'zoom_out',
    ZOOM_IN = 'zoom_in'
}

export type MediaBackgroundAssetDataRequest = {
    preview_url: string;
    thumbnail_url: string;
    render_url: string;
    width: number;
    height: number;
    tags: Array<(string)>;
    title?: (string) | null;
    description?: (string) | null;
    source: SourceEnum;
    source_id: string;
    license: LicenseEnum;
    attribution?: (string) | null;
};

export type MediaBackgroundRemovalRequest = {
    asset_uuid?: string;
    asset_data?: MediaBackgroundAssetDataRequest;
    video_id: number;
};

export type MediaCandidates = {
    source_media: Array<(string)>;
    uploaded_media: Array<(string)>;
    stock_media: Array<(string)>;
    stock_icons: Array<(string)>;
    uploaded_icons: Array<(string)>;
    stock_media_by_query: Array<UuidsByQuery>;
};

export type MediaCandidatesRequest = {
    source_media: Array<(string)>;
    uploaded_media: Array<(string)>;
    stock_media: Array<(string)>;
    stock_icons: Array<(string)>;
    uploaded_icons: Array<(string)>;
    stock_media_by_query: Array<UuidsByQueryRequest>;
};

export type MediaConceptPreviewRequest = {
    content_prompt: string;
    media_options: MediaOptionsRequest;
};

export type MediaConceptPreviewResponse = {
    thumbnails: Array<(string)>;
};

export type MediaFolder = {
    readonly id: number;
    name: string;
    readonly created_at: string;
    readonly last_updated: string;
    readonly media_count: number;
    /**
     * Returns thumbnail_url of the folder
     * The thumbnail is the thumbnail_url (or poster_url for video media) of the most recent media asset in the folder
     */
    readonly thumbnail_url: string;
    creation_source: string;
};

export type MediaFolderRequest = {
    name?: string;
    creation_source?: string;
};

export type MediaOptions = {
    source_media_enabled: boolean;
    stock_media_enabled: boolean;
    stock_icons_enabled: boolean;
    dam_media_enabled: boolean;
    workspace_media_mode: (WorkspaceMediaModeEnum);
    workspace_folder_ids: Array<(number)>;
    media_guidance: string;
    minimum_stock_suitability_score: (number) | null;
};

export type MediaOptionsRequest = {
    source_media_enabled?: boolean;
    stock_media_enabled?: boolean;
    stock_icons_enabled?: boolean;
    dam_media_enabled?: boolean;
    workspace_media_mode?: (WorkspaceMediaModeEnum);
    workspace_folder_ids?: Array<(number)>;
    media_guidance?: string;
    minimum_stock_suitability_score?: (number) | null;
};

export type MediaSearchRequest = {
    q?: string;
    page?: number;
    count?: number;
    upsell_count?: number;
    search_source?: MediaSearchSourceEnum;
    filter_by_user_level?: boolean;
    filter?: string;
    autocorrect?: boolean;
    did_you_mean?: boolean;
    sort?: SortEnum;
    uuids?: Array<(string)> | null;
    folder_id?: (number) | null;
    pos?: (string) | null;
    similar_asset_source_type?: SimilarAssetSourceTypeEnum;
    similar_asset_source_uuid?: (string) | null;
    locale?: (string) | null;
};

export type MediaSearchResponse = {
    count: number;
    search_source: MediaSearchSourceEnum;
    next: (string) | null;
    previous: (string) | null;
    results: Array<AssetContainerModel>;
    premium_results: Array<AssetContainerModel>;
    sort: ((SortEnum) | null);
    pos: (string) | null;
    corrected_query: string;
    corrected_query_indices: [
        number,
        number
    ];
    did_you_mean_query: string;
    did_you_mean_highlighted_query: string;
    popular_queries: Array<(string)>;
    processed_query: string;
    error: string;
};

/**
 * * `recommended` - recommended
 * * `curated` - curated
 * * `tenor` - tenor
 * * `uploads` - uploads
 * * `icon_library` - icon_library
 * * `recent` - recent
 * * `favorites` - favorites
 * * `similar` - similar
 * * `tenor-stickers` - tenor-stickers
 * * `waveforms` - waveforms
 * * `favorite-ai-media` - favorite-ai-media
 * * `stickers_uploads` - stickers_uploads
 * * `ai-generated` - ai-generated
 * * `ai-generated-charts` - ai-generated-charts
 */
export enum MediaSearchSourceEnum {
    RECOMMENDED = 'recommended',
    CURATED = 'curated',
    TENOR = 'tenor',
    UPLOADS = 'uploads',
    ICON_LIBRARY = 'icon_library',
    RECENT = 'recent',
    FAVORITES = 'favorites',
    SIMILAR = 'similar',
    TENOR_STICKERS = 'tenor-stickers',
    WAVEFORMS = 'waveforms',
    FAVORITE_AI_MEDIA = 'favorite-ai-media',
    STICKERS_UPLOADS = 'stickers_uploads',
    AI_GENERATED = 'ai-generated',
    AI_GENERATED_CHARTS = 'ai-generated-charts'
}

export type MediaSelectionEntryRequest = {
    media_uuid: (string) | null;
    media_type: ((MediaTypeEnum) | null);
    source_category: ((SourceCategoryEnum) | null);
};

/**
 * * `image` - image
 * * `video` - video
 */
export enum MediaTypeEnum {
    IMAGE = 'image',
    VIDEO = 'video'
}

export type MergeTeamsRequest = {
    source_team_id: string;
    target_team_id: string;
    show_stats?: boolean;
};

export type MergeTeamsStatsResponse = {
    source_team: TeamMergeStats;
    target_team: TeamMergeStats;
};

export type MixpanelEventRequest = {
    event_name: string;
    properties: {
        [key: string]: unknown;
    };
};

export type MixpanelProxyRequest = {
    people_set: {
        [key: string]: unknown;
    };
    people_set_once: {
        [key: string]: unknown;
    };
    super_properties: {
        [key: string]: unknown;
    };
    events: Array<MixpanelEventRequest>;
};

/**
 * * `fal-ai/flux/dev` - Flux Dev
 * * `fal-ai/flux/schnell` - Flux Schnell
 * * `fal-ai/imagen4/preview` - Imagen4
 * * `fal-ai/nano-banana` - Nano Banana
 * * `fal-ai/nano-banana-pro` - Nano Banana Pro
 * * `fal-ai/nano-banana-2` - Nano Banana 2
 * * `fal-ai/imagen3` - Imagen3
 * * `fal-ai/flux-pro/v1.1` - Flux Pro 1 1
 * * `fal-ai/recraft-v3` - Recraft V3
 * * `fal-ai/birefnet/v2` - Briefnet V2
 * * `fal-ai/nano-banana/edit` - Nano Banana Edit
 * * `fal-ai/nano-banana-pro/edit` - Nano Banana Pro Edit
 * * `fal-ai/nano-banana-2/edit` - Nano Banana 2 Edit
 * * `fal-ai/flux-kontext/dev` - Flux Kontext Dev
 * * `gpt-image-1` - Gpt Image 1
 * * `fal-ai/flux/dev/image-to-image` - Flux Dev Kontext
 * * `fal-ai/flux-pro/kontext` - Flux Pro Kontext
 * * `fal-ai/veo3.1/fast` - Veo3 1 Fast
 * * `fal-ai/veo3.1` - Veo3 1
 * * `fal-ai/wan/v2.2-a14b/text-to-video/turbo` - Wan 2 2 Turbo
 * * `fal-ai/sora-2/text-to-video/pro` - Sora 2 Pro
 * * `fal-ai/sora-2/text-to-video` - Sora 2
 * * `fal-ai/veo3.1/image-to-video` - Veo3 1 Image To Video
 * * `fal-ai/veo3.1/fast/image-to-video` - Veo3 1 Fast Image To Video
 * * `fal-ai/veo3.1/fast/first-last-frame-to-video` - Veo3 1 Fast First Last Frame
 * * `fal-ai/veo3.1/reference-to-video` - Veo3 1 Reference To Video
 * * `fal-ai/wan/v2.2-a14b/image-to-video/turbo` - Wan 2 2 Turbo
 * * `fal-ai/kling-video/o1/reference-to-video` - Kling O1 Reference
 * * `fal-ai/sora-2/image-to-video/pro` - Sora 2 Pro
 * * `fal-ai/sora-2/image-to-video` - Sora 2
 */
export enum ModelNameEnum {
    FAL_AI_FLUX_DEV = 'fal-ai/flux/dev',
    FAL_AI_FLUX_SCHNELL = 'fal-ai/flux/schnell',
    FAL_AI_IMAGEN4_PREVIEW = 'fal-ai/imagen4/preview',
    FAL_AI_NANO_BANANA = 'fal-ai/nano-banana',
    FAL_AI_NANO_BANANA_PRO = 'fal-ai/nano-banana-pro',
    FAL_AI_NANO_BANANA_2 = 'fal-ai/nano-banana-2',
    FAL_AI_IMAGEN3 = 'fal-ai/imagen3',
    FAL_AI_FLUX_PRO_V1_1 = 'fal-ai/flux-pro/v1.1',
    FAL_AI_RECRAFT_V3 = 'fal-ai/recraft-v3',
    FAL_AI_BIREFNET_V2 = 'fal-ai/birefnet/v2',
    FAL_AI_NANO_BANANA_EDIT = 'fal-ai/nano-banana/edit',
    FAL_AI_NANO_BANANA_PRO_EDIT = 'fal-ai/nano-banana-pro/edit',
    FAL_AI_NANO_BANANA_2_EDIT = 'fal-ai/nano-banana-2/edit',
    FAL_AI_FLUX_KONTEXT_DEV = 'fal-ai/flux-kontext/dev',
    GPT_IMAGE_1 = 'gpt-image-1',
    FAL_AI_FLUX_DEV_IMAGE_TO_IMAGE = 'fal-ai/flux/dev/image-to-image',
    FAL_AI_FLUX_PRO_KONTEXT = 'fal-ai/flux-pro/kontext',
    FAL_AI_VEO3_1_FAST = 'fal-ai/veo3.1/fast',
    FAL_AI_VEO3_1 = 'fal-ai/veo3.1',
    FAL_AI_WAN_V2_2_A14B_TEXT_TO_VIDEO_TURBO = 'fal-ai/wan/v2.2-a14b/text-to-video/turbo',
    FAL_AI_SORA_2_TEXT_TO_VIDEO_PRO = 'fal-ai/sora-2/text-to-video/pro',
    FAL_AI_SORA_2_TEXT_TO_VIDEO = 'fal-ai/sora-2/text-to-video',
    FAL_AI_VEO3_1_IMAGE_TO_VIDEO = 'fal-ai/veo3.1/image-to-video',
    FAL_AI_VEO3_1_FAST_IMAGE_TO_VIDEO = 'fal-ai/veo3.1/fast/image-to-video',
    FAL_AI_VEO3_1_FAST_FIRST_LAST_FRAME_TO_VIDEO = 'fal-ai/veo3.1/fast/first-last-frame-to-video',
    FAL_AI_VEO3_1_REFERENCE_TO_VIDEO = 'fal-ai/veo3.1/reference-to-video',
    FAL_AI_WAN_V2_2_A14B_IMAGE_TO_VIDEO_TURBO = 'fal-ai/wan/v2.2-a14b/image-to-video/turbo',
    FAL_AI_KLING_VIDEO_O1_REFERENCE_TO_VIDEO = 'fal-ai/kling-video/o1/reference-to-video',
    FAL_AI_SORA_2_IMAGE_TO_VIDEO_PRO = 'fal-ai/sora-2/image-to-video/pro',
    FAL_AI_SORA_2_IMAGE_TO_VIDEO = 'fal-ai/sora-2/image-to-video'
}

/**
 * * `text_to_image` - Text To Image
 * * `image_to_image` - Image To Image
 * * `text_to_video` - Text To Video
 * * `image_to_video` - Image To Video
 */
export enum ModelTypeEnum {
    TEXT_TO_IMAGE = 'text_to_image',
    IMAGE_TO_IMAGE = 'image_to_image',
    TEXT_TO_VIDEO = 'text_to_video',
    IMAGE_TO_VIDEO = 'image_to_video'
}

/**
 * * `recommended` - Recommended
 * * `starred` - Starred
 * * `off` - Off
 */
export enum MusicRecommendationModeEnum {
    RECOMMENDED = 'recommended',
    STARRED = 'starred',
    OFF = 'off'
}

export type MusicRecommendationRequest = {
    text: string;
    min_duration?: number;
    music_recommendation_mode?: (MusicRecommendationModeEnum);
};

export type MuteAudioRequest = {
    input_url: string;
    start_time_millis: number;
    end_time_millis: number;
};

export type MuteAudioResponse = {
    output_url: string;
};

/**
 * * `text` - Text
 * * `voiceover` - Voiceover
 * * `talking_head` - Talking Head
 */
export enum NarrativeThreadEnum {
    TEXT = 'text',
    VOICEOVER = 'voiceover',
    TALKING_HEAD = 'talking_head'
}

export type NonBlankTranscriptWord = {
    word: string;
    startTime: number;
    endTime: number;
    filler: boolean;
};

export type Notification = {
    readonly id: number;
    type: NotificationTypeEnum;
    recipient: number;
    content: string;
    read_status: boolean;
    url: string;
    readonly created_at: string;
    photo_url: (string) | null;
    photo_fallback: (string) | null;
};

export type NotificationSettings = {
    newsletter_emails_unsubscribed: boolean;
    render_emails_unsubscribed: boolean;
    support_emails_unsubscribed: boolean;
    training_emails_unsubscribed: boolean;
    notification_emails_unsubscribed: boolean;
    has_opt_in_newsletter_emails: (boolean) | null;
};

/**
 * * `VIDEO_APPROVAL_STATUS` - Video Approval Status
 * * `COMMENT_MENTION` - Comment Mention
 * * `COMMENT_REPLY` - Comment Reply
 * * `RENDER_SUCCESS` - Render Success
 * * `RENDER_FAILURE` - Render Failure
 * * `UNSPECIFIED` - Unspecified
 */
export enum NotificationTypeEnum {
    VIDEO_APPROVAL_STATUS = 'VIDEO_APPROVAL_STATUS',
    COMMENT_MENTION = 'COMMENT_MENTION',
    COMMENT_REPLY = 'COMMENT_REPLY',
    RENDER_SUCCESS = 'RENDER_SUCCESS',
    RENDER_FAILURE = 'RENDER_FAILURE',
    UNSPECIFIED = 'UNSPECIFIED'
}

export type NotificationsNumUnread = {
    count: number;
};

export type PaginatedAIVoiceList = {
    count: number;
    next: (string) | null;
    previous: (string) | null;
    results: Array<AIVoice>;
};

export type PaginatedAsyncOperationList = {
    count: number;
    next: (string) | null;
    previous: (string) | null;
    results: Array<AsyncOperation>;
};

export type PaginatedAuditLogList = {
    count: number;
    next: (string) | null;
    previous: (string) | null;
    results: Array<AuditLog>;
    total_page_count: number;
    current_page: number;
};

export type PaginatedDashboardVideoList = {
    count: number;
    next: (string) | null;
    previous: (string) | null;
    results: Array<DashboardVideo>;
};

export type PaginatedTemplateInfoResponseList = {
    count: number;
    next: (string) | null;
    previous: (string) | null;
    results: Array<TemplateInfoResponse>;
};

export type PasswordResetRedemptionRequest = {
    password: string;
    password_repeat: string;
    public_uuid: string;
};

export type PasswordResetRedemptionResponse = {
    token: string;
    password: string;
    password_repeat: string;
};

export type PatchedArticleUpdateContentRequest = {
    /**
     * If true, the article content will be fully reset
     */
    reset?: boolean;
    original_content?: {
        [key: string]: unknown;
    };
    /**
     * Script in our custom format
     */
    serialized_script?: unknown;
};

export type PatchedBlueprintRequest = {
    name?: string;
    user?: number;
    workspace?: number;
    default_template_id?: string;
    default_aspect_ratio?: AspectRatio;
    narrative_thread?: NarrativeThreadEnum;
    video_ids?: Array<(number)>;
    description?: (string) | null;
    draft_video_ids?: Array<(number)>;
    ai_avatar?: (number) | null;
    /**
     * Global caption scene design ID (e.g., global_template:fancy_caption) for this blueprint
     */
    caption_scene_design_id?: (string) | null;
    is_temporary?: boolean;
    /**
     * For public blueprints, allows for filtering to specific product use cases
     *
     * * `sketch` - Sketch
     * * `spinoff` - Spinoff
     * * `clip_creator` - Clip Creator
     */
    use_case?: ((UseCaseEnum) | null);
    /**
     * Custom instructions for the blueprint that guide AI video generation
     */
    custom_instructions?: (string) | null;
};

export type PatchedDatasetMetadataRequest = {
    dataset_metadata?: unknown;
};

export type PatchedDisplayGroupRequest = {
    display_name?: string;
    template?: string;
    order?: number;
};

export type PatchedDocumentsRequest = {
    url?: string;
    name?: string;
};

export type PatchedEvalGradeCreateRequest = {
    evalRunShotId?: number;
    stage?: StageEnum;
    score?: number;
    notes?: string;
};

export type PatchedEvalRunShotUpdateRequest = {
    imageAssetUuid?: string;
    videoAssetUuid?: string;
    imageStatus?: ImageStatusEnum;
    videoStatus?: VideoStatusEnum;
};

export type PatchedEvalRunUpdateRequest = {
    status?: EvalRunUpdateStatusEnum;
    notes?: string;
    imageCreditsUsed?: number;
    videoCreditsUsed?: number;
};

export type PatchedEvalScriptCreateRequest = {
    title?: string;
    scriptText?: string;
    order?: number;
};

export type PatchedEvalSetCreateRequest = {
    name?: string;
    description?: string;
};

export type PatchedGenXPresetBuilderScenarioRequest = {
    text?: string;
    order?: number;
};

export type PatchedMediaFolderRequest = {
    name?: string;
    creation_source?: string;
};

export type PatchedMoveMultipleVideosRequest = {
    target_project_id?: (number) | null;
    target_workspace_id?: (number) | null;
    video_ids?: Array<(number)>;
};

export type PatchedNotificationSettingsRequest = {
    newsletter_emails_unsubscribed?: boolean;
    render_emails_unsubscribed?: boolean;
    support_emails_unsubscribed?: boolean;
    training_emails_unsubscribed?: boolean;
    notification_emails_unsubscribed?: boolean;
    has_opt_in_newsletter_emails?: (boolean) | null;
};

export type PatchedProjectRequest = {
    name?: string;
    icon?: ProjectIcon;
    color?: ProjectColorCode;
    added_members?: Array<(number)>;
    removed_members?: Array<(number)>;
    archived?: boolean;
};

export type PatchedPublicBlueprintRequest = {
    name?: string;
    user?: (string) | null;
    workspace?: (string) | null;
    default_template_id?: string;
    default_aspect_ratio?: AspectRatio;
    narrative_thread?: NarrativeThreadEnum;
    video_ids?: Array<(number)>;
    description?: (string) | null;
    draft_video_ids?: Array<(number)>;
    ai_avatar?: (number) | null;
    /**
     * Global caption scene design ID (e.g., global_template:fancy_caption) for this blueprint
     */
    caption_scene_design_id?: (string) | null;
    is_temporary?: boolean;
    /**
     * For public blueprints, allows for filtering to specific product use cases
     *
     * * `sketch` - Sketch
     * * `spinoff` - Spinoff
     * * `clip_creator` - Clip Creator
     */
    use_case?: ((UseCaseEnum) | null);
    /**
     * Custom instructions for the blueprint that guide AI video generation
     */
    custom_instructions?: (string) | null;
};

export type PatchedSSOIdPConfigRequest = {
    entity_id?: string;
    idp_signin_url?: string;
    public_certificate?: string;
    first_name_attribute_name?: string;
    last_name_attribute_name?: string;
    email_attribute_name?: string;
};

export type PatchedSceneDesignRequest = {
    id?: string;
    template?: string;
    order?: number;
    status?: TemplateStatusEnum;
    landscape_data?: unknown;
    square_data?: unknown;
    vertical_data?: unknown;
    fourfive_data?: unknown;
    scene_attributes_recommendation?: SceneAttributesRecommendationRequest;
    display_group?: number;
    display_name?: (string) | null;
    non_recommendable_assets?: Array<(string)> | null;
};

/**
 * plan_name: the name of the plan requested
 * email: the email of the user, collected on the stripe form
 * coupon: the coupon used by the customer ('' if there is no coupon)
 * with_trial: true if the user is requesting a free trial, otherwise false
 * trial_end_date: the milliseconds since Jan 1, 1970, when the trial should end.
 *
 * NOTE: the validated data will also contain two additional properties:
 * - plan: the plan object
 * - trial_end_datetime: datetime object of the trial end, None if no trial applies
 * Furthermore, the following are removed from the validated data:
 * - trial_end_date
 * - with_trial
 */
export type PatchedSubscriptionUpdateRequest = {
    plan_name?: string;
    email?: string;
    coupon?: string;
    with_trial?: boolean;
    trial_end_date?: (number) | null;
    seat_quantity?: (number) | null;
    success_path?: string;
    cancel_path?: string;
};

export type PatchedTeamSettingsRequest = {
    mfa_required?: boolean;
    sso_idp_config?: ((SSOIdPConfigRequest) | null);
    sso_login_status?: SsoLoginStatusEnum;
    auto_blueprint_recommendations_enabled?: boolean;
};

export type PatchedTemplateRequest = {
    id?: string;
    order?: number;
    status?: TemplateStatusEnum;
    display_name?: string;
    /**
     * Provide a single paragraph describing what this template is best used for (content types, topics, industries) and its visual style/feel. This helps the AI recommend the right template when users create videos in Sketch. Example: 'Modern template with bold typography and vibrant colors, ideal for product launches, announcements, and promotional content. Style is energetic and attention-grabbing.'
     */
    description?: (string) | null;
    default_scene_design?: (string) | null;
    default_storyboard_scene_design?: (string) | null;
    default_outro_scene_design?: (string) | null;
    default_icon_scene_design?: (string) | null;
    template_category?: number;
    image_url?: (string) | null;
    mp4_url?: (string) | null;
    landscape_mp4_url?: (string) | null;
    square_mp4_url?: (string) | null;
    vertical_mp4_url?: (string) | null;
    fourfive_mp4_url?: (string) | null;
    text_min_size?: number;
    text_max_size?: number;
    /**
     * Format: 45, 55, 70, 90, 150
     */
    default_text_size_options?: Array<(number)>;
    default_talking_head_scene_design?: (string) | null;
    default_caption_scene_design?: (string) | null;
    /**
     * Danger! Easy to make mistakes. Only edit this in an emergency!
     */
    template_data?: unknown;
    palette_data?: unknown;
    teams?: Array<(number)>;
    color_shuffle_enabled?: boolean;
    default_voiceover_scene_design?: (string) | null;
    default_cutaway_scene_design?: (string) | null;
    /**
     * Default aspect ratio to select when users choose this template
     *
     * * `landscape` - Landscape
     * * `square` - Square
     * * `vertical` - Vertical
     * * `fourfive` - Fourfive
     */
    default_aspect_ratio?: ((AspectRatio) | null);
    allow_global_scene_designs?: boolean;
};

export type PatchedUserProfileRequest = {
    id?: number;
    first_name?: string;
    last_name?: string;
    email?: string;
    is_staff?: boolean;
    photo_url?: (string) | null;
    role?: RoleEnum;
    two_factor_activated?: (boolean) | null;
    permissions?: Array<UserPermissions>;
};

export type PatchedVideoApprovalStatusRequest = {
    video?: number;
    assigner?: number;
    assignee?: (number) | null;
    status?: ((VideoApprovalStatusEnum) | null);
};

export type PatchedVideoRequest = {
    name?: string;
    video_data?: {
        [key: string]: unknown;
    };
    archived?: boolean;
    user_overrides?: unknown;
    document?: DocumentRequest;
    creation_duration?: (number) | null;
    media_tab_duration?: (number) | null;
    music_tab_duration?: (number) | null;
    style_tab_duration?: (number) | null;
    format_tab_duration?: (number) | null;
    voiceover_tab_duration?: (number) | null;
    original_content_tab_duration?: (number) | null;
    transcripts?: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    visibility?: VideoVisibility;
    /**
     * String containing all the text in the video used for search
     */
    script?: string;
    template_id?: string;
    brand_kit_id?: (number) | null;
    blueprint_id?: (number) | null;
    creation_source?: ((CreationSourceEnum) | null);
    edit_parent_language?: (string) | null;
    script_composer_data?: ((ScriptComposerDataRequest) | null);
    video_init_type?: (string) | null;
    /**
     * The auto-detected language of the video
     */
    language?: string;
    aspect_ratio?: AspectRatio;
    narrative_threads?: Array<NarrativeThreadEnum> | null;
    async_generation_id?: (string) | null;
    async_generation_data?: unknown;
    /**
     * List of tags for categorizing and filtering videos
     */
    tags?: Array<(string)>;
};

export type PatchedWorkspaceRequest = {
    name?: string;
    editors_require_approval_to_publish?: boolean;
    default_visibility?: VideoVisibility;
    slug?: string;
    enable_editor_advanced_settings?: (boolean) | null;
    public_template_visibility?: PublicTemplateVisibilityEnum;
    ai_context_enabled?: (boolean) | null;
    media_guidance?: (string) | null;
};

export type PauseSubscriptionRequest = {
    duration_months?: (number) | null;
};

export type PauseSubscriptionResponse = {
    status: StatusEnum;
    reason: (string) | null;
    resume_date: (string) | null;
};

export type PaymentMethodCheckoutSessionRequest = {
    selected_plan?: string;
    source?: string;
    success_path?: string;
    cancel_path?: string;
};

export type PaymentMethodCheckoutSessionResponse = {
    checkout_session_id: string;
};

export type PaymentMethodStatus = {
    has_payment_configured: boolean;
};

/**
 * * `auto` - Auto
 * * `first_person` - First Person
 * * `third_person` - Third Person
 */
export enum PerspectiveEnum {
    AUTO = 'auto',
    FIRST_PERSON = 'first_person',
    THIRD_PERSON = 'third_person'
}

export type Plan = {
    name: string;
    display_name: string;
    description: string;
    price: number;
    billing_cycle: BillingCycleEnum;
    deprecated: boolean;
    featured: boolean;
    features: PlanFeatures;
    highlights: Array<PlanHighlight>;
    is_enterprise: boolean;
    is_trial: boolean;
    hide_in_public_pricing_page: boolean;
};

export type PlanFeatures = {
    no_branding: boolean;
    max_brand_kits: number;
    cc_media: boolean;
    getty_media: boolean;
    shutterstock_media: boolean;
    getty_unlimited_media: boolean;
    shutterstock_unlimited_media: boolean;
    render_720p: boolean;
    render_1080p: boolean;
    custom_watermark: boolean;
    custom_font: boolean;
    upload_media: boolean;
    upload_stickers: boolean;
    theming_settings: boolean;
    script_generation_duration_control: boolean;
    premium_ai_voices: boolean;
    default_team_seats: number;
    max_workspaces: number;
    num_videos_per_month: (number) | null;
    max_video_duration_seconds: (number) | null;
    num_ai_vo_minutes_per_month: (number) | null;
    preset_themes: boolean;
    custom_themes: boolean;
    chat_support: boolean;
    asset_credits: number;
    public_asset_credits: number;
    enable_team_invite: boolean;
    video_approval_status: boolean;
    max_translations_per_month: (number) | null;
    purchased_seat_ceiling: number;
    voiceover: boolean;
    unlimited_invitations: boolean;
    ai_avatar: boolean;
    has_audit_log: boolean;
    max_ai_media_credits_per_month: (number) | null;
};

export type PlanHighlight = {
    text1: string;
    text2: (string) | null;
    text3: (string) | null;
    tooltip: (string) | null;
};

export type PolymorphicAsset = GenerateTextAssetMetadata | GenerateMediaAssetMetadata | GenerateIconAssetMetadata;

export type PrefetchMediaCandidatesRequest = {
    video_id: number;
    script: string;
    media_options?: ((MediaOptionsRequest) | null);
};

export type PremiumMedia = {
    total_active_credit_availability: number;
    total_active_credit_expense: number;
};

export type PremiumMediaCreditCheckRequest = {
    video_data: string;
};

export type PremiumMediaCreditCheckResponse = {
    credits_in_data: number;
};

export type PremiumMediaError = {
    credits_available: number;
    credits_used: number;
    additional_credits_required: number;
};

export type PricingPlans = {
    monthly_plans: Array<Plan>;
    annual_plans: Array<Plan>;
    coupon_status: CouponStatus;
};

export type Project = {
    readonly id: number;
    name: string;
    icon: ProjectIcon;
    color: ProjectColorCode;
    archived: boolean;
    readonly workspace: number;
};

/**
 * * `#5846F6` - Primary
 * * `#4636C5` - Primary Dark
 * * `#02D3DA` - Accent
 * * `#017D9C` - Accent Dark
 * * `#F8558E` - Accent Alt
 * * `#CC376E` - Accent Alt Dark
 * * `#49D66E` - Success
 * * `#249A5A` - Success Dark
 * * `#21BCFF` - Info
 * * `#106EB7` - Info Dark
 * * `#FFA101` - Warning
 * * `#B86600` - Warning Dark
 * * `#FF4B38` - Error
 * * `#B71C26` - Error Dark
 * * `#9FAABF` - Grey
 * * `#5D6575` - Grey Dark
 */
export enum ProjectColorCode {
    _5846F6 = '#5846F6',
    _4636C5 = '#4636C5',
    _02D3DA = '#02D3DA',
    _017D9C = '#017D9C',
    _F8558E = '#F8558E',
    _CC376E = '#CC376E',
    _49D66E = '#49D66E',
    _249A5A = '#249A5A',
    _21BCFF = '#21BCFF',
    _106EB7 = '#106EB7',
    _FFA101 = '#FFA101',
    _B86600 = '#B86600',
    _FF4B38 = '#FF4B38',
    _B71C26 = '#B71C26',
    _9FAABF = '#9FAABF',
    _5D6575 = '#5D6575'
}

/**
 * * `folder_open` - Folder Open
 * * `alarm` - Alarm
 * * `business` - Business
 * * `photo_camera` - Photo Camera
 * * `leaderboard` - Bar Chart
 * * `favorite_border` - Favorite Border
 * * `filter_vintage` - Filter Vintage
 * * `people` - People
 * * `headphones` - Headphones
 * * `book` - Book
 * * `laptop` - Laptop
 * * `map` - Map
 * * `mail` - Mail
 * * `mode_night` - Mode Night
 * * `monetization_on` - Monetization On
 * * `mood` - Mood
 * * `business_center` - Business Center
 * * `calendar_today` - Calendar Today
 * * `notifications` - Notifications
 * * `flag` - Flag
 * * `category` - Category
 */
export enum ProjectIcon {
    FOLDER_OPEN = 'folder_open',
    ALARM = 'alarm',
    BUSINESS = 'business',
    PHOTO_CAMERA = 'photo_camera',
    LEADERBOARD = 'leaderboard',
    FAVORITE_BORDER = 'favorite_border',
    FILTER_VINTAGE = 'filter_vintage',
    PEOPLE = 'people',
    HEADPHONES = 'headphones',
    BOOK = 'book',
    LAPTOP = 'laptop',
    MAP = 'map',
    MAIL = 'mail',
    MODE_NIGHT = 'mode_night',
    MONETIZATION_ON = 'monetization_on',
    MOOD = 'mood',
    BUSINESS_CENTER = 'business_center',
    CALENDAR_TODAY = 'calendar_today',
    NOTIFICATIONS = 'notifications',
    FLAG = 'flag',
    CATEGORY = 'category'
}

export type ProjectRequest = {
    name?: string;
    icon?: ProjectIcon;
    color?: ProjectColorCode;
    added_members?: Array<(number)>;
    removed_members?: Array<(number)>;
    archived?: boolean;
};

export type Pronunciation = {
    readonly id: number;
    readonly team: number;
    target_word: string;
    pronunciation: string;
    language: LanguageEnum;
    readonly language_full_name: string;
};

export type PronunciationRequest = {
    target_word: string;
    pronunciation: string;
    language: LanguageEnum;
};

/**
 * * `cloudinary` - Cloudinary
 * * `ap` - Ap
 * * `bynder` - Bynder
 * * `acquia` - Acquia
 * * `frontify` - Frontify
 * * `brandfolder` - Brandfolder
 */
export enum ProviderEnum {
    CLOUDINARY = 'cloudinary',
    AP = 'ap',
    BYNDER = 'bynder',
    ACQUIA = 'acquia',
    FRONTIFY = 'frontify',
    BRANDFOLDER = 'brandfolder'
}

export type PublicBlueprint = {
    readonly id: number;
    name: string;
    readonly supported_templates: Array<(string)>;
    readonly supported_templates_data: {
        [key: string]: {
            video_id: number;
            poster_url: string;
        };
    };
    default_template_id: string;
    default_aspect_ratio: AspectRatio;
    readonly default_target_duration_seconds: number;
    readonly min_scene_count: (number) | null;
    narrative_thread: NarrativeThreadEnum;
    video_ids: Array<(number)>;
    readonly poster_url: string;
    description: (string) | null;
    draft_video_ids: Array<(number)>;
    readonly ai_voice: (string) | null;
    ai_avatar: (number) | null;
    /**
     * Global caption scene design ID (e.g., global_template:fancy_caption) for this blueprint
     */
    caption_scene_design_id: (string) | null;
    is_temporary: boolean;
    /**
     * Returns whether the blueprint is public or not.
     * A blueprint is considered public if it has no user or workspace associated with it.
     */
    readonly is_public: boolean;
    /**
     * For public blueprints, allows for filtering to specific product use cases
     *
     * * `sketch` - Sketch
     * * `spinoff` - Spinoff
     * * `clip_creator` - Clip Creator
     */
    use_case: ((UseCaseEnum) | null);
    readonly display_group: (BlueprintDisplayGroup);
    readonly display_order: number;
    /**
     * Custom instructions for the blueprint that guide AI video generation
     */
    custom_instructions: (string) | null;
};

export type PublicBlueprintRequest = {
    name: string;
    user?: (string) | null;
    workspace?: (string) | null;
    default_template_id: string;
    default_aspect_ratio?: AspectRatio;
    narrative_thread: NarrativeThreadEnum;
    video_ids?: Array<(number)>;
    description?: (string) | null;
    draft_video_ids?: Array<(number)>;
    ai_avatar?: (number) | null;
    /**
     * Global caption scene design ID (e.g., global_template:fancy_caption) for this blueprint
     */
    caption_scene_design_id?: (string) | null;
    is_temporary?: boolean;
    /**
     * For public blueprints, allows for filtering to specific product use cases
     *
     * * `sketch` - Sketch
     * * `spinoff` - Spinoff
     * * `clip_creator` - Clip Creator
     */
    use_case?: ((UseCaseEnum) | null);
    /**
     * Custom instructions for the blueprint that guide AI video generation
     */
    custom_instructions?: (string) | null;
};

/**
 * * `visible` - Visible
 * * `admins_only` - Admins Only
 * * `hidden` - Hidden
 */
export enum PublicTemplateVisibilityEnum {
    VISIBLE = 'visible',
    ADMINS_ONLY = 'admins_only',
    HIDDEN = 'hidden'
}

/**
 * This endpoint should not contain any non-public info since it is included in video links.
 */
export type PublicUser = {
    first_name: string;
    last_name: string;
    readonly id: number;
    readonly photo_url: string;
};

export type PublicVideo = {
    slug: string;
    readonly id: number;
    readonly user_id: number;
    readonly workspace_id: number;
    readonly creation_date: (string) | null;
    readonly share_link: string;
    name: string;
    video_data: {
        [key: string]: unknown;
    };
    readonly status: (VideoStatus);
    readonly video_renders: Array<VideoRender>;
    visibility: VideoVisibility;
    readonly project_id: (number) | null;
    last_updated_by: PublicUser;
    last_updated_date: string;
    /**
     * Language this video was translated into (only set if video created by translation feature)
     */
    translated_language: (string) | null;
    creation_source: ((CreationSourceEnum) | null);
    edit_parent_language: (string) | null;
    readonly video_approval_status: (VideoApprovalStatusEnum);
};

export type PublishErrorDetails = {
    transitioned_asset_errors: ((TransitionedAssetErrorList) | null);
    premium_media_errors: ((PremiumMediaError) | null);
};

export type QueuedTaskResult = {
    task_id: string;
};

export type QueuedTaskResultRequest = {
    task_id: string;
};

export type QueuedTaskResultWithAiMediaCredits = {
    task_id: string;
    ai_media_credits_used_in_cycle: number;
    ai_media_credits_limit_per_cycle: (number) | null;
};

export type QueuedTaskResults = {
    task_ids: Array<(string)>;
};

export type ReceiptSubscriber = {
    email_address: string;
    readonly team: number;
    readonly id: number;
};

export type ReceiptSubscriberRequest = {
    email_address: string;
};

export type RecentTemplates = {
    template: ((Template) | null);
};

export type RegenerateTranscriptForAssetRequest = {
    asset_uuid: string;
    asset_type: TranscriptAssetType;
    language_code?: string;
};

export type ResetDocument = {
    document_id: number;
};

export type ResetDocumentRequest = {
    document_id: number;
};

export type ResolveReopenCommentsRequest = {
    video_id: number;
    scene_id: string;
    resolve_comments: boolean;
    /**
     * Required if resolve_comments is False
     */
    comment_id?: number;
};

export type ResumeSubscriptionResponse = {
    status: StatusEnum;
    reason: (string) | null;
};

/**
 * * `admin` - Admin
 * * `editor` - Editor
 * * `viewer` - Viewer
 * * `reviewer` - Reviewer
 */
export enum RoleEnum {
    ADMIN = 'admin',
    EDITOR = 'editor',
    VIEWER = 'viewer',
    REVIEWER = 'reviewer'
}

/**
 * This class MUST be instantiated with the user in the context, like this:
 * serializer = v2RSSFeedSerializer(feed, context={'user':request.user})
 */
export type RssFeed = {
    readonly creation_date: string;
    feed_url: string;
    readonly feed_title: string;
    readonly id: number;
    readonly deleted: boolean;
    readonly last_polled: string;
    active: boolean;
    readonly entries: Array<RssFeedEntry>;
};

export type RssFeedEntry = {
    title: string;
    url: string;
    readonly id: number;
    readonly image_url: string;
};

export type RssFeedEntryRequest = {
    title: string;
    url: string;
};

/**
 * This class MUST be instantiated with the user in the context, like this:
 * serializer = v2RSSFeedSerializer(feed, context={'user':request.user})
 */
export type RssFeedRequest = {
    feed_url: string;
    active?: boolean;
};

export type SSOIdPConfig = {
    readonly id: number;
    entity_id: string;
    idp_signin_url: string;
    public_certificate: string;
    first_name_attribute_name: string;
    last_name_attribute_name: string;
    email_attribute_name: string;
};

export type SSOIdPConfigRequest = {
    entity_id: string;
    idp_signin_url: string;
    public_certificate: string;
    first_name_attribute_name: string;
    last_name_attribute_name: string;
    email_attribute_name: string;
};

export type SSOVerificationRequest = {
    email?: string;
    invite_uuid?: string;
};

export type SSOVerificationResponse = {
    idp: string;
};

export type SaveConversationRequest = {
    conversation_id: string;
    messages: Array<{
        [key: string]: unknown;
    }>;
    model: string;
    tools?: unknown;
    video_id?: (number) | null;
    task_type?: (string) | null;
    actual_latency?: (number) | null;
    media_registry?: unknown;
};

export type SaveVideoDataSnapshotRequest = {
    video_data: unknown;
    conversation_id: string;
};

export type SaveVideoDataSnapshotResponse = {
    video_data_id: string;
    url: string;
};

export type SceneAttributesRecommendation = {
    readonly id: number;
    brightness: BrightnessRecommendationOptions;
    text_position_landscape: ((TextPositionRecommendationOptions) | null);
    text_position_vertical: ((TextPositionRecommendationOptions) | null);
    text_position_square: ((TextPositionRecommendationOptions) | null);
    text_position_fourfive: ((TextPositionRecommendationOptions) | null);
    background_animation: BackgroundAnimationRecommendationOptions;
    crop: CropRecommendationOptions;
    timing: number;
};

export type SceneAttributesRecommendationRequest = {
    brightness: BrightnessRecommendationOptions;
    text_position_landscape?: ((TextPositionRecommendationOptions) | null);
    text_position_vertical?: ((TextPositionRecommendationOptions) | null);
    text_position_square?: ((TextPositionRecommendationOptions) | null);
    text_position_fourfive?: ((TextPositionRecommendationOptions) | null);
    background_animation: BackgroundAnimationRecommendationOptions;
    crop: CropRecommendationOptions;
    timing: number;
};

export type SceneAttributesResponse = {
    scene_design: string;
    text_pos: string;
    media_attributes: Array<MediaAttributesResponse>;
};

export type SceneDesign = {
    id: string;
    template: string;
    order: number;
    status: TemplateStatusEnum;
    landscape_data: unknown;
    square_data: unknown;
    vertical_data: unknown;
    fourfive_data: unknown;
    scene_attributes_recommendation: SceneAttributesRecommendation;
    display_group: number;
    display_name: (string) | null;
    non_recommendable_assets: Array<(string)> | null;
};

export type SceneDesignAnnotation = {
    scene_design_id: string;
    annotation: string;
};

export type SceneDesignIdsPerTemplate = {
    template_id: string;
    scene_design_ids: Array<(string)>;
};

export type SceneDesignRequest = {
    id: string;
    template: string;
    order: number;
    status: TemplateStatusEnum;
    landscape_data?: unknown;
    square_data?: unknown;
    vertical_data?: unknown;
    fourfive_data?: unknown;
    scene_attributes_recommendation: SceneAttributesRecommendationRequest;
    display_group: number;
    display_name?: (string) | null;
    non_recommendable_assets?: Array<(string)> | null;
};

export type SceneRecommendation = {
    index: number;
    text_words: Array<(string)>;
    scene_data: GenerateSceneMetadata;
};

export type ScoreHistory = {
    readonly runId: number;
    readonly createdAt: string;
    readonly imageModel: string;
    readonly videoModel: string;
    readonly notes: string;
    readonly avgImageScore: (number) | null;
    readonly avgVideoScore: (number) | null;
    readonly configSnapshot: unknown;
    readonly gradingConfigSnapshot: unknown;
};

export type ScriptComposerData = {
    page: (string) | null;
    edited_script: Array<ScriptSection>;
    selected_script_option: GenerateScriptOption;
    script_options: {
        [key: string]: Array<GenerateScriptOption>;
    };
    script_cache: {
        [key: string]: Array<ScriptSection>;
    };
    longest_supported_script_duration: (number) | null;
    skip_ai_summarization_stage: (boolean) | null;
    edited_script_initial_word_count: number;
    edited_script_language: ((LanguageEnum) | null);
    selected_ai_voice: (string) | null;
    import_type: (string) | null;
    idea_outline_data: ((IdeaOutlineData) | null);
    dashboard_flow: ((DashboardFlowEnum) | null);
};

export type ScriptComposerDataRequest = {
    page: (string) | null;
    edited_script?: Array<ScriptSectionRequest>;
    selected_script_option?: GenerateScriptOptionRequest;
    script_options?: {
        [key: string]: Array<GenerateScriptOptionRequest>;
    };
    script_cache?: {
        [key: string]: Array<ScriptSectionRequest>;
    };
    longest_supported_script_duration?: (number) | null;
    skip_ai_summarization_stage?: (boolean) | null;
    edited_script_initial_word_count?: number;
    edited_script_language?: ((LanguageEnum) | null);
    selected_ai_voice: (string) | null;
    import_type: (string) | null;
    idea_outline_data?: ((IdeaOutlineDataRequest) | null);
    dashboard_flow?: ((DashboardFlowEnum) | null);
};

export type ScriptData = {
    script: Array<SentenceWithHeader>;
};

export type ScriptOption = {
    type: (string) | null;
    title: string;
    description: string;
    duration_seconds: number;
};

export type ScriptOptionsRequest = {
    doctext: string;
    video_id: number;
    language?: ((LanguageEnum) | null);
};

export type ScriptOptionsResponse = {
    script_options: Array<ScriptOption>;
};

export type ScriptSection = {
    header: string;
    sentences: Array<(string)>;
};

export type ScriptSectionRequest = {
    header: string;
    sentences: Array<(string)>;
};

export type SegmentEditedTextResponse = {
    corrected_words_in_windows: Array<Array<NonBlankTranscriptWord>>;
};

/**
 * * `word` - word
 * * `sentence` - sentence
 */
export enum SegmentationTypeEnum {
    WORD = 'word',
    SENTENCE = 'sentence'
}

export type SendCommentMentionsRequest = {
    commenter_first_name: string;
    mentioned_user_email: string;
    comment_id: number;
    mentioned_user_id: (number) | null;
};

export type SendEmailVerificationRequest = {
    user_id: number;
};

export type SendMfaRecoveryCodeRequest = {
    email: string;
};

export type SentenceWithHeader = {
    header: string;
    sentences: Array<(string)>;
};

export type SerializedArticleChildNode = {
    text: string;
    index: number;
    url: string;
};

export type SerializedArticleNode = {
    type: string;
    value: Array<SerializedArticleChildNode>;
};

/**
 * * `0` - Image
 * * `1` - Video
 */
export enum SimilarAssetSourceTypeEnum {
    IMAGE = 0,
    VIDEO = 1
}

export type SimpleMessageResponse = {
    message: string;
};

export type SimpleTextCorrectionRequest = {
    original_words_in_windows: Array<Array<TranscriptWordRequest>>;
    text_corrected_windows: Array<(string)>;
    language: LanguageEnum;
};

export type SketchContextResponse = {
    /**
     * Custom/team templates
     */
    custom_templates: Array<TemplateOption>;
    /**
     * Public templates with descriptions
     */
    public_templates: Array<TemplateOption>;
    /**
     * Available blueprint options
     */
    blueprint_options: Array<BlueprintOption>;
    /**
     * User's recent video history
     */
    user_video_history: Array<UserVideoHistory>;
};

export type SketchResearchRequest = {
    research_topic: string;
};

export type SketchUrlFetchRequest = {
    /**
     * URL to fetch content from
     */
    url: string;
};

export type SketchVideoPlanValidationRequest = {
    /**
     * List of video plans to validate
     */
    plans: Array<VideoPlanRequest>;
};

export type SketchVideoPlanValidationResponse = {
    /**
     * Whether all plans are valid
     */
    valid: boolean;
    /**
     * List of validated video plan objects (only present if valid=True)
     */
    validated_plans: Array<VideoPlan>;
    /**
     * List of validation error messages (empty list when valid=True)
     */
    errors: Array<(string)>;
};

export type SketchWebImageSearchObject = {
    title: string;
    link: string;
};

export type SketchWebImageSearchRequest = {
    /**
     * The image search query string
     */
    query: string;
    num_results?: number;
    /**
     * Reasoning for why this image search is being performed
     */
    thoughts?: string;
};

export type SketchWebImageSearchResponse = {
    query: string;
    num_results_requested: number;
    num_results_found: number;
    num_assets_created: number;
    asset_uuids: Array<(string)>;
    search_results: Array<SketchWebImageSearchObject>;
};

/**
 * This is a base class that shouldn't really be instantiated ever.
 * It allows any serializer that inherits from it to call:
 *
 * .. code-block:: python
 *
 * >>> serializer.create_obj(serializer.validated_data)
 *
 * And return an object of the type indicated by python_class inside the Meta
 * class of the serializer.
 */
export type SlideBackgroundModel = {
    type: SlideBackgroundModelTypeEnum;
    video: ((VideoAssetModel) | null);
    image: ((ImageAssetModel) | null);
    readonly history_index_user_ids: Array<(number)> | null;
};

/**
 * This is a base class that shouldn't really be instantiated ever.
 * It allows any serializer that inherits from it to call:
 *
 * .. code-block:: python
 *
 * >>> serializer.create_obj(serializer.validated_data)
 *
 * And return an object of the type indicated by python_class inside the Meta
 * class of the serializer.
 */
export type SlideBackgroundModelRequest = {
    type: SlideBackgroundModelTypeEnum;
    video?: ((VideoAssetModelRequest) | null);
    image?: ((ImageAssetModelRequest) | null);
};

/**
 * * `image` - Image
 * * `video` - Video
 */
export enum SlideBackgroundModelTypeEnum {
    IMAGE = 'image',
    VIDEO = 'video'
}

export type SlideTranslatedText = {
    slide_id: string;
    message: string;
};

/**
 * * `most_relevant` - Most Relevant
 * * `latest` - Latest
 * * `earliest` - Earliest
 */
export enum SortEnum {
    MOST_RELEVANT = 'most_relevant',
    LATEST = 'latest',
    EARLIEST = 'earliest'
}

export type SoundEffectStyle = {
    readonly id: number;
    slug: string;
    name: string;
};

/**
 * * `source` - source
 * * `uploads` - uploads
 * * `stock` - stock
 */
export enum SourceCategoryEnum {
    SOURCE = 'source',
    UPLOADS = 'uploads',
    STOCK = 'stock'
}

export type SourceData = {
    source: number;
    source_id: string;
};

export type SourceDataRequest = {
    source: number;
    source_id: string;
};

/**
 * * `0` - User Uploaded Media
 * * `1` - User Uploaded Watermark
 * * `2` - User Uploaded Outro
 * * `3` - Noun Project
 * * `4` - Pexels
 * * `5` - Pixabay
 * * `6` - Unsplash
 * * `7` - Videoblocks
 * * `8` - Videvo
 * * `9` - Wikimedia
 * * `10` - Graphicstock
 * * `11` - Coverr
 * * `12` - Distill
 * * `13` - Article Media
 * * `14` - Lumen5 Colours
 * * `15` - Tenor
 * * `16` - Getty
 * * `17` - Incompetech
 * * `18` - Bensound
 * * `19` - Youtube Audio Library
 * * `20` - Lumen5 Fonts
 * * `21` - Lumen5 Assets
 * * `22` - Audioblocks
 * * `23` - Getty Unlimited
 * * `24` - Shutterstock Unlimited
 * * `25` - Shutterstock Essentials
 * * `26` - Shutterstock Premium
 * * `27` - Shutterstock Editorial
 * * `28` - User Uploaded Voice Recording
 * * `29` - Text-to-speech Voiceover
 * * `30` - Lumen5 Icons
 * * `31` - Shutterstock Choice
 * * `32` - Enhanced Audio
 * * `33` - AI Voiceover
 * * `35` - AI Avatar
 * * `36` - DAM Integration
 * * `37` - Shutterstock Audio
 * * `38` - AI Generated Media
 * * `39` - Web Search
 * * `34` - Document Upload
 * * `41` - User Uploaded Stickers
 * * `40` - Waveforms
 * * `42` - AI Generated Chart
 * * `43` - Lumen5 Chart Styles
 * * `44` - Lumen5 GEN-X Styles
 * * `45` - Lumen5 Sound Effects
 */
export enum SourceEnum {
    SOURCE_USER = 0,
    SOURCE_USER_WATERMARK = 1,
    SOURCE_USER_OUTRO = 2,
    SOURCE_NOUNPROJECT = 3,
    SOURCE_PEXELS = 4,
    SOURCE_PIXABAY = 5,
    SOURCE_UNSPLASH = 6,
    SOURCE_VIDEOBLOCKS = 7,
    SOURCE_VIDEVO = 8,
    SOURCE_WIKIMEDIA = 9,
    SOURCE_GRAPHICSTOCK = 10,
    SOURCE_COVERR = 11,
    SOURCE_WEDISTILL = 12,
    SOURCE_ARTICLE = 13,
    SOURCE_LUMEN5_COLOURS = 14,
    SOURCE_TENOR = 15,
    SOURCE_GETTY = 16,
    SOURCE_INCOMPETECH = 17,
    SOURCE_BENSOUND = 18,
    SOURCE_YOUTUBE_AUDIO_LIBRARY = 19,
    SOURCE_LUMEN5_FONTS = 20,
    SOURCE_LUMEN5_ASSETS = 21,
    SOURCE_AUDIOBLOCKS = 22,
    SOURCE_GETTY_UNLIMITED = 23,
    SOURCE_SHUTTERSTOCK_UNLIMITED = 24,
    SOURCE_SHUTTERSTOCK_ESSENTIALS = 25,
    SOURCE_SHUTTERSTOCK_PREMIUM = 26,
    SOURCE_SHUTTERSTOCK_EDITORIAL = 27,
    SOURCE_USER_VOICEOVER = 28,
    SOURCE_AUTO_VOICEOVER = 29,
    SOURCE_LUMEN5_ICONS_PREMIUM = 30,
    SOURCE_SHUTTERSTOCK_CHOICES = 31,
    SOURCE_AUDIO_ENHANCEMENT = 32,
    SOURCE_AI_VOICEOVER = 33,
    SOURCE_AI_AVATAR = 35,
    SOURCE_DAM = 36,
    SOURCE_SHUTTERSTOCK_AUDIO = 37,
    SOURCE_AI_GENERATED = 38,
    SOURCE_WEB_SEARCH = 39,
    SOURCE_DOCUMENT = 34,
    SOURCE_USER_STICKERS = 41,
    SOURCE_WAVEFORMS = 40,
    SOURCE_AI_CHART = 42,
    SOURCE_LUMEN5_CHART_STYLES = 43,
    SOURCE_LUMEN5_GENX_STYLES = 44,
    SOURCE_LUMEN5_SOUND_EFFECTS = 45
}

/**
 * * `off` - Off
 * * `pending` - Pending
 * * `optional` - Optional
 * * `required` - Required
 */
export enum SsoLoginStatusEnum {
    OFF = 'off',
    PENDING = 'pending',
    OPTIONAL = 'optional',
    REQUIRED = 'required'
}

/**
 * * `image` - image
 * * `video` - video
 */
export enum StageEnum {
    IMAGE = 'image',
    VIDEO = 'video'
}

/**
 * * `success` - Success
 * * `error` - Error
 */
export enum StatusEnum {
    SUCCESS = 'success',
    ERROR = 'error'
}

export type SubmitFeedbackRequest = {
    page: string;
    feedback: string;
};

export type Subscription = {
    price: number;
    is_monthly: boolean;
    trial_end_date: (string) | null;
    plan_deprecated: boolean;
    next_billing_date: (string) | null;
    status: (string) | null;
    cancel_at_period_end: boolean;
    is_paused: boolean;
    pause_resumes_at: (string) | null;
};

export type SubscriptionCreationResponse = {
    checkout_session_id: string;
};

/**
 * * `invalid_plan_name` - Invalid Plan Name
 * * `sca_required` - Sca Required
 * * `missing_subscription` - Missing Subscription
 * * `team_size_error` - Team Size Error
 * * `seat_ceiling_reached` - Seat Ceiling Reached
 * * `unsupported_feature` - Unsupported Feature
 * * `credit_card_declined` - Credit Card Declined
 * * `invalid_customer` - Invalid Customer
 */
export enum SubscriptionFailureReasons {
    INVALID_PLAN_NAME = 'invalid_plan_name',
    SCA_REQUIRED = 'sca_required',
    MISSING_SUBSCRIPTION = 'missing_subscription',
    TEAM_SIZE_ERROR = 'team_size_error',
    SEAT_CEILING_REACHED = 'seat_ceiling_reached',
    UNSUPPORTED_FEATURE = 'unsupported_feature',
    CREDIT_CARD_DECLINED = 'credit_card_declined',
    INVALID_CUSTOMER = 'invalid_customer'
}

/**
 * plan_name: the name of the plan requested
 * email: the email of the user, collected on the stripe form
 * coupon: the coupon used by the customer ('' if there is no coupon)
 * with_trial: true if the user is requesting a free trial, otherwise false
 * trial_end_date: the milliseconds since Jan 1, 1970, when the trial should end.
 *
 * NOTE: the validated data will also contain two additional properties:
 * - plan: the plan object
 * - trial_end_datetime: datetime object of the trial end, None if no trial applies
 * Furthermore, the following are removed from the validated data:
 * - trial_end_date
 * - with_trial
 */
export type SubscriptionUpdateRequest = {
    plan_name: string;
    email?: string;
    coupon?: string;
    with_trial?: boolean;
    trial_end_date?: (number) | null;
    seat_quantity?: (number) | null;
    success_path?: string;
    cancel_path?: string;
};

export type SubscriptionUpdateResponse = {
    status: SubscriptionUpdateResponseStatusEnum;
    reason: ((SubscriptionFailureReasons) | null);
    client_secret: (string) | null;
};

/**
 * * `ok` - ok
 * * `warning` - warning
 * * `error` - error
 */
export enum SubscriptionUpdateResponseStatusEnum {
    OK = 'ok',
    WARNING = 'warning',
    ERROR = 'error'
}

export type SuccessResponse = {
    success: boolean;
};

export type SuggestedBlueprint = {
    readonly id: number;
    narrative_thread: NarrativeThreadEnum;
    readonly video_id: string;
    template: string;
    readonly video_name: string;
    readonly duration: string;
    readonly poster_url: string;
    readonly preview_video_url: string;
    readonly video_data: string;
};

export type SuggestedMediaEntryResponse = {
    query: string;
    results: Array<SlideBackgroundModel>;
};

export type SuggestedMediaRequest = {
    sentence: string;
    script: string;
    search_count?: number;
};

export type SuggestedMediaResponse = {
    queries: Array<(string)>;
    search_results: Array<SuggestedMediaEntryResponse>;
};

export enum SupportedAIMediaAspectRatios {
    UNDEFINED = 'undefined',
    LANDSCAPE = '16:9',
    VERTICAL = '9:16',
    SQUARE = '1:1',
    FOURFIVE = '4:5'
}

export type SupportedLanguageLocales = {
    code: LanguageLocalesEnum;
    name: string;
};

export type SupportedLanguages = {
    code: LanguageEnum;
    name: string;
    text_direction: TextDirectionEnum;
    reading_speed: number;
    supports_translation: boolean;
    supports_ai_voiceover: boolean;
    show_as_speech_recognition_language: boolean;
    are_we_trying_to_support_this_language: boolean;
    words_separated_by_spaces: boolean;
    translation_locales: Array<SupportedLanguageLocales> | null;
};

export type SwitchTemplateForVideoRequest = {
    video_id: number;
    template_id: string;
    narrative_thread: NarrativeThreadEnum;
};

export type SwitchTemplateForVideoResponse = {
    video_id: number;
    task_id: string;
};

export type TaskResult = {
    status: TaskResultStatusEnum;
    message: string;
    partial_result: ((TaskResultResponse) | null);
    result: ((TaskResultResponse) | null);
    task_id: string;
};

export type TaskResultMessage = {
    uid: string;
    error: {
        [key: string]: unknown;
    } | null;
    type: TaskResultMessageTypeEnum;
    result: ((TaskResultResponse) | null);
    partial_result: ((TaskResultResponse) | null);
};

/**
 * * `TASK_RESULT` - TASK_RESULT
 */
export enum TaskResultMessageTypeEnum {
    TASK_RESULT = 'TASK_RESULT'
}

export type TaskResultResponse = AudioAssetModel | BatchTextToVoiceoverResponse | GenerateRecommendedVideoResponse | GenerateScriptResponse | AssetGenerationListResponse | ScriptOptionsResponse | VideoAsset | UpdateDocumentResponse | UpdateArticleResponse | GenerateTranscriptResponse | ZipVideoRendersResponse | VideoNameSuggestionResponse | SuggestedMediaResponse | ExportAuditLogResponse | ClipPlansResponse | TranscriptClipResponse | VoiceoverAssetResponse | MediaCandidates | TranslatedTranscript | VideoTextAssetsTranslationResponse | GroundhogAnalysisResponse | EditedTranscriptWord | AudioAssetSourceData | BlueprintAutoPickResponse | FaceDetectionResponse | BackgroundRemovalResponse | SketchWebImageSearchResponse | MediaConceptPreviewResponse;

/**
 * * `FAILURE` - FAILURE
 * * `PENDING` - PENDING
 * * `SUCCESS` - SUCCESS
 * * `REVOKED` - REVOKED
 */
export enum TaskResultStatusEnum {
    FAILURE = 'FAILURE',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    REVOKED = 'REVOKED'
}

export type TeamInvitation = {
    readonly id: number;
    status: TeamInvitationStatusEnum;
    recipient: TeammateUser;
    recipient_email: string;
    readonly creation_date: (string) | null;
    readonly public_uuid: string;
    workspaces: Array<(number)>;
    projects: Array<(number)>;
    role: RoleEnum;
    permissions: Array<UserPermissions>;
};

export type TeamInvitationCreateRequest = {
    recipient_emails: Array<(string)>;
    workspaces?: Array<(number)>;
    projects?: Array<(number)>;
    role?: RoleEnum;
    permissions?: Array<UserPermissions>;
};

export type TeamInvitationCreateResponse = {
    invites: Array<TeamInvitation> | null;
    has_pending_invites: Array<(string)> | null;
    has_paid_plan: Array<(string)> | null;
    insufficient_open_seats: Array<(string)> | null;
    already_in_team: Array<(string)> | null;
    invalid_invites: Array<(string)> | null;
};

/**
 * * `pending` - Pending
 * * `accepted` - Accepted
 * * `cancelled` - Cancelled
 */
export enum TeamInvitationStatusEnum {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    CANCELLED = 'cancelled'
}

export type TeamMergeStats = {
    workspaces: Array<(string)>;
    team_members: Array<(string)>;
    max_team_size: number;
    video_count: number;
    user_uploaded_video_count: number;
    user_uploaded_image_count: number;
    user_uploaded_audio_count: number;
    user_uploaded_font_count: number;
    user_uploaded_icon_count: number;
};

export type TeamSettings = {
    mfa_required: boolean;
    readonly can_request_video_approval: boolean;
    readonly purchased_seats: number;
    readonly purchased_seat_ceiling: number;
    readonly max_team_size: number;
    readonly date_joined_cycle_start_date: string;
    readonly date_joined_cycle_end_date: string;
    readonly videos_created_in_cycle: number;
    readonly can_use_ai_voiceover_flow: boolean;
    readonly can_use_ai_script_flow: boolean;
    readonly can_use_outline_an_idea: boolean;
    readonly can_use_premium_ai_voices: boolean;
    readonly max_video_duration_seconds: (number) | null;
    readonly max_videos_in_cycle: (number) | null;
    readonly max_ai_vo_minutes_per_month: (number) | null;
    sso_idp_config: ((SSOIdPConfig) | null);
    readonly can_see_sso_settings: boolean;
    sso_login_status: SsoLoginStatusEnum;
    readonly sso_use_signed_certificate: boolean;
    readonly can_use_editorial_media: boolean;
    readonly can_use_ai_avatar: boolean;
    readonly can_publish_ai_avatar: boolean;
    readonly can_translate_videos: boolean;
    readonly can_use_ai_media: boolean;
    readonly can_use_sketch: boolean;
    readonly can_use_screen_recording: boolean;
    readonly has_audit_log: boolean;
    readonly can_use_shutterstock_unlimited_media: boolean;
    auto_blueprint_recommendations_enabled: boolean;
};

export type TeammateUser = {
    first_name: string;
    last_name: string;
    email: string;
    readonly photo_url: string;
};

export type Template = {
    id: string;
    order: number;
    status: TemplateStatusEnum;
    display_name: string;
    /**
     * Provide a single paragraph describing what this template is best used for (content types, topics, industries) and its visual style/feel. This helps the AI recommend the right template when users create videos in Sketch. Example: 'Modern template with bold typography and vibrant colors, ideal for product launches, announcements, and promotional content. Style is energetic and attention-grabbing.'
     */
    description: (string) | null;
    default_scene_design: (string) | null;
    default_storyboard_scene_design: (string) | null;
    default_outro_scene_design: (string) | null;
    default_icon_scene_design: (string) | null;
    template_category: number;
    image_url: (string) | null;
    mp4_url: (string) | null;
    landscape_mp4_url: (string) | null;
    square_mp4_url: (string) | null;
    vertical_mp4_url: (string) | null;
    fourfive_mp4_url: (string) | null;
    text_min_size: number;
    text_max_size: number;
    /**
     * Format: 45, 55, 70, 90, 150
     */
    default_text_size_options: Array<(number)>;
    default_talking_head_scene_design: (string) | null;
    default_caption_scene_design: (string) | null;
    /**
     * Danger! Easy to make mistakes. Only edit this in an emergency!
     */
    template_data: unknown;
    palette_data: unknown;
    teams: Array<(number)>;
    color_shuffle_enabled: boolean;
    default_voiceover_scene_design: (string) | null;
    default_cutaway_scene_design: (string) | null;
    readonly supported_aspect_ratios: Array<(string)>;
    /**
     * Default aspect ratio to select when users choose this template
     *
     * * `landscape` - Landscape
     * * `square` - Square
     * * `vertical` - Vertical
     * * `fourfive` - Fourfive
     */
    default_aspect_ratio: ((AspectRatio) | null);
    allow_global_scene_designs: boolean;
};

export type TemplateAnnotations = {
    template_id: string;
    aspect_ratio: string;
    narrative_thread: string;
    scene_design_annotations: Array<SceneDesignAnnotation>;
};

export type TemplateCategory = {
    readonly id: number;
    display_name: string;
    order: number;
    readonly templates: Array<(string)>;
};

export type TemplateInfoItem = {
    id: string;
    aspect_ratio: Array<(string)>;
    description: (string) | null;
};

export type TemplateInfoResponse = {
    custom_templates: Array<TemplateInfoItem>;
    public_templates: Array<TemplateInfoItem>;
    template_ids: Array<(string)>;
};

export type TemplateOption = {
    id: string;
    description: string;
    aspect_ratio: Array<AspectRatio>;
};

export type TemplateRequest = {
    id: string;
    order: number;
    status: TemplateStatusEnum;
    display_name: string;
    /**
     * Provide a single paragraph describing what this template is best used for (content types, topics, industries) and its visual style/feel. This helps the AI recommend the right template when users create videos in Sketch. Example: 'Modern template with bold typography and vibrant colors, ideal for product launches, announcements, and promotional content. Style is energetic and attention-grabbing.'
     */
    description?: (string) | null;
    default_scene_design?: (string) | null;
    default_storyboard_scene_design?: (string) | null;
    default_outro_scene_design?: (string) | null;
    default_icon_scene_design?: (string) | null;
    template_category: number;
    image_url?: (string) | null;
    mp4_url?: (string) | null;
    landscape_mp4_url?: (string) | null;
    square_mp4_url?: (string) | null;
    vertical_mp4_url?: (string) | null;
    fourfive_mp4_url?: (string) | null;
    text_min_size: number;
    text_max_size: number;
    /**
     * Format: 45, 55, 70, 90, 150
     */
    default_text_size_options: Array<(number)>;
    default_talking_head_scene_design?: (string) | null;
    default_caption_scene_design?: (string) | null;
    /**
     * Danger! Easy to make mistakes. Only edit this in an emergency!
     */
    template_data: unknown;
    palette_data: unknown;
    teams?: Array<(number)>;
    color_shuffle_enabled?: boolean;
    default_voiceover_scene_design?: (string) | null;
    default_cutaway_scene_design?: (string) | null;
    /**
     * Default aspect ratio to select when users choose this template
     *
     * * `landscape` - Landscape
     * * `square` - Square
     * * `vertical` - Vertical
     * * `fourfive` - Fourfive
     */
    default_aspect_ratio?: ((AspectRatio) | null);
    allow_global_scene_designs?: boolean;
};

/**
 * * `draft` - Draft
 * * `active` - Active
 * * `archived` - Archived
 */
export enum TemplateStatusEnum {
    DRAFT = 'draft',
    ACTIVE = 'active',
    ARCHIVED = 'archived'
}

export type TemplateStyleVideoData = {
    video_data: string;
};

export type TextAssetTranslation = {
    scene_id: string;
    subscene_id: (string) | null;
    text_asset_id: string;
    translated_text: string;
    translated_text_highlights: Array<Array<(number)>>;
};

export type TextAssetsRequest = {
    scene_id: string;
    subscene_id: (string) | null;
    subscene_index: (number) | null;
    text_asset_id: string;
    text_asset_index: number;
    text: string;
    text_highlights: Array<Array<(number)>>;
};

/**
 * * `ltr` - Left To Right
 * * `rtl` - Right To Left
 */
export enum TextDirectionEnum {
    LTR = 'ltr',
    RTL = 'rtl'
}

/**
 * * `bottom_center` - Bottom Center
 * * `bottom_left` - Bottom Left
 * * `bottom_right` - Bottom Right
 * * `center` - Center
 * * `center_left` - Center Left
 * * `center_right` - Center Right
 * * `top_center` - Top Center
 * * `top_left` - Top Left
 * * `top_right` - Top Right
 * * `auto` - Auto
 */
export enum TextPositionRecommendationOptions {
    BOTTOM_CENTER = 'bottom_center',
    BOTTOM_LEFT = 'bottom_left',
    BOTTOM_RIGHT = 'bottom_right',
    CENTER = 'center',
    CENTER_LEFT = 'center_left',
    CENTER_RIGHT = 'center_right',
    TOP_CENTER = 'top_center',
    TOP_LEFT = 'top_left',
    TOP_RIGHT = 'top_right',
    AUTO = 'auto'
}

export type TextSegmentationRequest = {
    text: string;
    language_code?: string;
    segmentation_type: SegmentationTypeEnum;
};

export type TextSegmentationResponse = {
    words: Array<(string)>;
    sentences: Array<(string)>;
    text: string;
    language_code: string;
};

export type TextToVoiceoverRequest = {
    text: string;
    voice_preset: string;
    language_code?: string;
};

export type TextToVoiceoverResponse = {
    text: string;
    voice_preset: string;
    language_code: string;
    url: (string) | null;
    script_sentence: Array<TranscriptWord> | null;
    audible_duration: (number) | null;
};

export type TextTranslateRequest = {
    original_transcript: Array<TranscriptWordRequest>;
    original_language?: LanguageEnum;
    target_language: LanguageLocalesEnum;
    video_id?: (number) | null;
};

/**
 * A serializer for responses to sucessful CREATE requests to
 * the Favorites endpoint
 */
export type ToggleFavoritedAsset = {
    asset_type: AssetTypes;
    uuid: string;
    favorite: boolean;
};

/**
 * A serializer for responses to sucessful CREATE requests to
 * the Favorites endpoint
 */
export type ToggleFavoritedAssetRequest = {
    asset_type: AssetTypes;
    uuid: string;
    favorite: boolean;
};

export type TopUploadTagsResponseSerializers = {
    top_tags: Array<(string)>;
};

export type TrackVideoDownloadResponse = {
    status: string;
    error: string;
};

/**
 * * `video` - Talking Head
 * * `audio` - Voiceover
 */
export enum TranscriptAssetType {
    VIDEO = 'video',
    AUDIO = 'audio'
}

export type TranscriptClipRequest = {
    transcript_words: Array<TranscriptWordRequest>;
    language_code?: ((LanguageEnum) | null);
    clip_plan: ClipPlanRequest;
    allow_supercuts?: boolean;
};

export type TranscriptClipResponse = {
    clip: Array<ClipSegment>;
};

export type TranscriptWord = {
    word: string;
    startTime: number;
    endTime: number;
    filler: boolean;
};

export type TranscriptWordRequest = {
    word: string;
    startTime: number;
    endTime: number;
    filler?: boolean;
};

export type Transcription = {
    captions: Array<{
        [key: string]: unknown;
    }>;
    corrected_captions: Array<{
        [key: string]: unknown;
    }> | null;
    language_code: string;
};

export type TranscriptionRequest = {
    captions: Array<{
        [key: string]: unknown;
    }>;
    corrected_captions?: Array<{
        [key: string]: unknown;
    }> | null;
    language_code?: string;
};

export type TransientUrl = {
    url: string;
    description: string;
};

export type TransitionedAssetError = {
    sceneId: string;
    assetName: string;
    type: TransitionedAssetErrorTypeEnum;
    video: ((SourceData) | null);
    image: ((SourceData) | null);
    icon: ((SourceData) | null);
};

export type TransitionedAssetErrorList = {
    assets: Array<TransitionedAssetError>;
};

export type TransitionedAssetErrorListRequest = {
    assets: Array<TransitionedAssetErrorRequest>;
};

export type TransitionedAssetErrorRequest = {
    sceneId: string;
    assetName: string;
    type: TransitionedAssetErrorTypeEnum;
    video?: ((SourceDataRequest) | null);
    image?: ((SourceDataRequest) | null);
    icon?: ((SourceDataRequest) | null);
};

/**
 * * `video` - video
 * * `image` - image
 * * `icon` - icon
 */
export enum TransitionedAssetErrorTypeEnum {
    VIDEO = 'video',
    IMAGE = 'image',
    ICON = 'icon'
}

export type TranslatedTranscript = {
    translated_transcript: Array<TranscriptWord>;
};

export type TwoFactorAuthenticationResponse = {
    qr_uri: string;
    otp_secret: string;
};

export type UnifiedImageGenerationRequest = {
    prompt: string;
    asset_uuids?: Array<(string)>;
    openai_container_id?: (string) | null;
    openai_file_id?: (string) | null;
    model: ImageGenerationRequestModelEnum;
    aspect_ratio?: ((SupportedAIMediaAspectRatios) | null);
    video_id?: (number) | null;
    save_generation?: boolean;
    source?: (number) | null;
    usage_source?: ((UsageSourceEnum) | null);
};

export type UnreadCount = {
    unread_count: number;
};

export type UpdateArticleResponse = {
    serialized_article: Array<SerializedArticleNode>;
    article_language_code: LanguageEnum;
    is_too_short: boolean;
};

export type UpdateDocumentResponse = {
    serialized_document: Array<SerializedArticleNode>;
    document_language_code: LanguageEnum;
    document_url: string;
    document_id: number;
};

export type UpdateSpecificVideoResponse = {
    videoDataHash: string;
    share_page_url: string;
    language: ((LanguageEnum) | null);
};

export type UploadUrlsRequest = {
    type: UploadUrlsRequestTypeEnum;
    file_name: string;
    upload_id?: (string) | null;
    part_number?: (number) | null;
};

/**
 * * `single-request-upload` - Single Request Upload
 * * `initialize-multipart-upload` - Initialize Multipart Upload
 * * `part-of-multipart-upload` - Part Of Multipart Upload
 * * `complete-multipart-upload` - Complete Multipart Upload
 */
export enum UploadUrlsRequestTypeEnum {
    SINGLE_REQUEST_UPLOAD = 'single-request-upload',
    INITIALIZE_MULTIPART_UPLOAD = 'initialize-multipart-upload',
    PART_OF_MULTIPART_UPLOAD = 'part-of-multipart-upload',
    COMPLETE_MULTIPART_UPLOAD = 'complete-multipart-upload'
}

export type UploadUrlsResponse = {
    upload_url: string;
    file_name: string;
    async_operation_uuid: string;
};

export type UploadsMetadataUpdateRequest = {
    asset_id: number;
    asset_type: AssetTypes;
    asset_tags?: Array<(string)> | null;
    folder_id?: (number) | null;
    attribution?: (string) | null;
};

export type UploadsMetadataUpdateResponse = {
    new_src_folder_thumbnail_url: (string) | null;
    new_target_folder_thumbnail_url: (string) | null;
};

export type UsageLimit = {
    ai_vo_minutes_used_in_cycle: number;
    ai_vo_minutes_limit_per_cycle: (number) | null;
    usage_cycle: BillingCycleEnum;
    current_usage_cycle_start: string;
    current_usage_cycle_end: string;
    ai_media_credits_used_in_cycle: number;
    ai_media_credits_limit_per_cycle: (number) | null;
    translations_used_in_cycle: number;
    translations_limit_per_cycle: (number) | null;
};

/**
 * * `genx` - Genx
 * * `ai_media_tab` - Ai Media Tab
 */
export enum UsageSourceEnum {
    GENX = 'genx',
    AI_MEDIA_TAB = 'ai_media_tab'
}

/**
 * * `sketch` - Sketch
 * * `spinoff` - Spinoff
 * * `clip_creator` - Clip Creator
 */
export enum UseCaseEnum {
    SKETCH = 'sketch',
    SPINOFF = 'spinoff',
    CLIP_CREATOR = 'clip_creator'
}

export type UserAICreditCount = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    credits_used: number;
};

export type UserOverridesItemRequest = {
    duration?: boolean;
    scene_design?: boolean;
    text_position?: boolean;
    text_size?: boolean;
    text_alignment?: boolean;
    background_transform?: boolean;
    background_animation?: boolean;
    brightness?: boolean;
    background_color?: boolean;
    asset_timing_overrides?: Array<(string)>;
};

/**
 * * `create_and_manage_project` - Create And Manage Project
 * * `access_watermarks` - Access Watermarks
 * * `access_fonts` - Access Fonts
 * * `access_colour_palettes` - Access Colour Palettes
 * * `access_saved_templates_and_brand_kits` - Access Saved Templates And Brand Kits
 * * `access_move_and_resize_text` - Access Move And Resize Text
 * * `access_move_and_resize_icons` - Access Move And Resize Icons
 * * `access_move_and_resize_captions` - Access Move And Resize Captions
 */
export enum UserPermissions {
    CREATE_AND_MANAGE_PROJECT = 'create_and_manage_project',
    ACCESS_WATERMARKS = 'access_watermarks',
    ACCESS_FONTS = 'access_fonts',
    ACCESS_COLOUR_PALETTES = 'access_colour_palettes',
    ACCESS_SAVED_TEMPLATES_AND_BRAND_KITS = 'access_saved_templates_and_brand_kits',
    ACCESS_MOVE_AND_RESIZE_TEXT = 'access_move_and_resize_text',
    ACCESS_MOVE_AND_RESIZE_ICONS = 'access_move_and_resize_icons',
    ACCESS_MOVE_AND_RESIZE_CAPTIONS = 'access_move_and_resize_captions'
}

export type UserProfile = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    readonly has_email_auth: boolean;
    is_staff: boolean;
    photo_url: (string) | null;
    role: RoleEnum;
    two_factor_activated: (boolean) | null;
    readonly projects: Array<(number)>;
    permissions: Array<UserPermissions>;
    readonly workspaces: Array<(number)>;
};

export type UserProfileRequest = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    is_staff: boolean;
    photo_url?: (string) | null;
    role?: RoleEnum;
    two_factor_activated?: (boolean) | null;
    permissions: Array<UserPermissions>;
};

export type UserVideoCount = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    video_count: number;
};

export type UserVideoHistory = {
    name: string;
    template_id: string;
    blueprint_name: string;
    narrative_thread: NarrativeThreadEnum;
    aspect_ratio: AspectRatio;
    article_title: string;
    duration_seconds: number;
    script: string;
};

export type UuidsByQuery = {
    query: string;
    uuids: Array<(string)>;
};

export type UuidsByQueryRequest = {
    query: string;
    uuids: Array<(string)>;
};

export type ValidateDatasetVideoResponse = {
    is_valid: boolean;
    error_message: (string) | null;
};

export type ValidateTwoFactorAuthenticationRequest = {
    one_time_password: string;
};

export type Video = {
    name: string;
    video_data: {
        [key: string]: unknown;
    };
    readonly page_url: string;
    readonly id: number;
    archived: boolean;
    user_overrides: unknown;
    article: Article;
    document: Document;
    creation_duration: (number) | null;
    media_tab_duration: (number) | null;
    music_tab_duration: (number) | null;
    style_tab_duration: (number) | null;
    format_tab_duration: (number) | null;
    voiceover_tab_duration: (number) | null;
    original_content_tab_duration: (number) | null;
    transcripts: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    visibility: VideoVisibility;
    readonly user_id: number;
    readonly project: (number) | null;
    /**
     * String containing all the text in the video used for search
     */
    script: string;
    template_id: string;
    brand_kit_id: (number) | null;
    blueprint_id: (number) | null;
    readonly video_approval_status: ((VideoApprovalStatusEnum) | null);
    creation_source: ((CreationSourceEnum) | null);
    edit_parent_language: (string) | null;
    readonly script_composer_page: (string) | null;
    script_composer_data: ((ScriptComposerData) | null);
    video_init_type: (string) | null;
    /**
     * The auto-detected language of the video
     */
    language: string;
    readonly video_data_hash: string;
    aspect_ratio: AspectRatio;
    narrative_threads: Array<NarrativeThreadEnum> | null;
    async_generation_id: (string) | null;
    async_generation_data: unknown;
    /**
     * List of tags for categorizing and filtering videos
     */
    tags: Array<(string)>;
};

export type VideoApprovalStatus = {
    video: number;
    assigner: number;
    assignee: (number) | null;
    status: ((VideoApprovalStatusEnum) | null);
};

/**
 * * `in_progress` - In Progress
 * * `needs_review` - Needs Review
 * * `approved` - Approved
 */
export enum VideoApprovalStatusEnum {
    IN_PROGRESS = 'in_progress',
    NEEDS_REVIEW = 'needs_review',
    APPROVED = 'approved'
}

export type VideoApprovalStatusRequest = {
    video: number;
    assigner?: number;
    assignee: (number) | null;
    status?: ((VideoApprovalStatusEnum) | null);
};

export type VideoAsset = {
    id: (number) | null;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: (string) | null;
    license: LicenseEnum;
    attribution: (string) | null;
    is_editorial: (boolean) | null;
    width: (number) | null;
    height: (number) | null;
    suitability_score: (number) | null;
    thumbnail_url: string;
    preview_url: string;
    render_url: (string) | null;
    poster_url: string;
    audio_url: (string) | null;
    duration: number;
    has_audio: (boolean) | null;
    has_voiceover: (boolean) | null;
    start_time: (number) | null;
    stop_time: (number) | null;
    volume: number;
};

export type VideoAssetModel = {
    readonly id: number;
    uuid: (string) | null;
    source: SourceEnum;
    source_id: string;
    license: LicenseEnum;
    attribution: (string) | null;
    is_editorial: (boolean) | null;
    width: number;
    height: number;
    suitability_score: (number) | null;
    thumbnail_url: string;
    preview_url: string;
    render_url: (string) | null;
    poster_url: string;
    audio_url: (string) | null;
    duration: number;
    has_audio: (boolean) | null;
    has_voiceover: (boolean) | null;
    description: (string) | null;
    tags: Array<(string)>;
    title: (string) | null;
    display_credit_text: (string) | null;
    display_credit_url: (string) | null;
    captions: ((Transcription) | null);
};

export type VideoAssetModelRequest = {
    uuid?: (string) | null;
    source: SourceEnum;
    source_id: string;
    license: LicenseEnum;
    attribution?: (string) | null;
    is_editorial?: (boolean) | null;
    width?: number;
    height?: number;
    suitability_score?: (number) | null;
    thumbnail_url: string;
    preview_url: string;
    render_url?: (string) | null;
    poster_url: string;
    audio_url?: (string) | null;
    duration?: number;
    has_audio?: (boolean) | null;
    has_voiceover?: (boolean) | null;
    description?: (string) | null;
    tags: Array<(string)>;
    title?: (string) | null;
    display_credit_text?: (string) | null;
    display_credit_url?: (string) | null;
    captions?: ((TranscriptionRequest) | null);
};

export type VideoComment = {
    readonly id: number;
    user: CommentablePersonProfile;
    video: number;
    message: {
        [key: string]: unknown;
    };
    readonly created_at: string;
    readonly last_updated: string;
    resolved_at: (string) | null;
    deleted_at: (string) | null;
    slide_id: (string) | null;
    readonly element_id: (string) | null;
    readonly user_photo_url: string;
    external_user_name: (string) | null;
    external_user_email: (string) | null;
};

export type VideoCommentsCreateRequest = {
    video_id: number;
    slide_id?: (string) | null;
    message: unknown;
    external_user_name?: string;
    external_user_email?: string;
};

export type VideoDetailRequest = {
    video_data: {
        [key: string]: unknown;
    };
    user_overrides: {
        [key: string]: UserOverridesItemRequest;
    } | null;
    transcripts: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    script?: string;
    user_uploads: Array<(string)>;
    template_id: string;
    aspect_ratio: AspectRatio;
    brand_kit_id: (number) | null;
    blueprint_id?: (number) | null;
    video_data_hash: string;
    video_updated_by_user: boolean;
    video_init_type: string;
    script_composer_data: ((ScriptComposerDataRequest) | null);
    article_original_content: {
        [key: string]: unknown;
    } | null;
    tab_durations: {
        [key: string]: unknown;
    } | null;
    render: boolean;
    ai_vo_seconds?: (number) | null;
    narrative_threads?: Array<NarrativeThreadEnum> | null;
    async_generation_id: (string) | null;
    async_generation_data: {
        [key: string]: unknown;
    } | null;
    is_force_save?: boolean;
    duration_seconds?: (number) | null;
    scene_count?: (number) | null;
    creation_source?: ((CreationSourceEnum) | null);
};

export type VideoDownloadResponse = {
    status: string;
    video_status: VideoStatus;
    url: (string) | null;
    task_id: (string) | null;
    error: ((ErrorEnum) | null);
    usage_sources: Array<(string)> | null;
};

export type VideoEstimate = {
    estimated_status: EstimatedStatusEnum;
    estimated_time_remaining: number;
};

/**
 * * `fal-ai/veo3.1/fast` - Veo3 1 Fast
 * * `fal-ai/veo3.1` - Veo3 1
 * * `fal-ai/wan/v2.2-a14b/text-to-video/turbo` - Wan 2 2 Turbo
 * * `fal-ai/sora-2/text-to-video/pro` - Sora 2 Pro
 * * `fal-ai/sora-2/text-to-video` - Sora 2
 * * `fal-ai/veo3.1/image-to-video` - Veo3 1 Image To Video
 * * `fal-ai/veo3.1/fast/image-to-video` - Veo3 1 Fast Image To Video
 * * `fal-ai/veo3.1/fast/first-last-frame-to-video` - Veo3 1 Fast First Last Frame
 * * `fal-ai/veo3.1/reference-to-video` - Veo3 1 Reference To Video
 * * `fal-ai/wan/v2.2-a14b/image-to-video/turbo` - Wan 2 2 Turbo
 * * `fal-ai/kling-video/o1/reference-to-video` - Kling O1 Reference
 * * `fal-ai/sora-2/image-to-video/pro` - Sora 2 Pro
 * * `fal-ai/sora-2/image-to-video` - Sora 2
 */
export enum VideoGenerationRequestModelEnum {
    FAL_AI_VEO3_1_FAST = 'fal-ai/veo3.1/fast',
    FAL_AI_VEO3_1 = 'fal-ai/veo3.1',
    FAL_AI_WAN_V2_2_A14B_TEXT_TO_VIDEO_TURBO = 'fal-ai/wan/v2.2-a14b/text-to-video/turbo',
    FAL_AI_SORA_2_TEXT_TO_VIDEO_PRO = 'fal-ai/sora-2/text-to-video/pro',
    FAL_AI_SORA_2_TEXT_TO_VIDEO = 'fal-ai/sora-2/text-to-video',
    FAL_AI_VEO3_1_IMAGE_TO_VIDEO = 'fal-ai/veo3.1/image-to-video',
    FAL_AI_VEO3_1_FAST_IMAGE_TO_VIDEO = 'fal-ai/veo3.1/fast/image-to-video',
    FAL_AI_VEO3_1_FAST_FIRST_LAST_FRAME_TO_VIDEO = 'fal-ai/veo3.1/fast/first-last-frame-to-video',
    FAL_AI_VEO3_1_REFERENCE_TO_VIDEO = 'fal-ai/veo3.1/reference-to-video',
    FAL_AI_WAN_V2_2_A14B_IMAGE_TO_VIDEO_TURBO = 'fal-ai/wan/v2.2-a14b/image-to-video/turbo',
    FAL_AI_KLING_VIDEO_O1_REFERENCE_TO_VIDEO = 'fal-ai/kling-video/o1/reference-to-video',
    FAL_AI_SORA_2_IMAGE_TO_VIDEO_PRO = 'fal-ai/sora-2/image-to-video/pro',
    FAL_AI_SORA_2_IMAGE_TO_VIDEO = 'fal-ai/sora-2/image-to-video'
}

export type VideoGenerationRequest = {
    prompt: string;
    negative_prompt?: string;
    asset_uuids?: Array<(string)>;
    last_frame_asset_uuid?: (string) | null;
    model: VideoGenerationRequestModelEnum;
    aspect_ratio: string;
    duration: number;
    usage_source?: ((UsageSourceEnum) | null);
};

export type VideoNameSuggestionRequest = {
    storyboard_text: string;
    source_article_text?: string;
};

export type VideoNameSuggestionResponse = {
    video_name: string;
};

export type VideoPlan = {
    id: string;
    title: string;
    content_prompt: (string) | null;
    video_prompt: (string) | null;
    script: (string) | null;
    aspect_ratio: AspectRatio;
    template_id: string;
    narrative_thread: NarrativeThreadEnum;
    blueprint_id: (number) | null;
    duration_target_seconds: (number) | null;
    ai_voice: (string) | null;
    ai_avatar: (number) | null;
};

export type VideoPlanRequest = {
    id?: string;
    title: string;
    content_prompt?: (string) | null;
    video_prompt?: (string) | null;
    script?: (string) | null;
    aspect_ratio: AspectRatio;
    template_id: string;
    narrative_thread: NarrativeThreadEnum;
    blueprint_id?: (number) | null;
    duration_target_seconds?: (number) | null;
    ai_voice?: (string) | null;
    ai_avatar?: (number) | null;
};

export type VideoPosterValidationRequest = {
    bucket: string;
    file_name: string;
    video_id: number;
};

export type VideoRender = {
    series_index: number;
    https_url: string;
    placeholder_image_url: string;
    status: ((VideoRenderStatusEnum) | null);
};

export type VideoRenderData = {
    video_data: {
        [key: string]: unknown;
    };
    video_id: number;
    user_id: number;
    user_email: string;
    user_name: string;
    capabilities: Capabilities;
};

export type VideoRenderDetailsResponse = {
    estimated_status: EstimatedStatusEnum;
    estimated_time_remaining: number;
    video_status: VideoStatus;
};

/**
 * * `created` - Created
 * * `submitted` - Submitted
 * * `preparing` - Preparing
 * * `segmented` - Segmented
 * * `rendering` - Rendering
 * * `assembling` - Assembling
 * * `finished` - Finished
 * * `failed` - Failed
 */
export enum VideoRenderStatusEnum {
    CREATED = 'created',
    SUBMITTED = 'submitted',
    PREPARING = 'preparing',
    SEGMENTED = 'segmented',
    RENDERING = 'rendering',
    ASSEMBLING = 'assembling',
    FINISHED = 'finished',
    FAILED = 'failed'
}

/**
 * * `draft` - Draft
 * * `queued` - Queued
 * * `processing` - Processing
 * * `failed` - Failed
 * * `published` - Published
 */
export enum VideoStatus {
    DRAFT = 'draft',
    QUEUED = 'queued',
    PROCESSING = 'processing',
    FAILED = 'failed',
    PUBLISHED = 'published'
}

/**
 * * `pending` - pending
 * * `completed` - completed
 * * `failed` - failed
 */
export enum VideoStatusEnum {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export type VideoTextAssetsTranslationRequest = {
    language: LanguageLocalesEnum;
    text_assets: Array<TextAssetsRequest>;
    context?: string;
};

export type VideoTextAssetsTranslationResponse = {
    translations: Array<TextAssetTranslation>;
    comments: Array<SlideTranslatedText>;
};

export type VideoVersion = {
    generation: number;
    created_at: string;
};

export type VideoVersionDataResponse = {
    video_data: unknown;
};

export type VideoVersionListResponse = {
    versions: Array<VideoVersion>;
};

/**
 * Request to restore a video from a specific version generation.
 */
export type VideoVersionRestoreRequest = {
    generation: number;
};

/**
 * * `unlisted` - Unlisted
 * * `private` - Private
 */
export enum VideoVisibility {
    UNLISTED = 'unlisted',
    PRIVATE = 'private'
}

export type VoiceoverAssetResponse = {
    audio_asset: AudioAssetModel;
    transcript: Array<TranscriptWord>;
    language: ((LanguageEnum) | null);
};

export type WebSocketMessage = AsyncOperationMessage | TaskResultMessage;

export type Workspace = {
    readonly id: number;
    name: string;
    readonly updated_date: string;
    editors_require_approval_to_publish: boolean;
    default_visibility: VideoVisibility;
    slug: string;
    readonly projects: Array<(number)>;
    enable_editor_advanced_settings: (boolean) | null;
    public_template_visibility: PublicTemplateVisibilityEnum;
    readonly feed_secret: (string) | null;
    ai_context_enabled: (boolean) | null;
    media_guidance: (string) | null;
};

export type WorkspaceAddMembersRequest = {
    user_ids?: Array<(number)>;
};

export type WorkspaceAnalyticsResponse = {
    avg_creation_duration: (number) | null;
    total_videos: number;
    user_video_counts: Array<UserVideoCount>;
    credits_used: number;
    credits_remaining: number;
    user_ai_credit_counts: Array<UserAICreditCount>;
};

/**
 * * `off` - Off
 * * `folders` - Folders
 * * `all` - All
 */
export enum WorkspaceMediaModeEnum {
    OFF = 'off',
    FOLDERS = 'folders',
    ALL = 'all'
}

export type WorkspaceRequest = {
    name?: string;
    editors_require_approval_to_publish?: boolean;
    default_visibility?: VideoVisibility;
    slug?: string;
    enable_editor_advanced_settings?: (boolean) | null;
    public_template_visibility?: PublicTemplateVisibilityEnum;
    ai_context_enabled?: (boolean) | null;
    media_guidance?: (string) | null;
};

export type WorkspaceVideoTags = {
    readonly tags: Array<(string)>;
};

export type ZipVideoRendersResponse = {
    zip_url: string;
};

export enum AllowedDocUploadTypes {
    _PDF = '.pdf',
    _DOCX = '.docx',
    _PPTX = '.pptx',
    _XML = '.xml'
}

export enum DurationTargetSeconds {
    TWENTY_S = 20,
    THIRTY_S = 30,
    FORTY_S = 40,
    FIFTY_S = 50,
    SIXTY_S = 60,
    SEVENTY_FIVE_S = 75,
    NINETY_S = 90,
    ONE_HUNDRED_FIVE_S = 105,
    ONE_HUNDRED_TWENTY_S = 120,
    ONE_HUNDRED_THIRTY_FIVE_S = 135,
    ONE_HUNDRED_FIFTY_S = 150,
    ONE_HUNDRED_SIXTY_FIVE_S = 165,
    ONE_HUNDRED_EIGHTY_S = 180,
    TWO_HUNDREN_TEN_S = 210,
    TWO_HUNDRED_FORTY_S = 240,
    TWO_HUNDRED_SEVENTY_S = 270,
    THREE_HUNDRED_S = 300
}

export enum DurationTargetDefaults {
    MIN = 20,
    MAX = 300,
    DEFAULT = 60
}

export enum AssetMinDimensions {
    MIN_USER_UPLOAD_PIXELS = 1,
    MIN_ARTICLE_PIXELS = 360,
    MIN_LIBRARY_PIXELS = 480,
    MIN_TENOR_PIXELS = 100
}

export enum AssetMaxDimensions {
    MAX_PIXELS = 9000
}

export enum UploadFileSizeRequirements {
    MIN_BYTES = 1,
    MAX_BYTES = 2097152000
}

export enum UploadFileSizeRequirementsPretty {
    MIN_BYTES = '1 byte',
    MAX_BYTES = '2 GB'
}

export enum BackgroundVideoDurationSeconds {
    MIN = 1,
    MAX = 3600
}

export enum AudioDurationSeconds {
    MIN = 1,
    MAX = 600
}

export enum MaxVideoDurationSeconds {
    WARNING = 480,
    LIMIT = 600
}

export enum MaxScenes {
    WARNING = 120,
    LIMIT = 150
}

export enum MaxSubscenesPerScene {
    LIMIT = 60
}

export enum VideoTitleParams {
    MAX_LENGTH = 150
}

export enum VideoTitleDefaults {
    DEFAULT_TITLE = 'Untitled video'
}

export enum VideoSortBy {
    LAST_UPDATED_DATE = 'last_updated_date',
    CREATION_DATE = 'creation_date',
    NAME = 'name'
}

export enum DatasetWorkspace {
    ID = 1810470,
    CONTRACTOR_ID = 3863931
}

export enum RecommendationDefaults {
    SUBSCENE_TOKEN = '||'
}

export enum GenerativeMediaErrorCodes {
    NSFW = 'nsfw',
    USER_CANCELLED = 'user_cancelled',
    MODEL_NOT_FOUND = 'model_not_found',
    NO_MEDIA_GENERATED = 'no_media_generated'
}

export enum GlobalTemplate {
    GLOBAL_TEMPLATE_ID = 'global_template'
}

export enum WebSocketKeepAliveMessage {
    PING = 'PING',
    PONG = 'PONG'
}

export enum WebSocketCloseCode {
    NORMAL = 1000,
    DISCONNECT_EVENT = 4000,
    WINDOW_CLOSED = 4001
}

export enum Urls {
    HOME = '/',
    ENTERPRISE = '/enterprise/',
    PRICING = '/pricing/',
    SPECIAL_PRICING = '/special-pricing/',
    ABOUT = '/about/',
    UPDATES = '/updates/',
    CAREERS = '/careers/',
    CAREER_LISTINGS = '/careers/listings/',
    CAREER_OPPORTUNITY = '/careers/opportunity/',
    TERMS = '/terms/',
    TERMS_VIDEOBLOCKS = '/terms-videoblocks/',
    TERMS_GETTY = '/terms-getty/',
    TERMS_SHUTTERSTOCK = '/terms-shutterstock/',
    PRIVACY = '/privacy/',
    APP = '/app/',
    CLIP_CREATOR = '/app/clip-creator/',
    DASHBOARD = '/dashboard/',
    ANALYTICS = '/dashboard/analytics/',
    BRAND_KITS = '/dashboard/brand-kits/',
    BLUEPRINTS_PAGE = '/dashboard/blueprints/',
    ANIMATED_EXPLAINER_VIDEOS = '/animated-explainer-videos/',
    RSS_FEEDS = '/dashboard/rss-feeds/',
    RSS_MANAGE = '/dashboard/rss-manage/',
    SKETCH = '/dashboard/sketch/',
    ACCOUNT = '/dashboard/account/',
    VIDEO_SETTINGS = '/dashboard/video-settings/',
    PRIVACY_SETTINGS = '/dashboard/privacy-settings/',
    AUDIT_LOG = '/dashboard/audit-log/',
    WORKSPACE_SETTINGS = '/dashboard/workspaces/',
    TEAM_MANAGEMENT = '/dashboard/team/',
    BILLING_SETTINGS = '/dashboard/billing/',
    ACCOUNT_CANCEL = '/dashboard/account/cancel/',
    LOGIN = '/auth/login/',
    SIGNUP = '/auth/signup/',
    LOGOUT = '/auth/logout/',
    SSO_VERIFICATION = '/auth/sso-verification/',
    CONFIRM_EMAIL = '/auth/confirm-email/',
    SSO_AUTH = '/login/saml/',
    FACEBOOK_AUTH = '/login/facebook/',
    GOOGLE_AUTH = '/login/google-oauth2/',
    SOCIAL_AUTH = '/login/backend/',
    EMAIL_AUTH_COMPLETE = '/complete/email/',
    SOCIAL_AUTH_COMPLETE = '/complete/backend/',
    FORGOT_PASSWORD = '/auth/forgot/',
    ADD_EMAIL = '/auth/addemail/',
    RECOMMENDATION_ARTIFACT = '/recommendation-artifact/1/',
    WEBSOCKET_CONNECT = '/ws/',
    FEATURE_FLAGS_CHANGELIST = '/admin/web/featureflag/'
}

export enum PublicBlueprintUseCase {
    SKETCH = 'sketch',
    SPINOFF = 'spinoff',
    CLIP_CREATOR = 'clip_creator'
}

export enum SketchAgentToolNames {
    URL_FETCH = 'url_fetch',
    RESEARCH = 'research',
    WEB_IMAGE_SEARCH = 'web_image_search',
    USER_INSPIRATION_PLANNING = 'user_inspiration_planning'
}

export type ApiTokenAuthCreateData = {
    body: AuthTokenRequest;
};

export type ApiTokenAuthCreateResponse = (AuthToken);

export type ApiTokenAuthCreateError = unknown;

export type ActiveAiAvatarVoicePresetListResponse = (Array<AIAvatarVoicePreset>);

export type ActiveAiAvatarVoicePresetListError = unknown;

export type ActiveAiAvatarVoicePresetRetrieveData = {
    path: {
        /**
         * Primary key of the object to retrieve
         */
        id: number;
    };
};

export type ActiveAiAvatarVoicePresetRetrieveResponse = (AIAvatarVoicePreset);

export type ActiveAiAvatarVoicePresetRetrieveError = unknown;

export type AdminMediaFoldersListData = {
    path: {
        workspace_id: string;
    };
};

export type AdminMediaFoldersListResponse = (Array<AdminMediaFolder>);

export type AdminMediaFoldersListError = unknown;

export type AdminWorkspacesListData = {
    path: {
        team_id: string;
    };
};

export type AdminWorkspacesListResponse = (Array<AdminWorkspace>);

export type AdminWorkspacesListError = unknown;

export type AiAvatarListResponse = (Array<AIAvatar>);

export type AiAvatarListError = unknown;

export type AiAvatarRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this ai avatar.
         */
        id: number;
    };
};

export type AiAvatarRetrieveResponse = (AIAvatar);

export type AiAvatarRetrieveError = unknown;

export type AiMediaModelsListResponse = (Array<GenerativeMediaModels>);

export type AiMediaModelsListError = unknown;

export type AiVoiceListResponse = (Array<AIVoice>);

export type AiVoiceListError = unknown;

export type AiVoiceFilterListData = {
    query?: {
        /**
         * Include accent filters
         */
        accent?: boolean;
        /**
         * Include age filters
         */
        age?: boolean;
        /**
         * Include gender filters
         */
        gender?: boolean;
        /**
         * Include language filters
         */
        language?: boolean;
        /**
         * Include quality filters
         */
        quality?: boolean;
        /**
         * Include style filters
         */
        style?: boolean;
        /**
         * Include tone filters
         */
        tone?: boolean;
    };
};

export type AiVoiceFilterListResponse = (Array<AIVoiceFilter>);

export type AiVoiceFilterListError = unknown;

export type AiVoiceFilterRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this ai voice filter.
         */
        id: number;
    };
};

export type AiVoiceFilterRetrieveResponse = (AIVoiceFilter);

export type AiVoiceFilterRetrieveError = unknown;

export type AiVoiceV2ListData = {
    query?: {
        /**
         * Filter by accent attribute value
         */
        accent?: string;
        /**
         * Filter by age attribute value
         */
        age?: string;
        /**
         * Filter by gender attribute value
         */
        gender?: string;
        /**
         * Filter by language attribute value
         */
        language?: Array<(string)>;
        /**
         * A page number within the paginated result set.
         */
        page?: number;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by quality attribute value
         */
        quality?: string;
        /**
         * Search voices by display name
         */
        search?: string;
        /**
         * Filter by style attribute value
         */
        style?: string;
        /**
         * Filter by tone attribute value
         */
        tone?: string;
    };
};

export type AiVoiceV2ListResponse = (PaginatedAIVoiceList);

export type AiVoiceV2ListError = unknown;

export type AiVoiceV2RetrieveData = {
    path: {
        id: number;
    };
};

export type AiVoiceV2RetrieveResponse = (AIVoice);

export type AiVoiceV2RetrieveError = unknown;

export type AiVoiceV2BySlugRetrieveData = {
    path: {
        slug: string;
    };
};

export type AiVoiceV2BySlugRetrieveResponse = (AIVoice);

export type AiVoiceV2BySlugRetrieveError = unknown;

export type AiVoiceRetrieveData = {
    path: {
        id: number;
    };
};

export type AiVoiceRetrieveResponse = (AIVoice);

export type AiVoiceRetrieveError = unknown;

export type AnnouncementsListData = {
    query?: {
        /**
         * Only return unread announcements
         */
        unread_only?: boolean;
        /**
         * Current page URL for targeting
         */
        url?: string;
    };
};

export type AnnouncementsListResponse = (Array<Announcement>);

export type AnnouncementsListError = unknown;

export type AnnouncementsMarkClickedCreateData = {
    body: AnnouncementClickRequest;
};

export type AnnouncementsMarkClickedCreateResponse = (SuccessResponse);

export type AnnouncementsMarkClickedCreateError = unknown;

export type AnnouncementsMarkViewedCreateData = {
    body: AnnouncementViewRequest;
};

export type AnnouncementsMarkViewedCreateResponse = (SuccessResponse);

export type AnnouncementsMarkViewedCreateError = unknown;

export type AnnouncementsPublicListResponse = (Array<Announcement>);

export type AnnouncementsPublicListError = unknown;

export type AnnouncementsUnreadCountRetrieveResponse = (UnreadCount);

export type AnnouncementsUnreadCountRetrieveError = unknown;

export type ArticleImagesListData = {
    path: {
        article_pk: number;
    };
};

export type ArticleImagesListResponse = (Array<ImageAsset>);

export type ArticleImagesListError = unknown;

export type ArticleImagesDestroyData = {
    path: {
        article_pk: number;
        id: number;
    };
};

export type ArticleImagesDestroyResponse = (void);

export type ArticleImagesDestroyError = unknown;

export type ArticleImagesDeleteAllDestroyData = {
    path: {
        article_pk: number;
    };
};

export type ArticleImagesDeleteAllDestroyResponse = (void);

export type ArticleImagesDeleteAllDestroyError = unknown;

export type ArticleRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this article.
         */
        id: number;
    };
};

export type ArticleRetrieveResponse = (Article);

export type ArticleRetrieveError = unknown;

export type ArticleUpdateData = {
    path: {
        /**
         * A unique integer value identifying this article.
         */
        id: number;
    };
};

export type ArticleUpdateResponse = (Article);

export type ArticleUpdateError = unknown;

export type ArticlePartialUpdateData = {
    body?: PatchedArticleUpdateContentRequest;
    path: {
        /**
         * A unique integer value identifying this article.
         */
        id: number;
    };
};

export type ArticlePartialUpdateResponse = (Article);

export type ArticlePartialUpdateError = unknown;

export type ArticleReplaceUrlUpdateData = {
    body: ArticleUpdateUrlRequest;
    path: {
        /**
         * A unique integer value identifying this article.
         */
        id: number;
    };
};

export type ArticleReplaceUrlUpdateResponse = (QueuedTaskResult);

export type ArticleReplaceUrlUpdateError = unknown;

export type AssetAudioEnhancementRetrieveData = {
    query: {
        asset_source_id: string;
        asset_type: string;
        target_asset_source: number;
    };
};

export type AssetAudioEnhancementRetrieveResponse = (AssetAudioEnhancementResponse);

export type AssetAudioEnhancementRetrieveError = unknown;

export type AssetDeletionGcsDestroyData = {
    query: {
        urls: string;
    };
};

export type AssetDeletionGcsDestroyResponse = (void);

export type AssetDeletionGcsDestroyError = unknown;

export type AssetSaveCreateData = {
    body: AssetSaveRequest;
};

export type AssetSaveCreateResponse = (AssetSave);

export type AssetSaveCreateError = unknown;

export type AssetTranscriptRetrieveData = {
    path: {
        asset_id: string;
    };
    query: {
        asset_type: 'audio' | 'video';
    };
};

export type AssetTranscriptRetrieveResponse = (AssetTranscript);

export type AssetTranscriptRetrieveError = unknown;

export type AssetValidationUpdateData = {
    body: AssetValidationRequest;
};

export type AssetValidationUpdateResponse = (unknown);

export type AssetValidationUpdateError = unknown;

export type AsyncOperationResultRetrieveData = {
    path: {
        async_operation_uuid: string;
    };
    query?: {
        success_step?: string;
    };
};

export type AsyncOperationResultRetrieveResponse = (AsyncOperationResult);

export type AsyncOperationResultRetrieveError = unknown;

export type AsyncOperationsListData = {
    query?: {
        asset_uuid?: string;
        async_operation_uuid?: string;
        end_datetime?: string;
        /**
         * A page number within the paginated result set.
         */
        page?: number;
        start_datetime?: string;
        user_email?: string;
        video_id?: number;
    };
};

export type AsyncOperationsListResponse = (PaginatedAsyncOperationList);

export type AsyncOperationsListError = unknown;

export type AudioRetrieveData = {
    query: {
        autocorrect: boolean;
        count: number;
        did_you_mean: boolean;
        duration_max?: number;
        duration_min?: number;
        filter_by_user_level: boolean;
        page: number;
        q: string;
        search_source: 'cc' | 'favorites' | 'recent' | 'uploads' | 'voiceover_uploads';
        sources_filter?: Array<(22)>;
    };
};

export type AudioRetrieveResponse = (AudioAssetResponse);

export type AudioRetrieveError = unknown;

export type AudioDestroyData = {
    query: {
        id: number;
    };
};

export type AudioDestroyResponse = (void);

export type AudioDestroyError = unknown;

export type AudioassetRetrieveData = {
    path: {
        uuid: string;
    };
};

export type AudioassetRetrieveResponse = (AudioAssetModel);

export type AudioassetRetrieveError = unknown;

export type AuditLogListData = {
    query?: {
        /**
         * A page number within the paginated result set.
         */
        page?: number;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
    };
};

export type AuditLogListResponse = (PaginatedAuditLogList);

export type AuditLogListError = unknown;

export type AuditLogExportCsvCreateResponse = (QueuedTaskResult);

export type AuditLogExportCsvCreateError = unknown;

export type BackgroundAssetsDestroyData = {
    query: {
        id: number;
        type: string;
    };
};

export type BackgroundAssetsDestroyResponse = (void);

export type BackgroundAssetsDestroyError = unknown;

export type BackgroundRemovalCreateData = {
    body: MediaBackgroundRemovalRequest;
};

export type BackgroundRemovalCreateResponse = (QueuedTaskResult);

export type BackgroundRemovalCreateError = unknown;

export type BatchTextToVoiceoverCreateData = {
    body: BatchTextToVoiceoverRequest;
};

export type BatchTextToVoiceoverCreateResponse = (QueuedTaskResult);

export type BatchTextToVoiceoverCreateError = unknown;

export type BillingChargesListResponse = (Array<Charge>);

export type BillingChargesListError = unknown;

export type BillingPreferencesRetrieveResponse = (BillingPreferences);

export type BillingPreferencesRetrieveError = unknown;

export type BillingPreferencesUpdateData = {
    body?: BillingPreferencesRequest;
};

export type BillingPreferencesUpdateResponse = (BillingPreferences);

export type BillingPreferencesUpdateError = unknown;

export type BillingSubscribersListResponse = (Array<ReceiptSubscriber>);

export type BillingSubscribersListError = unknown;

export type BillingSubscribersCreateData = {
    body: ReceiptSubscriberRequest;
};

export type BillingSubscribersCreateResponse = (ReceiptSubscriber);

export type BillingSubscribersCreateError = unknown;

export type BillingSubscribersDestroyData = {
    path: {
        id: number;
    };
};

export type BillingSubscribersDestroyResponse = (void);

export type BillingSubscribersDestroyError = unknown;

export type BlueprintAutoPickCreateData = {
    body: BlueprintAutoPickRequest;
};

export type BlueprintAutoPickCreateResponse = (QueuedTaskResult);

export type BlueprintAutoPickCreateError = unknown;

export type BlueprintsListData = {
    query?: {
        ids?: string;
        max_results?: number;
        narrative_thread?: string;
        template?: string;
        /**
         * Filter public blueprints by use case (not supported for custom blueprints)
         */
        use_case?: string;
    };
};

export type BlueprintsListResponse = (Array<Blueprint>);

export type BlueprintsListError = unknown;

export type BlueprintsRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type BlueprintsRetrieveResponse = (Blueprint);

export type BlueprintsRetrieveError = unknown;

export type BlueprintsTemplateStyleVideoDataRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
    query?: {
        template?: string;
    };
};

export type BlueprintsTemplateStyleVideoDataRetrieveResponse = (TemplateStyleVideoData);

export type BlueprintsTemplateStyleVideoDataRetrieveError = unknown;

export type BlueprintsVideoDataRetrieveData = {
    query: {
        /**
         * Comma-separated list of blueprint IDs
         */
        ids: string;
    };
};

export type BlueprintsVideoDataRetrieveResponse = ({
    [key: string]: unknown;
});

export type BlueprintsVideoDataRetrieveError = unknown;

export type BrandKitsListResponse = (Array<BrandKit>);

export type BrandKitsListError = unknown;

export type BrandKitsCreateData = {
    body: BrandKitRequest;
};

export type BrandKitsCreateResponse = (BrandKit);

export type BrandKitsCreateError = unknown;

export type BrandKitsRetrieveData = {
    path: {
        id: number;
    };
};

export type BrandKitsRetrieveResponse = (BrandKit);

export type BrandKitsRetrieveError = unknown;

export type BrandKitsUpdateData = {
    body: BrandKitRequest;
    path: {
        id: number;
    };
};

export type BrandKitsUpdateResponse = (BrandKit);

export type BrandKitsUpdateError = unknown;

export type BrandKitsDestroyData = {
    path: {
        id: number;
    };
};

export type BrandKitsDestroyResponse = (void);

export type BrandKitsDestroyError = unknown;

export type BulkAssetSourceCreateData = {
    body: BulkAssetSourceRequest;
};

export type BulkAssetSourceCreateResponse = (Array<AssetContainerModel>);

export type BulkAssetSourceCreateError = unknown;

export type BulkMediaAssetsListData = {
    query?: {
        uuids?: string;
    };
};

export type BulkMediaAssetsListResponse = (Array<AssetContainerModel>);

export type BulkMediaAssetsListError = unknown;

export type BulkTextSegmentationCreateData = {
    body: BulkTextSegmentationRequest;
};

export type BulkTextSegmentationCreateResponse = (BulkTextSegmentationResponse);

export type BulkTextSegmentationCreateError = unknown;

export type BulkUploadUrlsCreateData = {
    body: BulkUploadUrlsRequest;
};

export type BulkUploadUrlsCreateResponse = (BulkUploadUrlsResponse);

export type BulkUploadUrlsCreateError = unknown;

export type ChangePasswordCreateData = {
    body: ChangePasswordRequest;
};

export type ChangePasswordCreateResponse = (ChangePasswordResponse);

export type ChangePasswordCreateError = unknown;

export type ChangeWorkspaceUpdateData = {
    path: {
        workspace_id: string;
    };
};

export type ChangeWorkspaceUpdateResponse = (void);

export type ChangeWorkspaceUpdateError = unknown;

export type ChartStylesListResponse = (Array<AssetContainerModel>);

export type ChartStylesListError = unknown;

export type ClicklogsclickCreateData = {
    body: ClickLogsClickRequest;
};

export type ClicklogsclickCreateResponse = (ClickLogsClick);

export type ClicklogsclickCreateError = unknown;

export type ClicklogsqueryCreateData = {
    body: ClickLogsQueryRequest;
};

export type ClicklogsqueryCreateResponse = (ClickLogsQuery);

export type ClicklogsqueryCreateError = unknown;

export type ClicklogsrecommendationCreateData = {
    body: ClickLogsRecommendationRequest;
};

export type ClicklogsrecommendationCreateResponse = (ClickLogsRecommendation);

export type ClicklogsrecommendationCreateError = unknown;

export type ClipPlannerCreateData = {
    body: ClipPlannerRequest;
};

export type ClipPlannerCreateResponse = (QueuedTaskResult);

export type ClipPlannerCreateError = unknown;

export type ColorFilterListData = {
    query?: {
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
};

export type ColorFilterListResponse = (Array<ColorGradingFilter>);

export type ColorFilterListError = unknown;

export type SaveConversationData = {
    body: SaveConversationRequest;
};

export type SaveConversationResponse = (unknown);

export type SaveConversationError = unknown;

export type GetConversationData = {
    path: {
        /**
         * A UUID string identifying this conversation.
         */
        id: string;
    };
};

export type GetConversationResponse = (ConversationDetail);

export type GetConversationError = unknown;

export type CopyMediaAssetsCreateData = {
    body: CopyMediaAssetsRequest;
};

export type CopyMediaAssetsCreateResponse = (CopyMediaAssetsResult);

export type CopyMediaAssetsCreateError = unknown;

export type CustomBlueprintsListData = {
    query?: {
        ids?: string;
        max_results?: number;
        narrative_thread?: string;
        template?: string;
        /**
         * Filter public blueprints by use case (not supported for custom blueprints)
         */
        use_case?: string;
    };
};

export type CustomBlueprintsListResponse = (Array<Blueprint>);

export type CustomBlueprintsListError = unknown;

export type CustomBlueprintsCreateData = {
    body: BlueprintRequest;
};

export type CustomBlueprintsCreateResponse = (Blueprint);

export type CustomBlueprintsCreateError = unknown;

export type CustomBlueprintsRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type CustomBlueprintsRetrieveResponse = (Blueprint);

export type CustomBlueprintsRetrieveError = unknown;

export type CustomBlueprintsPartialUpdateData = {
    body?: PatchedBlueprintRequest;
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type CustomBlueprintsPartialUpdateResponse = (Blueprint);

export type CustomBlueprintsPartialUpdateError = unknown;

export type CustomBlueprintsDestroyData = {
    path: {
        id: number;
    };
};

export type CustomBlueprintsDestroyResponse = (void);

export type CustomBlueprintsDestroyError = unknown;

export type CustomBlueprintsDuplicateCreateData = {
    body?: DuplicateBlueprintRequest;
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type CustomBlueprintsDuplicateCreateResponse = (Array<Blueprint>);

export type CustomBlueprintsDuplicateCreateError = unknown;

export type CustomBlueprintsCreateFromSimilarCreateData = {
    body: CreateBlueprintFromSimilarRequest;
};

export type CustomBlueprintsCreateFromSimilarCreateResponse = (Blueprint);

export type CustomBlueprintsCreateFromSimilarCreateError = unknown;

export type CustomBlueprintsCreateFromSuggestedBlueprintCreateData = {
    body: CreateBlueprintFromSuggestedBlueprintRequest;
};

export type CustomBlueprintsCreateFromSuggestedBlueprintCreateResponse = (Blueprint);

export type CustomBlueprintsCreateFromSuggestedBlueprintCreateError = unknown;

export type DamSearchCreateData = {
    body: DAMSearchRequest;
};

export type DamSearchCreateResponse = (MediaSearchResponse);

export type DamSearchCreateError = unknown;

export type DatasetMetadataRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this video.
         */
        id: number;
    };
};

export type DatasetMetadataRetrieveResponse = (DatasetMetadata);

export type DatasetMetadataRetrieveError = unknown;

export type DatasetMetadataUpdateData = {
    body?: DatasetMetadataRequest;
    path: {
        /**
         * A unique integer value identifying this video.
         */
        id: number;
    };
};

export type DatasetMetadataUpdateResponse = (DatasetMetadata);

export type DatasetMetadataUpdateError = unknown;

export type DatasetMetadataPartialUpdateData = {
    body?: PatchedDatasetMetadataRequest;
    path: {
        /**
         * A unique integer value identifying this video.
         */
        id: number;
    };
};

export type DatasetMetadataPartialUpdateResponse = (DatasetMetadata);

export type DatasetMetadataPartialUpdateError = unknown;

export type DocumentResetUpdateData = {
    body: ResetDocumentRequest;
};

export type DocumentResetUpdateResponse = (ResetDocument);

export type DocumentResetUpdateError = unknown;

export type DocumentsCreateData = {
    body: DocumentsRequest;
};

export type DocumentsCreateResponse = (QueuedTaskResult);

export type DocumentsCreateError = unknown;

export type DocumentsImagesListData = {
    path: {
        documents_pk: number;
    };
};

export type DocumentsImagesListResponse = (Array<SlideBackgroundModel>);

export type DocumentsImagesListError = unknown;

export type DocumentsImagesDestroyData = {
    path: {
        documents_pk: number;
        id: number;
    };
};

export type DocumentsImagesDestroyResponse = (void);

export type DocumentsImagesDestroyError = unknown;

export type DocumentsImagesDeleteAllDestroyData = {
    path: {
        documents_pk: number;
    };
};

export type DocumentsImagesDeleteAllDestroyResponse = (void);

export type DocumentsImagesDeleteAllDestroyError = unknown;

export type DocumentsUpdateData = {
    body: DocumentsRequest;
    path: {
        /**
         * A unique integer value identifying this document.
         */
        id: number;
    };
};

export type DocumentsUpdateResponse = (QueuedTaskResult);

export type DocumentsUpdateError = unknown;

export type DocumentsPartialUpdateData = {
    body?: PatchedDocumentsRequest;
    path: {
        /**
         * A unique integer value identifying this document.
         */
        id: number;
    };
};

export type DocumentsPartialUpdateResponse = (DocumentsRequest);

export type DocumentsPartialUpdateError = unknown;

export type EditVoiceoverUpdateData = {
    body: EditVoiceoverRequest;
};

export type EditVoiceoverUpdateResponse = (AsyncOperationResponse);

export type EditVoiceoverUpdateError = unknown;

export type EmailExistsCreateData = {
    body: EmailExistenceRequest;
};

export type EmailExistsCreateResponse = (EmailExistenceResponse);

export type EmailExistsCreateError = unknown;

export type FaceDetectionCreateData = {
    body: FaceDetectionRequest;
};

export type FaceDetectionCreateResponse = (QueuedTaskResult);

export type FaceDetectionCreateError = unknown;

export type FavoritesListMarkedFavoritesListData = {
    query?: {
        search_audio?: boolean;
    };
};

export type FavoritesListMarkedFavoritesListResponse = (Array<FavoritedAsset>);

export type FavoritesListMarkedFavoritesListError = unknown;

export type FavoritesMarkFavoriteCreateData = {
    body: ToggleFavoritedAssetRequest;
};

export type FavoritesMarkFavoriteCreateResponse = (ToggleFavoritedAsset);

export type FavoritesMarkFavoriteCreateError = unknown;

export type FavoritesUnmarkFavoriteDestroyResponse = (void);

export type FavoritesUnmarkFavoriteDestroyError = unknown;

export type FeedbackBetaCreateData = {
    body: BetaFeedbackRequest;
};

export type FeedbackBetaCreateResponse = (void);

export type FeedbackBetaCreateError = unknown;

export type FetchArticleImageRetrieveData = {
    query?: {
        url?: string;
    };
};

export type FetchArticleImageRetrieveResponse = (string);

export type FetchArticleImageRetrieveError = unknown;

export type FlagEnrollRetrieveData = {
    path: {
        id: string;
    };
};

export type FlagEnrollRetrieveResponse = (string);

export type FlagEnrollRetrieveError = unknown;

export type FlagWithdrawRetrieveData = {
    path: {
        id: string;
    };
};

export type FlagWithdrawRetrieveResponse = (string);

export type FlagWithdrawRetrieveError = unknown;

export type FlagListAllListResponse = (Array<FeatureFlag>);

export type FlagListAllListError = unknown;

export type FontAssetsListResponse = (Array<FontAsset>);

export type FontAssetsListError = unknown;

export type FontAssetsDestroyData = {
    path: {
        id: number;
    };
};

export type FontAssetsDestroyResponse = (void);

export type FontAssetsDestroyError = unknown;

export type GenerateChartConfigCreateData = {
    body: GenerateChartConfigRequest;
};

export type GenerateChartConfigCreateResponse = (GenerateChartConfigResponse);

export type GenerateChartConfigCreateError = unknown;

export type GenerateMediaCandidatesCreateData = {
    body: QueuedTaskResultRequest;
    path: {
        video_id: number;
    };
    query?: {
        /**
         * Force generation of media candidates even if they already exist
         */
        force?: boolean;
    };
};

export type GenerateMediaCandidatesCreateResponse = (QueuedTaskResult);

export type GenerateMediaCandidatesCreateError = unknown;

export type GenerateScriptCreateData = {
    body: GenerateScriptRequest;
};

export type GenerateScriptCreateResponse = (QueuedTaskResult);

export type GenerateScriptCreateError = unknown;

export type GenerateScriptFromPromptCreateData = {
    body: GenerateScriptFromPromptRequest;
};

export type GenerateScriptFromPromptCreateResponse = (QueuedTaskResult);

export type GenerateScriptFromPromptCreateError = unknown;

export type GenerateVideoRecommendationCreateData = {
    body: GenerateRecommendedVideoRequest;
};

export type GenerateVideoRecommendationCreateResponse = (QueuedTaskResult);

export type GenerateVideoRecommendationCreateError = unknown;

export type GenerateVideosForVideoPlansCreateData = {
    body: GenerateVideosForVideoPlansRequest;
};

export type GenerateVideosForVideoPlansCreateResponse = (QueuedTaskResults);

export type GenerateVideosForVideoPlansCreateError = unknown;

export type GenxEvalsEvalRunsListData = {
    query?: {
        evalSet?: string;
        imageModel?: string;
        preset?: string;
        status?: string;
        videoModel?: string;
    };
};

export type GenxEvalsEvalRunsListResponse = (Array<EvalRunList>);

export type GenxEvalsEvalRunsListError = unknown;

export type GenxEvalsEvalRunsCreateData = {
    body: EvalRunCreateRequest;
};

export type GenxEvalsEvalRunsCreateResponse = (EvalRunList);

export type GenxEvalsEvalRunsCreateError = unknown;

export type GenxEvalsEvalRunsRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this Eval Run.
         */
        id: number;
    };
};

export type GenxEvalsEvalRunsRetrieveResponse = (EvalRunDetail);

export type GenxEvalsEvalRunsRetrieveError = unknown;

export type GenxEvalsEvalRunsPartialUpdateData = {
    body?: PatchedEvalRunUpdateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Run.
         */
        id: number;
    };
};

export type GenxEvalsEvalRunsPartialUpdateResponse = (EvalRunList);

export type GenxEvalsEvalRunsPartialUpdateError = unknown;

export type GenxEvalsEvalRunsScriptsCreateData = {
    body: EvalRunScriptCreateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Run.
         */
        id: number;
    };
};

export type GenxEvalsEvalRunsScriptsCreateResponse = (EvalRunScript);

export type GenxEvalsEvalRunsScriptsCreateError = unknown;

export type GenxEvalsEvalSetsListResponse = (Array<EvalSetList>);

export type GenxEvalsEvalSetsListError = unknown;

export type GenxEvalsEvalSetsCreateData = {
    body: EvalSetCreateRequest;
};

export type GenxEvalsEvalSetsCreateResponse = (EvalSetDetail);

export type GenxEvalsEvalSetsCreateError = unknown;

export type GenxEvalsEvalSetsRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this Eval Set.
         */
        id: number;
    };
};

export type GenxEvalsEvalSetsRetrieveResponse = (EvalSetDetail);

export type GenxEvalsEvalSetsRetrieveError = unknown;

export type GenxEvalsEvalSetsUpdateData = {
    body: EvalSetCreateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Set.
         */
        id: number;
    };
};

export type GenxEvalsEvalSetsUpdateResponse = (EvalSetDetail);

export type GenxEvalsEvalSetsUpdateError = unknown;

export type GenxEvalsEvalSetsPartialUpdateData = {
    body?: PatchedEvalSetCreateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Set.
         */
        id: number;
    };
};

export type GenxEvalsEvalSetsPartialUpdateResponse = (EvalSetDetail);

export type GenxEvalsEvalSetsPartialUpdateError = unknown;

export type GenxEvalsEvalSetsDestroyData = {
    path: {
        /**
         * A unique integer value identifying this Eval Set.
         */
        id: number;
    };
};

export type GenxEvalsEvalSetsDestroyResponse = (void);

export type GenxEvalsEvalSetsDestroyError = unknown;

export type GenxEvalsEvalSetsScriptsCreateData = {
    body: EvalScriptCreateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Set.
         */
        id: number;
    };
};

export type GenxEvalsEvalSetsScriptsCreateResponse = (EvalScript);

export type GenxEvalsEvalSetsScriptsCreateError = unknown;

export type GenxEvalsGradesCreateData = {
    body: EvalGradeCreateRequest;
};

export type GenxEvalsGradesCreateResponse = (EvalGrade);

export type GenxEvalsGradesCreateError = unknown;

export type GenxEvalsGradesPartialUpdateData = {
    body?: PatchedEvalGradeCreateRequest;
    path: {
        id: string;
    };
};

export type GenxEvalsGradesPartialUpdateResponse = (EvalGrade);

export type GenxEvalsGradesPartialUpdateError = unknown;

export type GenxEvalsGradesDestroyData = {
    path: {
        id: string;
    };
};

export type GenxEvalsGradesDestroyResponse = (void);

export type GenxEvalsGradesDestroyError = unknown;

export type GenxEvalsPresetsListResponse = (Array<GradingPreset>);

export type GenxEvalsPresetsListError = unknown;

export type GenxEvalsPresetsScoreHistoryListData = {
    path: {
        slug: string;
    };
};

export type GenxEvalsPresetsScoreHistoryListResponse = (Array<ScoreHistory>);

export type GenxEvalsPresetsScoreHistoryListError = unknown;

export type GenxEvalsScriptsPartialUpdateData = {
    body?: PatchedEvalScriptCreateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Script.
         */
        id: number;
    };
};

export type GenxEvalsScriptsPartialUpdateResponse = (EvalScript);

export type GenxEvalsScriptsPartialUpdateError = unknown;

export type GenxEvalsScriptsDestroyData = {
    path: {
        /**
         * A unique integer value identifying this Eval Script.
         */
        id: number;
    };
};

export type GenxEvalsScriptsDestroyResponse = (void);

export type GenxEvalsScriptsDestroyError = unknown;

export type GenxEvalsShotsPartialUpdateData = {
    body?: PatchedEvalRunShotUpdateRequest;
    path: {
        /**
         * A unique integer value identifying this Eval Run Shot.
         */
        id: number;
    };
};

export type GenxEvalsShotsPartialUpdateResponse = (EvalRunShot);

export type GenxEvalsShotsPartialUpdateError = unknown;

export type GenxPresetBuilderScenariosListResponse = (Array<GenXPresetBuilderScenario>);

export type GenxPresetBuilderScenariosListError = unknown;

export type GenxPresetBuilderScenariosCreateData = {
    body: GenXPresetBuilderScenarioRequest;
};

export type GenxPresetBuilderScenariosCreateResponse = (GenXPresetBuilderScenario);

export type GenxPresetBuilderScenariosCreateError = unknown;

export type GenxPresetBuilderScenariosUpdateData = {
    body: GenXPresetBuilderScenarioRequest;
    path: {
        /**
         * A unique integer value identifying this GEN-X Preset Builder Scenario.
         */
        id: number;
    };
};

export type GenxPresetBuilderScenariosUpdateResponse = (GenXPresetBuilderScenario);

export type GenxPresetBuilderScenariosUpdateError = unknown;

export type GenxPresetBuilderScenariosPartialUpdateData = {
    body?: PatchedGenXPresetBuilderScenarioRequest;
    path: {
        /**
         * A unique integer value identifying this GEN-X Preset Builder Scenario.
         */
        id: number;
    };
};

export type GenxPresetBuilderScenariosPartialUpdateResponse = (GenXPresetBuilderScenario);

export type GenxPresetBuilderScenariosPartialUpdateError = unknown;

export type GenxPresetBuilderScenariosDestroyData = {
    path: {
        /**
         * A unique integer value identifying this GEN-X Preset Builder Scenario.
         */
        id: number;
    };
};

export type GenxPresetBuilderScenariosDestroyResponse = (void);

export type GenxPresetBuilderScenariosDestroyError = unknown;

export type GenxStylePresetsListData = {
    query?: {
        all?: string;
        include_drafts?: string;
        include_public?: string;
    };
};

export type GenxStylePresetsListResponse = (Array<GenXStylePreset>);

export type GenxStylePresetsListError = unknown;

export type GenxStylePresetsCreateCreateData = {
    body: GenXStylePresetCreateRequest;
};

export type GenxStylePresetsCreateCreateResponse = (GenXStylePresetCreate);

export type GenxStylePresetsCreateCreateError = unknown;

export type GetLanguageInfoForTextCreateData = {
    body: LanguageInfoForTextRequest;
};

export type GetLanguageInfoForTextCreateResponse = (LanguageInfoForTextResponse);

export type GetLanguageInfoForTextCreateError = unknown;

export type ImageGenerationCreateData = {
    body: UnifiedImageGenerationRequest;
};

export type ImageGenerationCreateResponse = (QueuedTaskResultWithAiMediaCredits);

export type ImageGenerationCreateError = unknown;

export type InspirationCreateResponse = (QueuedTaskResult);

export type InspirationCreateError = unknown;

export type IsAuthenticatedRetrieveResponse = (unknown);

export type IsAuthenticatedRetrieveError = unknown;

export type LogMediaAgentResultsCreateData = {
    body: LogMediaAgentResultsRequest;
};

export type LogMediaAgentResultsCreateResponse = (void);

export type LogMediaAgentResultsCreateError = unknown;

export type LongestSupportedDurationTargetsCreateData = {
    body: LongestSupportedDurationTargetsRequest;
};

export type LongestSupportedDurationTargetsCreateResponse = (LongestSupportedDurationTargetsResponse);

export type LongestSupportedDurationTargetsCreateError = unknown;

export type MediaAssetTextRepresentationRetrieveData = {
    path: {
        media_asset_uuid: string;
    };
};

export type MediaAssetTextRepresentationRetrieveResponse = (MediaAssetTextRepresentationResponse);

export type MediaAssetTextRepresentationRetrieveError = unknown;

export type MediaConceptPreviewCreateData = {
    body: MediaConceptPreviewRequest;
};

export type MediaConceptPreviewCreateResponse = (QueuedTaskResult);

export type MediaConceptPreviewCreateError = unknown;

export type MediaFoldersListResponse = (Array<MediaFolder>);

export type MediaFoldersListError = unknown;

export type MediaFoldersCreateData = {
    body?: MediaFolderRequest;
};

export type MediaFoldersCreateResponse = (MediaFolder);

export type MediaFoldersCreateError = unknown;

export type MediaFoldersRetrieveData = {
    path: {
        id: number;
    };
};

export type MediaFoldersRetrieveResponse = (MediaFolder);

export type MediaFoldersRetrieveError = unknown;

export type MediaFoldersPartialUpdateData = {
    body?: PatchedMediaFolderRequest;
    path: {
        id: number;
    };
};

export type MediaFoldersPartialUpdateResponse = (MediaFolder);

export type MediaFoldersPartialUpdateError = unknown;

export type MediaFoldersDestroyData = {
    path: {
        id: number;
    };
};

export type MediaFoldersDestroyResponse = (void);

export type MediaFoldersDestroyError = unknown;

export type MediaSearchCreateData = {
    body?: MediaSearchRequest;
};

export type MediaSearchCreateResponse = (MediaSearchResponse);

export type MediaSearchCreateError = unknown;

export type MergeTeamsCreateData = {
    body: MergeTeamsRequest;
};

export type MergeTeamsCreateResponse = (MergeTeamsStatsResponse | void);

export type MergeTeamsCreateError = unknown;

export type MixyCreateData = {
    body: MixpanelProxyRequest;
};

export type MixyCreateResponse = (unknown);

export type MixyCreateError = unknown;

export type MusicRecommendationCreateData = {
    body: MusicRecommendationRequest;
};

export type MusicRecommendationCreateResponse = (QueuedTaskResult);

export type MusicRecommendationCreateError = unknown;

export type MuteAudioCreateData = {
    body: MuteAudioRequest;
};

export type MuteAudioCreateResponse = (MuteAudioResponse);

export type MuteAudioCreateError = unknown;

export type NameSuggestionCreateData = {
    body: VideoNameSuggestionRequest;
};

export type NameSuggestionCreateResponse = (QueuedTaskResult);

export type NameSuggestionCreateError = unknown;

export type NotificationsListResponse = (Array<Notification>);

export type NotificationsListError = unknown;

export type NotificationsMarkAsReadPartialUpdateData = {
    path: {
        id: number;
    };
};

export type NotificationsMarkAsReadPartialUpdateResponse = (unknown);

export type NotificationsMarkAsReadPartialUpdateError = unknown;

export type NotificationsMarkAllAsReadPartialUpdateResponse = (unknown);

export type NotificationsMarkAllAsReadPartialUpdateError = unknown;

export type NotificationsNumUnreadRetrieveResponse = (NotificationsNumUnread);

export type NotificationsNumUnreadRetrieveError = unknown;

export type PasswordForgotCreateData = {
    body: ForgotPasswordSubmissionRequest;
};

export type PasswordForgotCreateResponse = (SimpleMessageResponse);

export type PasswordForgotCreateError = unknown;

export type PasswordResetCreateData = {
    body: PasswordResetRedemptionRequest;
};

export type PasswordResetCreateResponse = (PasswordResetRedemptionResponse);

export type PasswordResetCreateError = unknown;

export type PrefetchMediaCandidatesCreateData = {
    body: PrefetchMediaCandidatesRequest;
};

export type PrefetchMediaCandidatesCreateResponse = (QueuedTaskResult);

export type PrefetchMediaCandidatesCreateError = unknown;

export type PremiumMediaCreditCheckCreateData = {
    body: PremiumMediaCreditCheckRequest;
};

export type PremiumMediaCreditCheckCreateResponse = (PremiumMediaCreditCheckResponse);

export type PremiumMediaCreditCheckCreateError = unknown;

export type PricingCancellationFeedbackCreateData = {
    body?: CancellationFeedbackRequest;
};

export type PricingCancellationFeedbackCreateResponse = (CancellationFeedback);

export type PricingCancellationFeedbackCreateError = unknown;

export type PricingCreditCardDetailsRetrieveResponse = (CreditCardDetails);

export type PricingCreditCardDetailsRetrieveError = unknown;

export type PricingCurrentPlanNameRetrieveResponse = (CurrentPlanName);

export type PricingCurrentPlanNameRetrieveError = unknown;

export type PricingPaymentMethodCheckoutUpdateData = {
    body?: PaymentMethodCheckoutSessionRequest;
};

export type PricingPaymentMethodCheckoutUpdateResponse = (PaymentMethodCheckoutSessionResponse);

export type PricingPaymentMethodCheckoutUpdateError = unknown;

export type PricingPaymentMethodStatusRetrieveResponse = (PaymentMethodStatus);

export type PricingPaymentMethodStatusRetrieveError = unknown;

export type PricingPlansRetrieveData = {
    query?: {
        /**
         * Coupon code to apply to the plans
         */
        coupon?: string;
    };
};

export type PricingPlansRetrieveResponse = (PricingPlans);

export type PricingPlansRetrieveError = unknown;

export type PricingPremiumMediaRetrieveResponse = (PremiumMedia);

export type PricingPremiumMediaRetrieveError = unknown;

export type PricingRenewSubscriptionCreateResponse = (unknown);

export type PricingRenewSubscriptionCreateError = unknown;

export type PricingSubscriptionRetrieveResponse = (Subscription);

export type PricingSubscriptionRetrieveError = unknown;

export type PricingSubscriptionCreateData = {
    body: SubscriptionUpdateRequest;
};

export type PricingSubscriptionCreateResponse = (SubscriptionCreationResponse);

export type PricingSubscriptionCreateError = unknown;

export type PricingSubscriptionPartialUpdateData = {
    body?: PatchedSubscriptionUpdateRequest;
};

export type PricingSubscriptionPartialUpdateResponse = (SubscriptionUpdateResponse);

export type PricingSubscriptionPartialUpdateError = unknown;

export type PricingSubscriptionPauseCreateData = {
    body?: PauseSubscriptionRequest;
};

export type PricingSubscriptionPauseCreateResponse = (PauseSubscriptionResponse);

export type PricingSubscriptionPauseCreateError = unknown;

export type PricingSubscriptionResumeCreateResponse = (ResumeSubscriptionResponse);

export type PricingSubscriptionResumeCreateError = unknown;

export type ProjectsListResponse = (Array<Project>);

export type ProjectsListError = unknown;

export type ProjectsCreateData = {
    body?: ProjectRequest;
};

export type ProjectsCreateResponse = (Project);

export type ProjectsCreateError = unknown;

export type ProjectsRetrieveData = {
    path: {
        id: number;
    };
};

export type ProjectsRetrieveResponse = (Project);

export type ProjectsRetrieveError = unknown;

export type ProjectsPartialUpdateData = {
    body?: PatchedProjectRequest;
    path: {
        id: number;
    };
};

export type ProjectsPartialUpdateResponse = (Project);

export type ProjectsPartialUpdateError = unknown;

export type ProjectsDestroyData = {
    path: {
        id: number;
    };
};

export type ProjectsDestroyResponse = (void);

export type ProjectsDestroyError = unknown;

export type ProjectsBulkUpdateMembersCreateData = {
    body: BulkUpdateProjectMembersRequest;
};

export type ProjectsBulkUpdateMembersCreateResponse = (Array<Project>);

export type ProjectsBulkUpdateMembersCreateError = unknown;

export type PronunciationListResponse = (Array<Pronunciation>);

export type PronunciationListError = unknown;

export type PronunciationUpsertData = {
    body: PronunciationRequest;
};

export type PronunciationUpsertResponse = (Pronunciation);

export type PronunciationUpsertError = unknown;

export type PronunciationDestroyData = {
    path: {
        id: string;
    };
};

export type PronunciationDestroyResponse = (void);

export type PronunciationDestroyError = unknown;

export type PublicBlueprintsListData = {
    query?: {
        ids?: string;
        max_results?: number;
        narrative_thread?: string;
        template?: string;
        /**
         * Filter public blueprints by use case (not supported for custom blueprints)
         */
        use_case?: string;
    };
};

export type PublicBlueprintsListResponse = (Array<PublicBlueprint>);

export type PublicBlueprintsListError = unknown;

export type PublicBlueprintsCreateData = {
    body: PublicBlueprintRequest;
};

export type PublicBlueprintsCreateResponse = (PublicBlueprint);

export type PublicBlueprintsCreateError = unknown;

export type PublicBlueprintsRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type PublicBlueprintsRetrieveResponse = (PublicBlueprint);

export type PublicBlueprintsRetrieveError = unknown;

export type PublicBlueprintsPartialUpdateData = {
    body?: PatchedPublicBlueprintRequest;
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type PublicBlueprintsPartialUpdateResponse = (PublicBlueprint);

export type PublicBlueprintsPartialUpdateError = unknown;

export type PublicBlueprintsDestroyData = {
    path: {
        /**
         * A unique integer value identifying this blueprint.
         */
        id: number;
    };
};

export type PublicBlueprintsDestroyResponse = (void);

export type PublicBlueprintsDestroyError = unknown;

export type PublicVideoRetrieveData = {
    path: {
        slug: string;
    };
};

export type PublicVideoRetrieveResponse = (PublicVideo);

export type PublicVideoRetrieveError = unknown;

export type QueueEstimatedRenderDurationRetrieveResponse = (EstimatedRenderDurationResponse);

export type QueueEstimatedRenderDurationRetrieveError = unknown;

export type QueueVideoRenderDetailsRetrieveData = {
    path: {
        video_id: string;
    };
};

export type QueueVideoRenderDetailsRetrieveResponse = (VideoRenderDetailsResponse);

export type QueueVideoRenderDetailsRetrieveError = unknown;

export type RecentlyUsedTemplatesListResponse = (Array<RecentTemplates>);

export type RecentlyUsedTemplatesListError = unknown;

export type RegenerateTranscriptForAssetCreateData = {
    body: RegenerateTranscriptForAssetRequest;
};

export type RegenerateTranscriptForAssetCreateResponse = (QueuedTaskResult);

export type RegenerateTranscriptForAssetCreateError = unknown;

export type RegenerateMfaBackupKeysCreateResponse = (BackupCodes);

export type RegenerateMfaBackupKeysCreateError = unknown;

export type ResolveCommentsCreateData = {
    body: ResolveReopenCommentsRequest;
};

export type ResolveCommentsCreateResponse = (Array<VideoComment>);

export type ResolveCommentsCreateError = unknown;

export type RssFeedsListData = {
    query?: {
        active?: boolean;
    };
};

export type RssFeedsListResponse = (Array<RssFeed>);

export type RssFeedsListError = unknown;

export type RssFeedsCreateData = {
    body: RssFeedRequest;
};

export type RssFeedsCreateResponse = (RssFeed);

export type RssFeedsCreateError = unknown;

export type RssFeedsUpdateData = {
    body: RssFeedRequest;
    path: {
        feed_id: string;
    };
};

export type RssFeedsUpdateResponse = (RssFeed);

export type RssFeedsUpdateError = unknown;

export type RssFeedsEntriesListData = {
    path: {
        feed_id: string;
    };
};

export type RssFeedsEntriesListResponse = (Array<RssFeedEntry>);

export type RssFeedsEntriesListError = unknown;

export type SaveVideoDataSnapshotCreateData = {
    body: SaveVideoDataSnapshotRequest;
};

export type SaveVideoDataSnapshotCreateResponse = (SaveVideoDataSnapshotResponse);

export type SaveVideoDataSnapshotCreateError = unknown;

export type SceneAttributesListData = {
    query: {
        aspect_ratio: string;
        auto_crop?: boolean;
        comma_separated_asset_uuids?: string;
        narrative_thread?: 'talking_head' | 'text' | 'voiceover';
        recommend_brightness?: boolean;
        template_id: string;
    };
};

export type SceneAttributesListResponse = (Array<SceneAttributesResponse>);

export type SceneAttributesListError = unknown;

export type SceneDesignsListData = {
    query: {
        template_id: string;
    };
};

export type SceneDesignsListResponse = (Array<SceneDesign>);

export type SceneDesignsListError = unknown;

export type SceneDesignsCreateData = {
    body: SceneDesignRequest;
};

export type SceneDesignsCreateResponse = (SceneDesign);

export type SceneDesignsCreateError = unknown;

export type SceneDesignsRetrieveData = {
    path: {
        /**
         * A unique value identifying this scene design.
         */
        id: string;
    };
};

export type SceneDesignsRetrieveResponse = (SceneDesign);

export type SceneDesignsRetrieveError = unknown;

export type SceneDesignsUpdateData = {
    body: SceneDesignRequest;
    path: {
        /**
         * A unique value identifying this scene design.
         */
        id: string;
    };
};

export type SceneDesignsUpdateResponse = (SceneDesign);

export type SceneDesignsUpdateError = unknown;

export type SceneDesignsPartialUpdateData = {
    body?: PatchedSceneDesignRequest;
    path: {
        /**
         * A unique value identifying this scene design.
         */
        id: string;
    };
};

export type SceneDesignsPartialUpdateResponse = (SceneDesign);

export type SceneDesignsPartialUpdateError = unknown;

export type SceneDesignsDestroyData = {
    path: {
        /**
         * A unique value identifying this scene design.
         */
        id: string;
    };
};

export type SceneDesignsDestroyResponse = (void);

export type SceneDesignsDestroyError = unknown;

export type SceneDesignsBulkUpdateUpdateData = {
    body: Array<SceneDesignRequest>;
};

export type SceneDesignsBulkUpdateUpdateResponse = (Array<SceneDesign>);

export type SceneDesignsBulkUpdateUpdateError = unknown;

export type SceneDesignsIdsPerTemplateListResponse = (Array<SceneDesignIdsPerTemplate>);

export type SceneDesignsIdsPerTemplateListError = unknown;

export type SceneDesignsTemplateAnnotationsRetrieveData = {
    query: {
        /**
         * One of: landscape, square, vertical, fourfive
         */
        aspect_ratio: string;
        /**
         * Comma-separated scene design IDs
         */
        force_included_scene_design_ids?: string;
        /**
         * Include all scenes regardless of status
         */
        include_all?: boolean;
        /**
         * Include outro scenes
         */
        include_outros?: boolean;
        /**
         * One of: text, voiceover, talking_head
         */
        narrative_thread: string;
        template_id: string;
    };
};

export type SceneDesignsTemplateAnnotationsRetrieveResponse = (TemplateAnnotations);

export type SceneDesignsTemplateAnnotationsRetrieveError = unknown;

export type ScriptOptionsCreateData = {
    body: ScriptOptionsRequest;
};

export type ScriptOptionsCreateResponse = (QueuedTaskResult);

export type ScriptOptionsCreateError = unknown;

export type SendEmailVerificationCreateData = {
    body: SendEmailVerificationRequest;
};

export type SendEmailVerificationCreateResponse = (unknown);

export type SendEmailVerificationCreateError = unknown;

export type SendMfaRecoveryCodeCreateData = {
    body: SendMfaRecoveryCodeRequest;
};

export type SendMfaRecoveryCodeCreateResponse = (unknown);

export type SendMfaRecoveryCodeCreateError = unknown;

export type SendSceneCommentMentionEmailCreateData = {
    body: SendCommentMentionsRequest;
};

export type SendSceneCommentMentionEmailCreateResponse = (unknown);

export type SendSceneCommentMentionEmailCreateError = unknown;

export type ShareGptFeedbackCreateData = {
    body: FeedbackRequest;
};

export type ShareGptFeedbackCreateResponse = (unknown);

export type ShareGptFeedbackCreateError = unknown;

export type SimpleTextCorrectionCreateData = {
    body: SimpleTextCorrectionRequest;
};

export type SimpleTextCorrectionCreateResponse = (SegmentEditedTextResponse);

export type SimpleTextCorrectionCreateError = unknown;

export type SketchContextInfoRetrieveResponse = (SketchContextResponse);

export type SketchContextInfoRetrieveError = unknown;

export type SketchResearchCreateData = {
    body: SketchResearchRequest;
};

export type SketchResearchCreateResponse = (QueuedTaskResult);

export type SketchResearchCreateError = unknown;

export type SketchUrlFetchCreateData = {
    body: SketchUrlFetchRequest;
};

export type SketchUrlFetchCreateResponse = (QueuedTaskResult);

export type SketchUrlFetchCreateError = unknown;

export type SketchValidateVideoPlansCreateData = {
    body: SketchVideoPlanValidationRequest;
};

export type SketchValidateVideoPlansCreateResponse = (SketchVideoPlanValidationResponse);

export type SketchValidateVideoPlansCreateError = unknown;

export type SketchWebImageSearchCreateData = {
    body: SketchWebImageSearchRequest;
};

export type SketchWebImageSearchCreateResponse = (QueuedTaskResult);

export type SketchWebImageSearchCreateError = unknown;

export type SoundEffectStylesListResponse = (Array<SoundEffectStyle>);

export type SoundEffectStylesListError = unknown;

export type SoundEffectsListData = {
    query?: {
        /**
         * Filter by sound effect style slug
         */
        sound_effect_style?: string;
    };
};

export type SoundEffectsListResponse = (Array<AudioAssetModel>);

export type SoundEffectsListError = unknown;

export type SsoIdpConfigCreateData = {
    body: SSOIdPConfigRequest;
};

export type SsoIdpConfigCreateResponse = (SSOIdPConfig);

export type SsoIdpConfigCreateError = unknown;

export type SsoIdpConfigRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this sso id p config.
         */
        id: number;
    };
};

export type SsoIdpConfigRetrieveResponse = (SSOIdPConfig);

export type SsoIdpConfigRetrieveError = unknown;

export type SsoIdpConfigUpdateData = {
    body: SSOIdPConfigRequest;
    path: {
        /**
         * A unique integer value identifying this sso id p config.
         */
        id: number;
    };
};

export type SsoIdpConfigUpdateResponse = (SSOIdPConfig);

export type SsoIdpConfigUpdateError = unknown;

export type SsoIdpConfigPartialUpdateData = {
    body?: PatchedSSOIdPConfigRequest;
    path: {
        /**
         * A unique integer value identifying this sso id p config.
         */
        id: number;
    };
};

export type SsoIdpConfigPartialUpdateResponse = (SSOIdPConfig);

export type SsoIdpConfigPartialUpdateError = unknown;

export type SsoIdpConfigDestroyData = {
    path: {
        /**
         * A unique integer value identifying this sso id p config.
         */
        id: number;
    };
};

export type SsoIdpConfigDestroyResponse = (void);

export type SsoIdpConfigDestroyError = unknown;

export type SsoVerficationCreateData = {
    body?: SSOVerificationRequest;
};

export type SsoVerficationCreateResponse = (SSOVerificationResponse);

export type SsoVerficationCreateError = unknown;

export type SubmitFeedbackCreateData = {
    body: SubmitFeedbackRequest;
};

export type SubmitFeedbackCreateResponse = (void);

export type SubmitFeedbackCreateError = unknown;

export type SuggestedBlueprintsListResponse = (Array<SuggestedBlueprint>);

export type SuggestedBlueprintsListError = unknown;

export type SuggestedBlueprintsRetrieveData = {
    path: {
        id: number;
    };
};

export type SuggestedBlueprintsRetrieveResponse = (SuggestedBlueprint);

export type SuggestedBlueprintsRetrieveError = unknown;

export type SuggestedMediaCreateData = {
    body: SuggestedMediaRequest;
};

export type SuggestedMediaCreateResponse = (QueuedTaskResult);

export type SuggestedMediaCreateError = unknown;

export type SupportedLanguagesListResponse = (Array<SupportedLanguages>);

export type SupportedLanguagesListError = unknown;

export type TaskResultRetrieveData = {
    path: {
        task_id: string;
    };
};

export type TaskResultRetrieveResponse = (TaskResult);

export type TaskResultRetrieveError = unknown;

export type TaskResultDestroyData = {
    path: {
        task_id: string;
    };
};

export type TaskResultDestroyResponse = (void);

export type TaskResultDestroyError = unknown;

export type TaskResultsListData = {
    query: {
        /**
         * List of comma-separated task ids to fetch results for
         */
        task_ids: string;
    };
};

export type TaskResultsListResponse = (Array<TaskResult>);

export type TaskResultsListError = unknown;

export type TeamInvitationsListResponse = (Array<TeamInvitation>);

export type TeamInvitationsListError = unknown;

export type TeamInvitationsCreateData = {
    body: TeamInvitationCreateRequest;
};

export type TeamInvitationsCreateResponse = (TeamInvitationCreateResponse);

export type TeamInvitationsCreateError = unknown;

export type TeamInvitationsRetrieveData = {
    path: {
        id: number;
    };
};

export type TeamInvitationsRetrieveResponse = (TeamInvitation);

export type TeamInvitationsRetrieveError = unknown;

export type TeamInvitationsDestroyData = {
    path: {
        id: number;
    };
};

export type TeamInvitationsDestroyResponse = (void);

export type TeamInvitationsDestroyError = unknown;

export type TeamInvitationsResendCreateData = {
    path: {
        /**
         * A unique integer value identifying this team invitation.
         */
        id: number;
    };
};

export type TeamInvitationsResendCreateResponse = (unknown);

export type TeamInvitationsResendCreateError = unknown;

export type TeamMembersListResponse = (Array<UserProfile>);

export type TeamMembersListError = unknown;

export type TeamMembersUpdateData = {
    body: UserProfileRequest;
    path: {
        id: number;
    };
};

export type TeamMembersUpdateResponse = (UserProfile);

export type TeamMembersUpdateError = unknown;

export type TeamMembersPartialUpdateData = {
    body?: PatchedUserProfileRequest;
    path: {
        id: number;
    };
};

export type TeamMembersPartialUpdateResponse = (UserProfile);

export type TeamMembersPartialUpdateError = unknown;

export type TeamMembersDestroyData = {
    path: {
        id: number;
    };
};

export type TeamMembersDestroyResponse = (void);

export type TeamMembersDestroyError = unknown;

export type TeamMembersDeleteUserAccountDestroyData = {
    path: {
        id: number;
    };
    query?: {
        editor_email?: string;
    };
};

export type TeamMembersDeleteUserAccountDestroyResponse = (DeleteUserAccountResponse);

export type TeamMembersDeleteUserAccountDestroyError = unknown;

export type TeamMembersTwoFactorAuthenticationRetrieveResponse = (TwoFactorAuthenticationResponse);

export type TeamMembersTwoFactorAuthenticationRetrieveError = unknown;

export type TeamMembersTwoFactorAuthenticationCreateData = {
    body: ValidateTwoFactorAuthenticationRequest;
};

export type TeamMembersTwoFactorAuthenticationCreateResponse = (unknown);

export type TeamMembersTwoFactorAuthenticationCreateError = unknown;

export type TeamSettingsRetrieveResponse = (TeamSettings);

export type TeamSettingsRetrieveError = unknown;

export type TeamSettingsPartialUpdateData = {
    body?: PatchedTeamSettingsRequest;
};

export type TeamSettingsPartialUpdateResponse = (TeamSettings);

export type TeamSettingsPartialUpdateError = unknown;

export type TemplateCategoriesListResponse = (Array<TemplateCategory>);

export type TemplateCategoriesListError = unknown;

export type TemplateInfoListData = {
    query?: {
        /**
         * A page number within the paginated result set.
         */
        page?: number;
    };
};

export type TemplateInfoListResponse = (PaginatedTemplateInfoResponseList);

export type TemplateInfoListError = unknown;

export type TemplatesListResponse = (Array<Template>);

export type TemplatesListError = unknown;

export type TemplatesCreateData = {
    body: TemplateRequest;
};

export type TemplatesCreateResponse = (Template);

export type TemplatesCreateError = unknown;

export type TemplatesRetrieveData = {
    path: {
        /**
         * A unique value identifying this template.
         */
        id: string;
    };
};

export type TemplatesRetrieveResponse = (Template);

export type TemplatesRetrieveError = unknown;

export type TemplatesUpdateData = {
    body: TemplateRequest;
    path: {
        /**
         * A unique value identifying this template.
         */
        id: string;
    };
};

export type TemplatesUpdateResponse = (Template);

export type TemplatesUpdateError = unknown;

export type TemplatesPartialUpdateData = {
    body?: PatchedTemplateRequest;
    path: {
        /**
         * A unique value identifying this template.
         */
        id: string;
    };
};

export type TemplatesPartialUpdateResponse = (Template);

export type TemplatesPartialUpdateError = unknown;

export type TemplatesDestroyData = {
    path: {
        /**
         * A unique value identifying this template.
         */
        id: string;
    };
};

export type TemplatesDestroyResponse = (void);

export type TemplatesDestroyError = unknown;

export type TemplatesDisplayGroupsListData = {
    path: {
        template_pk: string;
    };
};

export type TemplatesDisplayGroupsListResponse = (Array<DisplayGroup>);

export type TemplatesDisplayGroupsListError = unknown;

export type TemplatesDisplayGroupsCreateData = {
    body: DisplayGroupCreateRequest;
    path: {
        template_pk: string;
    };
};

export type TemplatesDisplayGroupsCreateResponse = (DisplayGroup);

export type TemplatesDisplayGroupsCreateError = unknown;

export type TemplatesDisplayGroupsRetrieveData = {
    path: {
        id: number;
        template_pk: string;
    };
};

export type TemplatesDisplayGroupsRetrieveResponse = (DisplayGroup);

export type TemplatesDisplayGroupsRetrieveError = unknown;

export type TemplatesDisplayGroupsPartialUpdateData = {
    body?: PatchedDisplayGroupRequest;
    path: {
        id: number;
        template_pk: string;
    };
};

export type TemplatesDisplayGroupsPartialUpdateResponse = (DisplayGroup);

export type TemplatesDisplayGroupsPartialUpdateError = unknown;

export type TemplatesDisplayGroupsOrderPartialUpdateData = {
    body: Array<DisplayGroupOrderRequest>;
    path: {
        template_pk: string;
    };
};

export type TemplatesDisplayGroupsOrderPartialUpdateResponse = (DisplayGroup);

export type TemplatesDisplayGroupsOrderPartialUpdateError = unknown;

export type TextToVoiceoverAssetCreateData = {
    body: TextToVoiceoverRequest;
};

export type TextToVoiceoverAssetCreateResponse = (AsyncOperationResponse);

export type TextToVoiceoverAssetCreateError = unknown;

export type TextTranslateCreateData = {
    body: TextTranslateRequest;
};

export type TextTranslateCreateResponse = (QueuedTaskResult);

export type TextTranslateCreateError = unknown;

export type TopUploadsTagsRetrieveData = {
    query: {
        filter: string;
        folder_id?: number;
    };
};

export type TopUploadsTagsRetrieveResponse = (TopUploadTagsResponseSerializers);

export type TopUploadsTagsRetrieveError = unknown;

export type TranscriptClipCreateData = {
    body: TranscriptClipRequest;
};

export type TranscriptClipCreateResponse = (QueuedTaskResult);

export type TranscriptClipCreateError = unknown;

export type TransitionedAssetErrorCreateData = {
    body: TransitionedAssetErrorListRequest;
};

export type TransitionedAssetErrorCreateResponse = (TransitionedAssetErrorList);

export type TransitionedAssetErrorCreateError = unknown;

export type TransmogVideoCreateData = {
    body: SwitchTemplateForVideoRequest;
};

export type TransmogVideoCreateResponse = (SwitchTemplateForVideoResponse);

export type TransmogVideoCreateError = unknown;

export type UploadUrlsCreateData = {
    body: UploadUrlsRequest;
};

export type UploadUrlsCreateResponse = (UploadUrlsResponse);

export type UploadUrlsCreateError = unknown;

export type UploadsMetadataUpdateUpdateData = {
    body: UploadsMetadataUpdateRequest;
};

export type UploadsMetadataUpdateUpdateResponse = (UploadsMetadataUpdateResponse);

export type UploadsMetadataUpdateUpdateError = unknown;

export type UsageLimitsRetrieveData = {
    query?: {
        excluded_video_id?: number;
    };
};

export type UsageLimitsRetrieveResponse = (UsageLimit);

export type UsageLimitsRetrieveError = unknown;

export type UsedTemplatesRetrieveResponse = (Array<(string)>);

export type UsedTemplatesRetrieveError = unknown;

export type UserRetrieveResponse = (UserProfile);

export type UserRetrieveError = unknown;

export type UserExtraDataCreateData = {
    body: AddExtraDataToUserRequest;
};

export type UserExtraDataCreateResponse = (unknown);

export type UserExtraDataCreateError = unknown;

export type UserHasValidProjectInWorkspaceRetrieveResponse = (HasValidProjectInWorkspaceResponse);

export type UserHasValidProjectInWorkspaceRetrieveError = unknown;

export type UserNotificationsRetrieveData = {
    path: {
        email_secret_uuid: string;
        user_id: string;
    };
};

export type UserNotificationsRetrieveResponse = (NotificationSettings);

export type UserNotificationsRetrieveError = unknown;

export type UserNotificationsPartialUpdateData = {
    body?: PatchedNotificationSettingsRequest;
    path: {
        email_secret_uuid: string;
        user_id: string;
    };
};

export type UserNotificationsPartialUpdateResponse = (NotificationSettings);

export type UserNotificationsPartialUpdateError = unknown;

export type ValidateDatasetVideoRetrieveData = {
    path: {
        video_id: number;
    };
    query: {
        validity_class: 'blueprint_oneshot' | 'blueprint_segment' | 'media_candidates' | 'transmog' | 'zero_shot' | 'zero_shot_eval';
    };
};

export type ValidateDatasetVideoRetrieveResponse = (ValidateDatasetVideoResponse);

export type ValidateDatasetVideoRetrieveError = unknown;

export type VideoListData = {
    query?: {
        /**
         * Filter videos by aspect ratio
         */
        aspect_ratio?: 'fourfive' | 'landscape' | 'square' | 'vertical';
        /**
         * Filter videos by user id
         */
        filter_by_user_id?: number;
        /**
         * Filter videos by narrative thread
         */
        narrative_thread?: 'talking_head' | 'text' | 'voiceover';
        /**
         * Filter videos by archived status
         */
        only_archived?: boolean;
        /**
         * A page number within the paginated result set.
         */
        page?: number;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter videos by project id
         */
        project_id?: number;
        /**
         * Search videos containing text
         */
        search?: string;
        /**
         * Sort videos by a field
         */
        sort_by?: 'creation_date' | 'last_updated_date' | 'name';
        /**
         * Filter videos by status
         */
        status?: 'draft' | 'failed' | 'processing' | 'published' | 'queued';
        /**
         * Filter videos by template id
         */
        template_id?: string;
    };
};

export type VideoListResponse = (PaginatedDashboardVideoList);

export type VideoListError = unknown;

export type VideoCreateData = {
    body: CreateVideoRequest;
};

export type VideoCreateResponse = (CreateVideoResponse);

export type VideoCreateError = unknown;

export type VideoApprovalStatusRetrieveData = {
    path: {
        video_id: number;
    };
};

export type VideoApprovalStatusRetrieveResponse = (VideoApprovalStatus);

export type VideoApprovalStatusRetrieveError = unknown;

export type VideoApprovalStatusUpdateData = {
    body: VideoApprovalStatusRequest;
    path: {
        video_id: number;
    };
    query?: {
        notify_assignee?: boolean;
    };
};

export type VideoApprovalStatusUpdateResponse = (VideoApprovalStatus);

export type VideoApprovalStatusUpdateError = unknown;

export type VideoApprovalStatusPartialUpdateData = {
    body?: PatchedVideoApprovalStatusRequest;
    path: {
        video_id: number;
    };
};

export type VideoApprovalStatusPartialUpdateResponse = (VideoApprovalStatus);

export type VideoApprovalStatusPartialUpdateError = unknown;

export type VideoCommentListData = {
    query: {
        /**
         * List comments on a video
         */
        video_id: number;
    };
};

export type VideoCommentListResponse = (Array<VideoComment>);

export type VideoCommentListError = unknown;

export type VideoCommentCreateData = {
    body: VideoCommentsCreateRequest;
};

export type VideoCommentCreateResponse = (VideoComment);

export type VideoCommentCreateError = unknown;

export type VideoCommentDestroyData = {
    path: {
        /**
         * A unique integer value identifying this video comment.
         */
        id: number;
    };
};

export type VideoCommentDestroyResponse = (VideoComment);

export type VideoCommentDestroyError = unknown;

export type VideoGenerationCreateData = {
    body: VideoGenerationRequest;
};

export type VideoGenerationCreateResponse = (QueuedTaskResultWithAiMediaCredits);

export type VideoGenerationCreateError = unknown;

export type VideoPosterValidationUpdateData = {
    body: VideoPosterValidationRequest;
};

export type VideoPosterValidationUpdateResponse = (unknown);

export type VideoPosterValidationUpdateError = unknown;

export type VideoUploadGenxStoryboardCreateData = {
    body?: {
        [key: string]: unknown;
    };
    path: {
        /**
         * A unique integer value identifying this video.
         */
        id: number;
    };
};

export type VideoUploadGenxStoryboardCreateResponse = (unknown);

export type VideoUploadGenxStoryboardCreateError = unknown;

export type VideoRetrieveData = {
    path: {
        video_id: string;
    };
    query?: {
        /**
         * Ensures the video is editable
         */
        require_editable_version?: boolean;
    };
};

export type VideoRetrieveResponse = (Video);

export type VideoRetrieveError = unknown;

export type VideoUpdateData = {
    body: VideoDetailRequest;
    path: {
        video_id: string;
    };
};

export type VideoUpdateResponse = (UpdateSpecificVideoResponse);

export type VideoUpdateError = unknown;

export type VideoPartialUpdateData = {
    body?: PatchedVideoRequest;
    path: {
        video_id: string;
    };
};

export type VideoPartialUpdateResponse = (Video);

export type VideoPartialUpdateError = unknown;

export type VideoGroundhogAnalysisCreateData = {
    body: GroundhogAnalysisRequest;
    path: {
        video_id: string;
    };
};

export type VideoGroundhogAnalysisCreateResponse = (QueuedTaskResult);

export type VideoGroundhogAnalysisCreateError = unknown;

export type VideoShareDownloadRetrieveData = {
    path: {
        video_id: string;
    };
};

export type VideoShareDownloadRetrieveResponse = (VideoDownloadResponse);

export type VideoShareDownloadRetrieveError = unknown;

export type VideoShareDownloadCreateData = {
    path: {
        video_id: string;
    };
};

export type VideoShareDownloadCreateResponse = (TrackVideoDownloadResponse);

export type VideoShareDownloadCreateError = unknown;

export type VideoTextAssetsTranslateCreateData = {
    body: VideoTextAssetsTranslationRequest;
    path: {
        video_id: string;
    };
};

export type VideoTextAssetsTranslateCreateResponse = (QueuedTaskResult);

export type VideoTextAssetsTranslateCreateError = unknown;

export type VideoTranslatedTextListData = {
    path: {
        video_id: string;
    };
};

export type VideoTranslatedTextListResponse = (Array<SlideTranslatedText>);

export type VideoTranslatedTextListError = unknown;

export type VideosRestoreCreateData = {
    body: VideoVersionRestoreRequest;
    path: {
        video_id: string;
    };
};

export type VideosRestoreCreateResponse = (DashboardVideo);

export type VideosRestoreCreateError = unknown;

export type VideosVersionsRetrieveData = {
    path: {
        video_id: string;
    };
};

export type VideosVersionsRetrieveResponse = (VideoVersionListResponse);

export type VideosVersionsRetrieveError = unknown;

export type VideosVersionDataRetrieveData = {
    path: {
        generation: string;
        video_id: string;
    };
};

export type VideosVersionDataRetrieveResponse = (VideoVersionDataResponse);

export type VideosVersionDataRetrieveError = unknown;

export type VideosArchiveMultipleVideosUpdateData = {
    body: ArchiveMultipleVideosRequest;
};

export type VideosArchiveMultipleVideosUpdateResponse = (ArchiveMultipleVideosResponse);

export type VideosArchiveMultipleVideosUpdateError = unknown;

export type VideosBulkPublishCreateData = {
    body: BulkPublishRequest;
};

export type VideosBulkPublishCreateResponse = (BulkPublishResponse);

export type VideosBulkPublishCreateError = unknown;

export type VideosCreateFromBlueprintCreateData = {
    body: CreateVideoFromBlueprintRequest;
};

export type VideosCreateFromBlueprintCreateResponse = (DashboardVideo);

export type VideosCreateFromBlueprintCreateError = unknown;

export type VideosDuplicateVideosCreateData = {
    body: DuplicateMultipleVideosRequest;
};

export type VideosDuplicateVideosCreateResponse = (Array<DashboardVideo>);

export type VideosDuplicateVideosCreateError = unknown;

export type VideosMoveVideosPartialUpdateData = {
    body?: PatchedMoveMultipleVideosRequest;
};

export type VideosMoveVideosPartialUpdateResponse = (unknown);

export type VideosMoveVideosPartialUpdateError = unknown;

export type WorkspaceListResponse = (Array<Workspace>);

export type WorkspaceListError = unknown;

export type WorkspaceCreateData = {
    body?: WorkspaceRequest;
};

export type WorkspaceCreateResponse = (Workspace);

export type WorkspaceCreateError = unknown;

export type WorkspaceVideoTagsRetrieveResponse = (WorkspaceVideoTags);

export type WorkspaceVideoTagsRetrieveError = unknown;

export type WorkspaceRetrieveData = {
    path: {
        id: number;
    };
};

export type WorkspaceRetrieveResponse = (Workspace);

export type WorkspaceRetrieveError = unknown;

export type WorkspacePartialUpdateData = {
    body?: PatchedWorkspaceRequest;
    path: {
        id: number;
    };
};

export type WorkspacePartialUpdateResponse = (Workspace);

export type WorkspacePartialUpdateError = unknown;

export type WorkspaceDestroyData = {
    path: {
        id: number;
    };
};

export type WorkspaceDestroyResponse = (void);

export type WorkspaceDestroyError = unknown;

export type WorkspaceAddMembersCreateData = {
    body?: WorkspaceAddMembersRequest;
    path: {
        /**
         * A unique integer value identifying this workspace.
         */
        id: number;
    };
};

export type WorkspaceAddMembersCreateResponse = (unknown);

export type WorkspaceAddMembersCreateError = unknown;

export type WorkspaceAnalyticsRetrieveData = {
    path: {
        /**
         * A unique integer value identifying this workspace.
         */
        id: number;
    };
    query?: {
        days?: number;
    };
};

export type WorkspaceAnalyticsRetrieveResponse = (WorkspaceAnalyticsResponse);

export type WorkspaceAnalyticsRetrieveError = unknown;

export type WorkspaceRemoveMemberDestroyData = {
    path: {
        /**
         * A unique integer value identifying this workspace.
         */
        id: number;
    };
    query?: {
        user_id?: number;
    };
};

export type WorkspaceRemoveMemberDestroyResponse = (void);

export type WorkspaceRemoveMemberDestroyError = unknown;

export type AuthInvitationRetrieveData = {
    query: {
        /**
         * Invitation UUID to retrieve.
         */
        uuid: string;
    };
};

export type AuthInvitationRetrieveResponse = (InvitationResponse);

export type AuthInvitationRetrieveError = unknown;

export type RenderVideoRenderDataRetrieveData = {
    path: {
        video_render_id: string;
    };
};

export type RenderVideoRenderDataRetrieveResponse = (VideoRenderData);

export type RenderVideoRenderDataRetrieveError = unknown;